(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3722],{

/***/ 67874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_PlayCircleFilled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/PlayCircleFilled.js
// This icon file is generated automatically.
var PlayCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 01-12.7-6.5V353.7a8 8 0 0112.7-6.5L656.1 506a7.9 7.9 0 010 12.9z" } }] }, "name": "play-circle", "theme": "filled" };
/* harmony default export */ var asn_PlayCircleFilled = (PlayCircleFilled);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 2 modules
var AntdIcon = __webpack_require__(84089);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/PlayCircleFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var PlayCircleFilled_PlayCircleFilled = function PlayCircleFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_PlayCircleFilled
  }));
};

PlayCircleFilled_PlayCircleFilled.displayName = 'PlayCircleFilled';
/* harmony default export */ var icons_PlayCircleFilled = (/*#__PURE__*/react.forwardRef(PlayCircleFilled_PlayCircleFilled));

/***/ }),

/***/ 15746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21584);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 71230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3873);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 16051:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/hackathon2022",
      function () {
        return __webpack_require__(64628);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, href = _param.href, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash",
        "href"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    // Add path prefix
    if (href && href.startsWith("/") && !href.startsWith("//") && !href.startsWith("/tidbcommunity")) {
        href = "/tidbcommunity" + href;
    }
    props.href = href;
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 31719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Container(_param) {
    var children = _param.children, fluid = _param.fluid, classNameInput = _param.className, rest = _objectWithoutProperties(_param, [
        "children",
        "fluid",
        "className"
    ]);
    var className = "PingCAPContainer";
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, classNameInput, (_obj = {}, _defineProperty(_obj, "".concat(className, "-fluid"), fluid), _defineProperty(_obj, "".concat(className, "-normal"), !fluid), _obj))
    }, rest, {
        children: children
    }));
};


/***/ }),

/***/ 80344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31719);

/* harmony default export */ __webpack_exports__["Z"] = (_Container__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 64628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/components/Container/index.ts
var Container = __webpack_require__(80344);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/index.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: #20222b;\n  padding-bottom: 128px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 auto;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 40px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* or 175% */\n  text-align: center;\n  color: #ffffff;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 66px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 60px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 66px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 60px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 66px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 60px;\n  overflow: hidden;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 78px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  //max-width: 960px;\n  margin-top: 48px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 78px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  //max-width: 960px;\n  margin-top: 48px;\n  width: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 80px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 70px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 96px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 16px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  text-align: center;\n  /* F3 */\n  color: #999999;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 48px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 78px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 960px;\n  width: 100%;\n  margin-top: 56px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 78px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  //max-width: 960px;\n  margin-top: 56px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 78px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  //max-width: 960px;\n  margin-top: 48px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}


var MyContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var Intro = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject1());
var IntroContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
var ThemeRace = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject3());
var ThemeRaceBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var WinnerTeam = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject5());
var WinnerTeamBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6());
var FinalistTeam = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject7());
var FinalistTeamBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8());
var CompetitionProcess = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject9());
var CompetitionProcessBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10());
var Prize = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject11());
var PrizeBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12());
var ParticipationWelfare = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject13());
var ParticipationWelfareBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14());
var Judge = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject15());
var JudgeDescription = styled_components_browser_esm/* default.div */.ZP.div(_templateObject16());
var JudgeBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject17());
var FAQ = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject18());
var FAQBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject19());
var Partner = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject20());
var PartnerBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject21());
var PastReview = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(_templateObject22());
var PastReviewBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject23());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/SectionTitle.styled.ts
function SectionTitle_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SectionTitle_styled_templateObject() {
    var data = SectionTitle_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n"
    ]);
    SectionTitle_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionTitle_styled_templateObject1() {
    var data = SectionTitle_styled_taggedTemplateLiteral([
        "\n  margin-right: 24px;\n  img,\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    SectionTitle_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionTitle_styled_templateObject2() {
    var data = SectionTitle_styled_taggedTemplateLiteral([
        "\n  //font-family: 'PingFang SC';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  /* identical to box height */\n  letter-spacing: 0.2em;\n  color: #ffffff;\n"
    ]);
    SectionTitle_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var SectionTitle_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(SectionTitle_styled_templateObject());
var iconSize = "64px";
var Icon = styled_components_browser_esm/* default.div */.ZP.div(SectionTitle_styled_templateObject1(), iconSize, iconSize);
var Text = styled_components_browser_esm/* default.div */.ZP.div(SectionTitle_styled_templateObject2());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/SectionTitle.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var SectionTitle = function(props) {
    //function SectionTitle(props: IProps) {
    var children = props.children, icon = props.icon, rest = _objectWithoutProperties(props, [
        "children",
        "icon"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle_styled_Container, _objectSpread({}, rest, {
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var hackathon2022_SectionTitle = (SectionTitle);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/title_icon_cube_orange.svg
var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTitleIconCubeOrange = function SvgTitleIconCubeOrange(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#title_icon_cube_orange_svg__a)",
    d: "M0 0h64v64H0z"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "title_icon_cube_orange_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#title_icon_cube_orange_svg__b",
    transform: "scale(.00178)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "title_icon_cube_orange_svg__b",
    width: 564,
    height: 563,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
/* harmony default export */ var title_icon_cube_orange = (SvgTitleIconCubeOrange);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/title_icon_corner_skyblue.svg
var title_icon_corner_skyblue_path, title_icon_corner_skyblue_defs;
function title_icon_corner_skyblue_extends() { title_icon_corner_skyblue_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return title_icon_corner_skyblue_extends.apply(this, arguments); }

var SvgTitleIconCornerSkyblue = function SvgTitleIconCornerSkyblue(props) {
  return /*#__PURE__*/react.createElement("svg", title_icon_corner_skyblue_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), title_icon_corner_skyblue_path || (title_icon_corner_skyblue_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#title_icon_corner_skyblue_svg__a)",
    d: "M0 0h64v64H0z"
  })), title_icon_corner_skyblue_defs || (title_icon_corner_skyblue_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "title_icon_corner_skyblue_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#title_icon_corner_skyblue_svg__b",
    transform: "scale(.00178)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "title_icon_corner_skyblue_svg__b",
    width: 563,
    height: 563,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
/* harmony default export */ var title_icon_corner_skyblue = (SvgTitleIconCornerSkyblue);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/title_icon_corner_green.svg
var title_icon_corner_green_path, title_icon_corner_green_defs;
function title_icon_corner_green_extends() { title_icon_corner_green_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return title_icon_corner_green_extends.apply(this, arguments); }

var SvgTitleIconCornerGreen = function SvgTitleIconCornerGreen(props) {
  return /*#__PURE__*/react.createElement("svg", title_icon_corner_green_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), title_icon_corner_green_path || (title_icon_corner_green_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#title_icon_corner_green_svg__a)",
    d: "M0 0h64v64H0z"
  })), title_icon_corner_green_defs || (title_icon_corner_green_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "title_icon_corner_green_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#title_icon_corner_green_svg__b",
    transform: "scale(.00178)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "title_icon_corner_green_svg__b",
    width: 563,
    height: 563,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
/* harmony default export */ var title_icon_corner_green = (SvgTitleIconCornerGreen);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/title_icon_cube_skyblue.svg
var title_icon_cube_skyblue_path, title_icon_cube_skyblue_defs;
function title_icon_cube_skyblue_extends() { title_icon_cube_skyblue_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return title_icon_cube_skyblue_extends.apply(this, arguments); }

var SvgTitleIconCubeSkyblue = function SvgTitleIconCubeSkyblue(props) {
  return /*#__PURE__*/react.createElement("svg", title_icon_cube_skyblue_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), title_icon_cube_skyblue_path || (title_icon_cube_skyblue_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#title_icon_cube_skyblue_svg__a)",
    d: "M0 0h64v64H0z"
  })), title_icon_cube_skyblue_defs || (title_icon_cube_skyblue_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "title_icon_cube_skyblue_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#title_icon_cube_skyblue_svg__b",
    transform: "scale(.00178)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "title_icon_cube_skyblue_svg__b",
    width: 564,
    height: 563,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjQAAAIzCAYAAAAXjoO7AAAACXBIWXMAACE3AAAhNwEzWJ96AAAgAElEQVR4nO3d+XebZ5338c8ty06UTY7tRM5WmzmzPPOc85zm+QcSlb1sDcMwzGGLPAz7UrMMlCWt0rC0rIFZmAMttZmZskNKYQoUqJP5A574P7BJnNixo1otVGkq+Xp+kJx4kR3Jlu7rvq77/TqH1o4l+RucKO9+fUdXYIwRAACAyxK2BwAAANgsggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAzkvaHgBA49760OUf33ao8/+kUonLks5Lmpc0sfi/E0d6JuxNBwD2BMYY2zMAaMCbv3V5xBgd37kzMXPoYGdmnZsWdTN2ztd+bEySThzpGWvrkABgCUEDOODN35oelszXFn+7/sWfd6mzM9jMQ56t/Xtp+MyLLQ8ARxE0QMS9+VvTOUmPSEaLv10b2NJs1qSq38a6ETvGVLc99x5lywMgeggaIMLe8u3pnDF6pPrezaCRWrKlacrKpwpjbm55jDQvs7jlMRP5O3onQhsMAETQAJH1lm9PH5P0s5u/RZcHTW9vRzGzN5kOa546QXPz7Rv/qL5R+9ikpInlsaPzxmj+1Et7zwsAWoigASLoLd+ePqzqhbzptYJGUumv/nJLqqMjnJk2EDR1PrbqfmdrHxur3e5G+Hzu5b3zLRkcQCwQNEDEvOWh6cMy1ZiRlgbAilAwUl9feFuaNgXNjY+tul31H7Utj5mQqV7TY6TzMpp/4M4+tjwAbiBogAh560PTh400JqMbkbJe0ASBSv/7r7ekwpjNUtAsPuJ6t6u75THS+S+9uo8tDxATBA0QEW99aLpb1WtO0vUDYHXQSNL+/cnS7u6OtkdNhIOm7seWjLN4Lc/ilqf2tpn/yuv2sOUBPEHQABHw1oenu2vfZrp97QCoHzQdHSr+r7/a0vZvOzkcNGvcziy+XX0hwuqnGKv94FjtY+dPH9vDlgdwAEEDWPa2h6e7a99mul1aLwDqB40UzpbG46C58YPr3GfcLB4zYWobnurb8994A1seIAoIGsCitz083a3qtR+3r/kHdgNBk+hQ8a/bvKWJedCsebva20UZna9NOlb72JiR9K9v3DsmAG1H0AAWve3h6RFJx9f9g72BoDGSXjTQqe3bE22blaCpf7vl9zHr3W5ctdfkMUsOFTVGE//+93snBGBTCBrAksWYkW7xB3uDQbO1K5j58z/vattxCARN/ds1ETSr3745hlTb8pjF4yaMZGTGJOlbb86MCcC6CBrAgrd/Z3rEmGrMSK0JGhnpRYPt29IQNPVv18KgqXM7s/LHx3XzXK151TY8kiYefltmQkCMETRAyN7+nenTku5u+A/2JoJmWypx4c/+rPNQy4de8fnW+vx151z2MYJmk0Gz6j4r7l80Wn7MhKrv65HjbHngN4IGCNHbv7N4cnYTf7A3ETSS9Jd/2aWuNhxaSdDUv13EgqaB25mztbeXnqI+L2niu//QPyHAUQQNEJLjjyw9Obt9QbNzZ2Jm4LbOll9LQ9DUv52DQXOrX0eTUu2YieWHiuq/3tk/JiCiCBogBMcfqW5mGgmSzQaNkfRXf9Glrq7WbmkImvq38zBobvl5jNHZ2pvnjcyN09S/9+59YwIsIWiANjv+yPRhSf9PWucPiBv/aE3Q7GrDloagqX+7mAbNkvss+9rc8X2iBpa070UrACg3Mn1Yiy+0FqJnn13YVamE/VkB5WwPgPgiaIA2WRIzbT9naSVjlJqdKxfD/ryIveN//++XB20PgXgiaIA2yI3MWIuZRXNzlS62NLAgb3sAxBNBA7TY0OhMt6QRWYwZqbqluVqoPG1zBsQSWxpYQdAALVSLmTGpenK2bbNzZX6Pw4Zh2wMgfniyA1okajEjSZWK0oVCpWR7DsRO7k3/frnb9hCIF4IGaJ0zilDMLLo8Xb5uewbETlpsaRAyggZogX/47syIpKO256iHLQ0sGX7TN9nSIDwEDbBJtZg5bnuO9cxdrTxjewbETlrSMdtDID4IGmATXIgZSbp2zWT++KcF22MgfvK2B0B8EDTABr3juzPDciBmFk1dKs/YngGxM/Cmb17O2R4C8UDQABvwjv+YyUn6mu05mnHtmsmUSpzdhtDlbQ+AeCBogCbVYuYR23NsxMwMWxqEbuBN37zMtTRoO4IGaILLMSNJxWcWMtevs6VB6Pgr3Gg7ggZo0D/+58xhSadtz7FZl7iWBuE7+nffvJy1PQT8RtAADajFzJgsn8/UCmxpYEne9gDwG0ED3IJPMbNo7mqlaHsGxM7Rv/s3Dq1E+xA0wDre+V83zmfyJmYkaXau0lWpsKVB6PK2B4C/CBpgDb7GjCQZo9TMFbY0CN1xtjRoF4IGqGNJzETusMlWmZ0td9meAbGUtz0A/ETQACu861H/Y0aqbmmucmglwnf8jf/GoZVoPYIGWG1EnsfMokuXytdtz4BY4nVp0HIEDbDEux6dGZF0l+05wlKpmDRbGlgw/MZ/ZUuD1iJogJpazDhz2GSrTLGlQfjSYkuDFiNoAEnvfvTKacUwZqTqluaPf1ywPQbiJ2d7APiFoEHsvft7V3KS7rY9h00Xpl7gOASEbeCN/3o5Z3sI+IOgQazVYsbZwyZb5do1k2FLAwvytgeAPwgaxNZ7iJllLl0uX7A9A2Jn4G/Z0qBFCBrE0nu+fyUrYmaZP/1p4RCHVsICLg5GSxA0iJ33fP/KYUlnbM8RRVxLAwtu/9t/uZy1PQTcR9AgVt5bjZkxeXg+UysUiwsZtjSwIG97ALiPoEFsvPcHxEwj2NLAgqNsabBZBA1i4b0/uNKt6pEGxMwtPPPMwq5KhS0NQpezPQDcRtDAe7WYGVNMzmfaLGOUmp6pFG3Pgdg5/oZ/uTxoewi4i6CB1973Q2JmI65cKXexpYEFedsDwF0EDXw3JmKmacYoNTtXedr2HIid42/450uDtoeAmwgaeOt9P7wyImJmw2ZmKjw/wAZelwYbwhMWvFSLmVgeNtkqlYpJz12tlGzPgdjJveGfL3XbHgLuIWjgnfcTMy1zcap83fYMiJ202NJgAwgaeOX9P7oyLGKmZSoVk56bY0uD0A3/DVsaNImggTfe/6MrOUlfsz2Hb67Mlp+xPQNiJy3pmO0h4BaCBl74wI84ObtdSiWTefbZBdtjIH7ytgeAWwgaOO8DPyZm2u3CRY5DQOgG/uYbl3K2h4A7CBo47QM/vnJY0mnbc/iuVDKZ50psaRC6vO0B4A6CBs764I85bDJMly+X2dIgbAN/841LXEuDhhA0cNIHfzJLzIRsvriQuX6d4xAQOv4KNxpC0MA5H/zJ7KCIGSsuXOBaGoTu6Ou/cSlrewhEH0EDp3zoJ7Pdks6ImLGCLQ0sydseANFH0MAZH/rpLCdnR8DsbKVoewbEztHXf4NDK7E+ggZOIGaiY+ZKuatSYUuD0OVtD4BoI2jgihERM5FgjFKXp9nSIHTHX/91tjRYG0GDyLv7p7Mjku6yPQdumrlS7rI9A2Ipb3sARBdBg0irxQyHTUaMMUpxaCUsOP76r3NoJeojaBBZd/+MmImyi1Pl67ZnQCzxujSoi6BBJN39s9mciJlIq1RMmi0NLBg+xpYGdRA0iJzhasxw2KQD2NLAgrTY0qAOggaRMnyGmHFJpWLSzz7LoZUIHUGDVQgaRMbwmdmsiBnn/OEixyEgdOljpy/lbA+BaCFoEAkfPjN7WNUjDeCYUslk2NLAgrztARAtBA2s+/BjnJztuqmp8gXbMyB2BtjSYCmCBlYRM374058WDnFoJSzgWhrcQNDAmo88xsnZPrlwgWtpELrb7zp9KWt7CEQDQQMrajEzJmnA8ihokfliJfM8WxqEL297AEQDQYPQfeTnnJztK7Y0sODoXV9jSwOCBnaMiZjxUvGZyq5KhS0NQse1NCBoEK6P/nx2RMSMt4xR6vJ0pWh7DsTOXXd97dKg7SFgF0GD0NRihvOZPDdzpdzFlgYW5G0PALsIGoTio4/PjYiYiQVjlJqdrTxtew7EzvHXsaWJNYIGbfexx+fyImZiZXqmwnMLbOBamhjjSQdt9bHH53KS7rM9B8JVqZj03FylZHsOxE7udV+91G17CNhB0KBtPvaLuZw4bDK2LkyVr9ueAbGTFlua2CJo0BbEDNjSwJJhtjTxRNCg5f7pF3OHJZ22PQfsm5ktP2N7BsROWlLO9hAIH0GDlqrFzJg4nwmSSiWTefbZBdtjIH74tlMMETRomX/6JTGD1TgOARYMvParl3K2h0C4CBq0xMd/OTcoYgZ1lEom81yJLQ1Cl7c9AMJF0GDTPv7LuW5JZ0TMYA2XLpXZ0iBsA6/96qVjtodAeAgabMrH/3uOk7NxS/PFhczz1zkOAaHjWpoYIWiwYZ8gZtAErqWBBUdf+5WprO0hEA6CBptxRsQMGsSWBpbkbQ+AcBA02JBP/PfciKSjtueAW2ZnK0XbMyB2jr7mK1OHbQ+B9iNo0LRPPMHJ2diYmZlyV6XClgah41qaGCBo0JR7iBlsgjFKXZ5mS4PQHX/NV6YGbQ+B9iJo0LB7npjLiZjBJs1cKXfZngGxlLc9ANqLoEFDajHDYZPYNGOU4tBKWHD8NV+e4tBKjxE0uKV7fkXMoLUuTJWv254BscS1NB4jaLCuT/5q7piIGbRYpWLSbGlgwfCr2dJ4i6DBmj75q7nDkkZszwE/XbjIlgahS4stjbcIGtT1yV9zcjbaq1Ix6Wef5dBKhI6g8RRBg1U+9eurxAxC8QeOQ0D40q/+8lTO9hBoPYIGy3zq11c5ORuhKZVMhi0NLMjbHgCtR9Dghk/95uriYZMDlkdBjPzhIlsahG7g1V9iS+MbggaSpE/fjBkOm0SoSiXDoZWwgWtpPEPQgJiBdRe4lgbhu/1VX5rK2h4CrUPQQJJOi5iBRfPzC2xpYEPe9gBoHYIm5j79m6sj4nwmRABbGlhwlC2NPwiaGPvMk8QMoqNYXNhVqbClQei4lsYTBE1MfebJq3kRM4gQY5S6PF0p2p4DsXPXq744NWh7CGweQRNDn3nyak7SfbbnAFaauVLuYksDC/K2B8DmETQx85nfXs2JwyYRUWxpYMnxO9nSOI+giZETxAwcMDtb5qWDYQPX0jiOoImJE7+9eljEDBxQqWj37Fy5ZHsOxE7uzi9OddseAhtH0MTAid/dOGwScMLFi+XrtmdA7KTFlsZpBI3n7v0dJ2fDPeWKSc+xpUH4hu98kC2Nqwgaj937u6uDImbgqJkrlWdsz4DYSUvK2R4CG0PQeOre313tlnRGxAwcVSotZJ59luuDETq+7eQogsZD9/2ewybhhz9c5DgEhG7gzgencraHQPMIGs8QM/AJWxpYkrc9AJpH0PjnjIgZeOTyTPmC7RkQOwOvfHDqmO0h0ByCxiP3/f7qiKSjtucAWqlYrBx6/jrHISB0XEvjGILGE/c9xcnZ8NeFC1xLg9AdfeWDU1nbQ6BxBI0H8sQMPDc/v5BhSwML8rYHQOMIGsflnyoMi5hBDMzOcmglQnf0lQ9MHbY9BBpD0Dgs/1QhJ+lrtucAwjBzpdxVqbClQei4lsYRBI2jTo4VcuKwScSIMUpdnmZLg9Adf8UDU4O2h8CtETQOOjlWOCZiBjE0M8OWBlbkbQ+AWyNoHHNyrHBY0ojtOQAbjFHq6acXOLQSYTv+igc4tDLqCBqHnDxb4ORsxN6Fi+XrtmdALHEtTcQRNI64n5gBJEmViknPzVXY0iBsw6/4AluaKCNoHHD/2cLi+UzEDCDpwhRbGoQuLbY0kUbQRBwxA6xWqZg0h1bCAoImwgiaCDt1rsDJ2cAa/sBxCAhf+uVfuJizPQTqI2giipgB1lcqmQxbGliQtz0A6iNoouu0iBlgXZNsaRC+AbY00UTQRNCpc4URcT4TcEulkuHQStjAtTQRRNBEDDEDNOcCWxqE7/aXf/5i1vYQWI6giZBT5wqnRcwATZmfX2BLAxvytgfAcgRNRJw6V8hJutv2HICL2NLAgqMvY0sTKQRNBNRihsMmgQ0qFhd2cWglLOBamgghaCwjZoDNM0apy9OVou05EDt3vezzFwdtD4EqgsaiU+cKh0XMAC0xPVPuYksDC/K2B0AVQWNJLWbGbM8B+IItDSw5/rLPsaWJAoLGgiUxw/lMQAvNzpZ56WDYwLU0EUDQhIyYAdqnUtHuublKyfYciJ3cSz93sdv2EHFH0ISodj7TiIgZoG0uXCxftz0DYicttjTWETQh4bBJIByViknPsqVB+IbZ0thF0ISAmAHCNXOl/IztGRA7aUk520PEGUETjjERM0BoSiWTefZZrg9G6Pi2k0UETZvVDpskZoCQ/YHjEBC+gZd+7mLO9hBxRdC0ESdnA/awpYEledsDxBVB0ybEDGDf9HT5gu0ZEDsDL/nsxWO2h4gjgqYNTp0rDIuYAawrFhcOPX+d4xAQOq6lsYCgabHaYZNfsz0HgCqupYEFR1/y2YtZ20PEDUHTQpycDUTP/PxChi0NLMjbHiBuCJoWIWaA6JqdLXNoJcJ29CWfvXjY9hBxQtC0QO18ptO25wBQ3/RMuatSYUuD0HEtTYgImk3isEkg+oxR6vI0WxqE7viLT10ctD1EXBA0m0DMAO6YYUsDO/K2B4gLgmaDlpzPRMwADjBGqcLTHFqJ0B1/8SkOrQwDQbMBxAzgposXy9dtz4BY4lqaEBA0TeLkbMBd5YpJz86V2dIgbMNsadqPoGkCMQO4jy0NLEiLLU3bETTNGRExAzitXDFpDq2EBQRNmxE0DaodNnmX7TkAbB7HIcCC9B33X8zZHsJnBE0DTp0rDIrDJgFvlEoLGbY0sCBvewCfETQNOHGkZ0LSqO05ALTOJFsahG+ALU37EDSNy9seAEDrlEqGQythA9fStAlB06DaluYx23MAaB2upYEFt99x/8Ws7SF8RNA0hwMoAY/Mzy+wpYENedsD+IigacKJIz1jks7angNA61xgS4PwHc2eZEvTagRN8/K2BwDQOsXiwi4OrYQFXEvTYgRNk2pbmknbcwBoDWOUuny5UrQ9B2LnruzJC4O2h/AJQbMxedsDAGid6ZlyV6VitMBL0yBcedsD+ISg2YATR3pGxJYG8MaOHYlS6ZrRc88t6I9/XNAf/7RQeq60MPnccwtTz183k89fNzOVilGlYmT47hRa5zhbmtZJ2h7AYXlJj9geAsDm7NyZKBzYn+xZ8cOphQUNGCMtLFQL5oUXJBnJqPp+EGgmkK4pCBKJhBYSgfYGgVIKpAT/qYjG5SXlLM/ghcDwnxsbdupcYV7VU1TbZumXx9z4x8qPmXU+tvx+jd/OrH2fNR5v1durPmbWvd1ab699O3Pr+6/4Oa73eZY82vL/X9Z4e73PY5b8JBt5rMa+Rqbp+6//9pKvx8qfT9OPVZtvjcdq/u36X4uNP279r8XKmFn5dLjq6XHF1/wW9ykFga5ISnQktGCkrR0dyshIiY6gwZ+fWf3jdX4ea81X/3aN/Tpa7/Msv8/NT7rur+M1Prbur8s6v/+beqza4zX7a2bl57zl16TBr88azxFFGQ2O5Q/NC5vChmZzTku6z/YQAJq3dUswd2B/Z9/qRGmZlDGLWx5JMiqXl/1BpiDQjJGudSSCpKRyItDeIKFUEAQK1n5c+CWt6t94yluew3lsaDbh1LlCt6QJtXFLw4ZmvduxobnV/Rv+L+GVP5+mH6s23xqP1fzb9b8WG3/c5V+Lzs6gMDjQ1VP91tAan6vO+yu/5o3cZ+nXr+7Hl4+w8jY3tjyJhBYkbe3oCDLG3Py2Fhuadd6uPV6zv2ZWfs66vzbXuv/Nn0IDb994rKKRBs+ypdkUvtO7CSeO9MyLVw8GnNLZGRQGB7t6Otx49ksZo4GFBR0qlzVQLivz/PNGzz9vVCpV//f882bm2vNm8vp1M/XCC2ayUjGlhQUuXnZMWlxHs2l8y2nzRsS3nQAnLIsZT/7AN0YZI6my+FfOK4sb2xs/wacV6JlASgRBsBAE2hUE2i1x8XLEDIv/QN4UfjlvUu3QylHbcwBYXxCodNuhTlc2M620e3HLU6mYgXLZ7L7+gtH160bXrlW3PbW/mj5ZfsFMlctmsrJQve6HLU+oBo7mL+RsD+EyNjStkZd03PYQAOoLApUGbutKdXZyqW09xmhAurnlMZWVF5Is3fJoQQpqWx6jIH6B2E55Vbf+2AB+KbYAWxoguoJApYGBrtTWLcTMJizZ8migUjG7XygbvfCC0fXnq9ue6y+YyReum8ly2UxVKmZyYUFaYMPTLLY0m8CGpnVOiy0NEDkDA53VmOEP17YyRgMyN79NZVb8dSEjPR3UtjxatuURf0V9uZzY0mwIG5oWOXGk57yks7bnAHBTf3+yxGYmMm5seRZqW55y2aj8Qm3T84JRuWwmy2VNVSqarFQ0uWBieR3P0SP3XcjaHsJFbGhaKy/pKdtDAJD6M8lSOp1I2Z4DjVu65Vn+ujA39j1PB4GekalueQIFuxRot4wU+NWteUlZyzM4hxfWa7FT5wpjko626vF4Yb31bscL693q/uu/veTrsfLn0/Rj1eZb47Gaf7v+16LR+2f6k6XuXYnUsme3FV+vm++v8bnqvL/qMRq4zyZfWK+x95c9Rp3ng0beX/LGyvfXfgyz/sfXeczm3jfL/y9a82upUiBdkZRUoLKkrYGqf609CFbcb523V37+ur8217q/Gvw9v+I3UZ37/99zJw+dFxrGhqb1RtTCoAHQnJ6ejmJ3OpFeVR6Ig5RRdcuzTqTMSLoWSAkjLQSB9sqousmL1pZnWLzYXlPY0LTBqXOFCan61yA3iw3NerdjQ3Or+6//9pKvx8qfT9OPVZtvjcdq/u36X4tb3X/njkRh/+Jhkyu+Pmu/v8bnqvP+qsdo4D5saFrxfsMbmo19jhuPYSSpJOmKzM0tjxRkpGrvhLihkaQXnTt5aEJoCBcFt0fe9gBA3CyLGWDjUqr+B+kBUz1cNGOMkVkwqiwYLVRfdHBmYUGTxuiCMZo0UmlV6bZGvi2P6ik2NG3Sqi0NG5r1bseG5lb3X//tJV+PlT+fph+rNt8aj9X82/W/FmvdZ+f2aswsezZb8fVZ+/01Pled91c9RgP3YUPTivdD3dA0/DnWeb8k6YoxSkjVQ0WDQJkNbGhkjF70P/ezpWkEG5r24UwOIASdnUGhv5/NDCJlcctzqPbvjDHVUDHGqLpIMDPGaNIYTRlpUtUIqicXzsjuI2jaZ0RS0fYQgM86O4PC4EBnD4cswkEZ1b61Vft3ajF6akrGaFLS39kZzz08DbTJiSM982JLA7QNMQPPpSR1S3qz7UFcwVNBe50WWxqg5ToSKg4QM/Bf9n/u57VoGsXTQRvVtjRnbM8B+CQIVDp0sDNNzMBzQ8RMc3hKaL+87QEAXwSBSgO3daa2cD4T/DZ07uShEdtDuIagabMTR3omJI3angNwXRCodBsxA/8RMxtE0IQjb3sAwHX7+pOGmIHnThIzG0fQhKC2pXnM9hyAq/r3Jks7diS22Z4DaKPRcycP5W0P4TKCJjz8FW5gA/ozyVI6nUjZngNoo9Gz+UM520O4jqAJyYkjPWOSztqeA3BJZi8xA+8RMy1C0IQrb3sAwBU7diQKxAw8Ny5p2PYQviBoQlTb0kzangOIup07EoX9+zifCV4bl5Q9mz80b3sQXxA04cvbHgCIsh3EDPxHzLQBQROyE0d6RsSWBqhry5ZgjpiB5yYlZcfuI2ZajaCxI297ACBqOpNB4dDBzj7bcwBtVJR0jJhpD4LGgtqWhkMrgZrOZFDgsEl4rqjqZobzmdqEpw97eF0aQMQMYqEWMweJmTbiKcSe02JLg5gLApUOHkgSM/DdsafuJWbajacRS04c6ZkXWxrEWBCodNuhzlRnJ+czwWtDT917cMz2EHFA0Ng1YnsAwIYgUOnQIU7OhveGnrr34IjtIeKCoLGodmjlqO05gDAFgZ677SAxA+8RMyEjaOzL2x4ACNPePcmAmIHnRn9/gpgJG0FjGVsaxMnevclSehfnM8Fro78/cTBne4g4ImiigYuD4b29nJwN/xEzFhE0EXDiSM95SWdtzwG0y+7dHUU2M/DcY8SMXQRNdORtDwC0w44diUJfb0fa9hxAG41LytkeIu4Imog4caRnTGxp4Jkd2xOFff0cNgmvjUvK/u7EQc5nsoygiZYR2wMArbJjBzED71Vj5jPETBQQNBFSO7Ry0vYcwGYlkwExA98VJR0jZqKDoImevO0BgM1IJoPCbbd1EjPwWVHVzcyE7UFwE0ETMWxp4LJkMsw4n+oAABFoSURBVCgMHOLkbHitKCn7289w2GTU8LQTTbwuDZyTSKhIzMBz1Zj5NDETRTz1RNOIqr9xACcEgUoHDnSmiRl4bpiYiS6efiLoxJGeebGlgSOCQKWDB5McNgnfDf3205zPFGUETXSdFlsaRFwQqHToADED7w09ScxEHkETUbUtzRnbcwDr2b+PmIH3Tj75KWLGBQRNtOVtDwCsZe/ejlIqRczAa6NPfupg3vYQaAxBE2EnjvRMSBq1PQew0t49HaVdHDYJv40++SkOm3QJQRN9edsDAEsRM4iB0d8QM84haCLu3qM9E5Iesz0HIFUPmyRm4Lnx33ySmHERQeMG/go3rNuxPVHo7+/gSAP4bFxS1vYQ2BiCxgH3Hu0Zk3TW9hyIr+3bE4X+DDEDr41Lyv7mkxw26SqCxh152wMgnlKpxFw/J2fDb5MiZpxH0DiitqXh0EqEKpkMCv39yT7bcwBtVJR07NefPEDMOI6gcUve9gCIj2QyKNx2kMMm4bWipOyv7znA+Uwe4KnKIfcd7RkRWxqEIJkMCoeIGfiNmPEMT1fuydseAH6rnpydJGbgu2PEjF94ynLMfdmeEXFoJdqkGjOdqWSSIw3gtaFf3XNgzPYQaC2Cxk28Lg1aLghUOnigM7Wli5iB14Z+dc+BEdtDoPUIGjedFlsatFAQ6LkDxAz8N/SrTxAzviJoHHRftmdebGnQQn19yYCYgee+Tsz4jaBx14jtAeCHPXuSpV07OZ8JXht94hMHhm0PgfYiaBx1X7ZnQtKo7TngNmIGMTD6xCcO5GwPgfYjaNyWtz0A3NXb23GNmIHnHnvi48RMXBA0DsvfwZYGG7N9e6LQne7YansOoI3GJeVsD4HwEDTu4+JgNGX79kShfy8nZ8Nr45KyT3yc85nihKBxXP6OnvOSztqeA27Yvj1RyGSIGXhtXFL2v4mZ2CFo/JC3PQCiL5kMCv3EDPxWFDETWwSNB/J39I6JLQ3WkUwGhUMHksQMfFaNmX8iZuKKoPHHiO0BEE3JZFA4yGGT8NtizHDYZIzxFOeJk3f0jkiatD0HoiWZDOYOHiRm4DViBpIIGt/kbQ+A6AgClfozHX3EDDw3/EtiBiJovHLyxWxpUBUEKh3Yn0x1cT4T/Db0y49xPhOqCBr/8Lo0MUfMICaIGSxD0PhnRNXvKSOm+jPEDLz3YWIGKxE0njn54t55saWJrb6+jlJqKzEDr43+4mMHeI7DKgSNn06LLU3s7OnrKO3ksEn4bfQXH+WwSdRH0HiotqU5Y3sOhGdPLzED7xEzWBdB46+87QEQjp07EnPEDDw3TszgVggaT93/kt4JSaO250B7bd+eKPT1dfTZngNoo3FJWdtDIPoIGr/lbQ+A9tm+PVHYu5fDJuG1cUnZxz/K+Uy4NYLGY7UtzWO250Drbd2amMvs5bBJeK0WM/uJGTSEoPEff73RM8lkUMjsTfJtJvisKCn3+EeIGTSOoPHc/S/pHZN01vYcaI1kMigc2N/JYZPwWVFS9vGP7Od8JjSFp8V4yNseAJtHzCAGipKyPydmsAE8NcbAqeqWhkMrHRYEurafmIH/jhEz2CieHuMjb3sAbEwQqLR/X3IrMQPPDf38w/vHbA8Bd/EUGROnXto7IrY0zqnFDIdNwndDP//w/hHbQ8BtBE285G0PgMYFgZ7b10/MwHtDjxEzaAGCJkZqWxoOrXRET09HQMzAc18nZtAqBE388Lo0DujjsEn4b/Sx4f3DtoeAPwia+DkttjSRRswgBkYfG96fsz0E/ELQxMxnX9o7L7Y0kbV7d8e1nTuIGXht9AwxgzYgaOJpxPYAWG3btkQhvSux1fYcQBuNS+LbTGgLgiaGPvuy3glJo7bnwE3btyUKe/dwcja8Ni4pe2aY85nQHgRNfOVtD4CqbcQM/FeNmbuJGbQPQRNTbGmioasrmCNm4LmiiBmEgKCJNy4OtiiZDAr9mWSf7TmANipKyv6MmEEICJoY++zLes9LOmt7jjhKJoPC/n1JDpuEzxZjhsMmEQqeTpG3PUDcJJPB3D5iBn6rxsyHiBmEh6fUmPvcy3vHxJYmNEGg0t49HX3EDDyXI2YQNp5WIfG6NKEIApU4bBIxMPTTD+0/Y3sIxA9BA33u5b0jkiZtz+GzIFCpP0PMwHtDP/0Qh03CDoIGi/K2B/AZMYMY+DAxA5sIGkhiS9NOvb0dJWIGnhv96Qf38zIQsIqgwVI8IbVYb09HicMm4bnRn3yQwyZhH0GDpUZU/euWaIHeno7SDmIGfiNmEBkEDW74/Mt758WWpiV27EjMETPw3FliBlFC0GCl02JLsynbtgWF3p4ERxrAZ+OSjtkeAliKoMEyn39F77x4XZoN27YtKPT1cdgkvDYuKfuTD+zjfCZECkGDevi20wZs25Yo7CFm4LdxSdkfEzOIIIIGq3z+Fb0TkkZtz+GSZDIo9PYQM/BaUVKOmEFUETRYS972AK5IJoNCf4bDJuG1oqqbGc5nQmTxFIy6vvCKvglJj9meI+qIGcRANWbeT8wg2ngaxnq4lmYdQaBr+/qJGXgv+yNiBg7gqRhr+sIr+8YknbU9RxQFgUqZTHIrMQPPDREzcAVPx7iVvO0BoqYWMxw2Cd8N/ej9+0ZsDwE0iqDBumpbmnHbc0TFjZjpJGbgtaEfvY+YgVsIGjSCa2lqens7DDEDz50kZuAigga39MAr+0YkTdqew7aeno7StlRim+05gDYa/eH79uVtDwFsBEGDRuVtD2BTT09Hacd2DpuE10Z/+L59OdtDABtF0KAhD9zZN6KYHlrZ3d1xjZiB50Z/+F5iBm4jaNCM2F1Lk0olCrt2JrbangNoo3FJw7aHADaLoEEzTitGW5ptqUShr5fzmeC1cUnZH76X85ngPoIGDXvgzr55xWRLsy2VKPRxcjb8Ni4p+wNiBp4gaNAs74OmszOYI2bguUkRM/AMQYOm1LY0o7bnaJdkR1DYuyfZZ3sOoI2Kko4RM/ANQYONyNseoB2SHUEhw8nZ8FtRUvYH7+F8JviHp2407cE7+ybk2Zamo0PEDHxXlJT9PjEDT/H0jY3y5lqaIFBpz54OYga+yxEz8BlP4diQB1/Vd17SWdtzbFYQqLR3T0cqmeR8Jnht6Pvv2XfG9hBAOxE02Iy87QE2YzFmOjlsEn4b+v67OWwS/iNosGEPvqpvTA5vafYQM/Df0PeIGcQEQYPNcvJamu7uRImYgedGiRnECUGDTfniq/rOqPoiXc7o7k6Utm/jsEl4bfR77+awScQLQYNWyNseoFHEDGJg9HvvImYQPwQNNu2Lr+4bkQNbmh07EsVtxAz8dvZRYgYxRdCgVSJ9Lc3WrUFh185E2vYcQBuNSzpmewjAFoIGrTKi6iuRRs7WrUGhZzeHTcJr45Kyj76rn/OZEFsEDVrii6/um1cEtzTEDGKAmAFE0KC1TitCW5qODhXSu4gZeK0o6dij7yRmAIIGLfOl6pZmxPYcUjVm+no5bBJeK0rK/tc7+ydsDwJEAU/3aDXr33YiZhADizHDYZNADU/5aKkvvaZvQtKorc+fSKjYS8zAf8QMsAJP+2iHvI1PGgQq7d7dkSZm4LkhYgZYjad+tFxtS/NYmJ8zCFTq6elIdSY5nwleG/rPf+wfsT0EEEUEDdoltGtpiBnEBDEDrIOgQVt8+TV9Y5LOhvG50rs6TJKYgd9OEjPA+ggatFO+3Z9g185EacuWYFu7Pw9g0eh//mN/3vYQQNQRNGib2pZmvF2Pv3NnopRKcdgkvDb6H+/oz9keAnABQYN2a8u1NMQMYoCYAZpA0KCtvvzavhFJk618zC1bgkJqa0DMwGfjxAzQHIIGYci36oG2bAkK6V0JzmeCz8YlZW0PAbiGoEHb1bY0mz60csuWoLCLmIHfxiVl/+MdHDYJNIugQVg2dS1NMhnM7dpJzMBrk5Ky3/0HYgbYCIIGYTmtDW5pEgkVutOJvhbPA0RJUdIxYgbYOIIGofjKa/vmtYEtTSKhwu7dHT0Br5sHfxVV3cxwPhOwCQQNwtRU0BAziAFiBmgRggah+crr9sxLGm3w5qV0mpiB9459d4iYAVqBoEHY8g3cptSdTqQ6+NUJvw2NDvWP2R4C8AV/ZCBUX3ndngmtv6UppdOJFIdNwnNDo0McNgm0EkEDG9a6luY5YgYxQMwAbUDQIHRffd2e85LOrvzxHdsTQbKDmIHXRokZoD0IGtiSX/rO9u2J0pYtnM8Er42O5DifCWgXggZWfPWuPWOqbWm2byNm4D1iBmgzggY2nd66NSgSM/DcYyO5TM72EIDvAmOM7RkQc6fOFbolHa69m13x78OS0iGPdMPK3x71frss/zEjU/3X+o+zgdvUvY/Murcxq9649W3Wfv/mnRq/z6pP3+B9zKr73Or9ep+nsfeX/Lxu9fVe+Ri3vs+4McqO5DIcaQC0GUEDJ5w6VzgsaTF8uiUNLvnfQLs+L0FD0Cz/gaaCZlxS9pHjxAwQBoIGXliy5am37Tm60cclaAia5T/QcNAQM0DICBrExka2PAQNQbP8BxoKmqKkw48cz0wIQGgIGqCm3pbHmOVbHoKm2fus+vS+B03RGGUfOZ7hfCYgZAQN0ISTY4Vs7c0b4WPMjW3PAEFzi/cbvo+TQVOUlP3O24kZwAaCBmih/FNXB400KLPsW1uHa7/Nji7ejqDxLmiIGcAyggYI2b2/u5qt/Zm97JoeY5Zfy0PQLL9PxINm6Dtvz4wIgDUEDRAxn3ny6qCkQSN1L42e2vu3L70tQbP+5wkpaIgZIAIIGsBBn/r11awkGZls7U/Y6pZHOixz84UICZpG3t9U0Aw9/DZiBogCggbw0D1PzA2quuUZ1Ipreox0O0Gz9P0NB83Jh9+WyQtAJBA0QEx9/JdzWUkyiy9AaJZseaQ0QbNu0Iw+/DbOZwKihKABUNfHHl+55THLtzxSXIOGmAEiiKABsCEf+fns4kXLS7c82dr79bc8S95xNGhGHyJmgEgiaAC0zfDPZhc3OoO6eT3PoG655Ylk0Iw/9NbMYQGIJIIGgDUf+ulaWx5zc8tT+6DloBmXlH3orRw2CUQVQQMg0j7w4yuHZVZveczSQ0XbGzTEDOAAggaA0973wys3XoCwttWRpGwtWI7euOHGgoaYARxB0ADw3nu+f2PLs/jKy0u2PGZg8Xb1Ts5+6K2czwS4gKABEHvvenRm6cnpi1ueM99+CzEDuIKgAQAAzkvYHgAAAGCzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOI+gAQAAziNoAACA8wgaAADgPIIGAAA4j6ABAADOI2gAAIDzCBoAAOA8ggYAADiPoAEAAM4jaAAAgPMIGgAA4DyCBgAAOO//A4K68+0mDGvVAAAAAElFTkSuQmCC"
  }))));
};
/* harmony default export */ var title_icon_cube_skyblue = (SvgTitleIconCubeSkyblue);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/title_icon_cloud_deepblue.svg
var title_icon_cloud_deepblue_path, title_icon_cloud_deepblue_defs;
function title_icon_cloud_deepblue_extends() { title_icon_cloud_deepblue_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return title_icon_cloud_deepblue_extends.apply(this, arguments); }

var SvgTitleIconCloudDeepblue = function SvgTitleIconCloudDeepblue(props) {
  return /*#__PURE__*/react.createElement("svg", title_icon_cloud_deepblue_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), title_icon_cloud_deepblue_path || (title_icon_cloud_deepblue_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#title_icon_cloud_deepblue_svg__a)",
    d: "M0 0h64v64H0z"
  })), title_icon_cloud_deepblue_defs || (title_icon_cloud_deepblue_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "title_icon_cloud_deepblue_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#title_icon_cloud_deepblue_svg__b",
    transform: "scale(.00178)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "title_icon_cloud_deepblue_svg__b",
    width: 563,
    height: 563,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
/* harmony default export */ var title_icon_cloud_deepblue = (SvgTitleIconCloudDeepblue);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/background_corner_skyblue.png
/* harmony default export */ var background_corner_skyblue = ({"src":"https://img1.tidb.net/_next/static/media/background_corner_skyblue.ed79a7b0.png","height":853,"width":853,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEVMaXF+v+5pqetnqOpfn+lsrOtIiuY/gOR+vu17u+yK1GcjAAAACnRSTlMATgkdTy0yS0U9SGLQjgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC5JREFUCJk1iMkNADAMg+zc2X/hylLDBwRwWNWPCIerltOtm2RHGOAkJ01rXToeEnoAhWDlM8MAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/background_corner_green.png
/* harmony default export */ var background_corner_green = ({"src":"https://img1.tidb.net/_next/static/media/background_corner_green.2993a13c.png","height":687,"width":687,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEVMaXEKplsDxmwEwWoLm1QIuGUAzHAOj06ChYwqAAAACHRSTlMAET9LTCBRMi65hQsAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAsSURBVAiZVYq5DQAwCMTuA/bfOBKiiQs3NvDBFTERgUSxCZTbXdvUurd2Ph4LjQBU5e7PSgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/background_corner_blue.png
/* harmony default export */ var background_corner_blue = ({"src":"https://img1.tidb.net/_next/static/media/background_corner_blue.26e7a8bd.png","height":911,"width":911,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEU3QORMaXE2QN8+SOlDTus6QO01di9ZAAAABnRSTlNOADEgEjqV1hzIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVQImS2LyREAIAyE2MP+W3Y04cUD0IKU9EsBVyg8ig7YFgImjrPX7BcMSABTlsy9+wAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/background_corner_skyblue_reverse.png
/* harmony default export */ var background_corner_skyblue_reverse = ({"src":"https://img1.tidb.net/_next/static/media/background_corner_skyblue_reverse.e3e5d6f8.png","height":707,"width":707,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEVMaXF+v+1dneloqOtnqOp8vO1ioulKi+ZBgeX0YV1yAAAACXRSTlMATi4KHUFOUD7LbKaHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVQImS2LyQ0AMAzCgJz7Txwl7QckGwAAZpuAUtdeGY900Y8EuUhFckedoTP/OxBBAHh0bD+1AAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Header/banner_background.png
/* harmony default export */ var banner_background = ({"src":"https://img1.tidb.net/_next/static/media/banner_background.27bb7a0e.png","height":559,"width":1680,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAABlBMVEUoK3QsMJVyoPn2AAAAAnRSTlMRCCuRZhoAAAAJcEhZcwAACxMAAAsTAQCanBgAAAATSURBVAiZY2BkAAFGRgYIg4ERAABBAAYDJi7dAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Header/index.styled.tsx
function index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function index_styled_templateObject() {
    var data = index_styled_taggedTemplateLiteral([
        ""
    ]);
    index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function index_styled_templateObject1() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  //flex-wrap: wrap;\n  padding: 52px 0;\n  background: url(",
        ") center no-repeat;\n"
    ]);
    index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function index_styled_templateObject2() {
    var data = index_styled_taggedTemplateLiteral([
        ""
    ]);
    index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function index_styled_templateObject3() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    padding: 0 100px;\n  "
    ]);
    index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function index_styled_templateObject4() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    padding: 16px;\n    display: none;\n  "
    ]);
    index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function index_styled_templateObject5() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function index_styled_templateObject6() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    padding-left: 100px;\n  "
    ]);
    index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function index_styled_templateObject7() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    padding: 16px;\n  "
    ]);
    index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function index_styled_templateObject8() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  //width: 100%;\n  //display: flex;\n  //flex-direction: column;\n  //align-items: center;\n  img {\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function index_styled_templateObject9() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function index_styled_templateObject10() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    display: block;\n    padding: 16px;\n    margin-top: -64px;\n  "
    ]);
    index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function index_styled_templateObject11() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  //width: 100%;\n  display: flex;\n  align-items: center;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    index_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function index_styled_templateObject12() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    padding-left: 100px;\n  "
    ]);
    index_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function index_styled_templateObject13() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    padding: 16px;\n  "
    ]);
    index_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function index_styled_templateObject14() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  margin-top: 52px;\n  color: #fff;\n"
    ]);
    index_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function index_styled_templateObject15() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  padding: 6px 16px;\n  font-size: 16px;\n  border: none;\n  cursor: not-allowed;\n  background: ",
        ";\n  color: #fff;\n  &:hover {\n    color: #fff;\n  }\n"
    ]);
    index_styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function index_styled_templateObject16() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  color: #f67200;\n"
    ]);
    index_styled_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function index_styled_templateObject17() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  color: #f67200;\n  a,\n  a:hover {\n    color: #f67200;\n  }\n"
    ]);
    index_styled_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function index_styled_templateObject18() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    padding-left: 100px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    margin-top: 70px;\n  "
    ]);
    index_styled_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function index_styled_templateObject19() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    padding: 16px;\n    margin-top: 48px;\n  "
    ]);
    index_styled_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function index_styled_templateObject20() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  height: auto;\n  background: linear-gradient(90deg, #3940ea 0%, rgba(57, 64, 234, 0) 100%);\n  a {\n    color: #fff;\n  }\n"
    ]);
    index_styled_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function index_styled_templateObject21() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  color: #fff;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 25px;\n  letter-spacing: 0.3em;\n  &:hover {\n    color: #00cf71;\n  }\n"
    ]);
    index_styled_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}






var index_styled_Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({})(index_styled_templateObject());
var Header = styled_components_browser_esm/* default.header */.ZP.header(index_styled_templateObject1(), banner_background.src);
var HeaderStart = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject2());
var HeaderEnd = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject5(), mixins/* onDesktop */.X$((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject3())), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject4())));
var HeaderStartTitle = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject8(), mixins/* onDesktop */.X$((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject6())), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject7())));
var HeaderStartImage = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject11(), mixins/* onDesktop */.X$((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject9())), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject10())));
var HeaderStartButton = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z).attrs({
    size: [
        44,
        44
    ],
    wrap: true
})(index_styled_templateObject14(), mixins/* onDesktop */.X$((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject12())), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject13())));
var HeaderStartButtonSignUp = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject15(), colors.F2);
var HeaderStartButtonJoinGroup = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject16());
var HeaderStartButtonAsk = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject17());
var HeaderStartNav = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z).attrs({
    size: [
        24,
        24
    ],
    split: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: {
            color: "#FFF"
        },
        children: "|"
    }),
    align: "center"
})(index_styled_templateObject20(), mixins/* onDesktop */.X$((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject18())), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject19())));
var HeaderStartNavItem = styled_components_browser_esm/* default.a */.ZP.a(index_styled_templateObject21());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Header/cube.png
/* harmony default export */ var cube = ({"src":"https://img1.tidb.net/_next/static/media/cube.187ed891.png","height":56,"width":62,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAANlBMVEVenudwsOpamuZhoedcnOdKiuR/vux6uexPkOVmpuh4t+tUlOVDhONwr+p/v+x0s+p9vexxseqSKz6VAAAAEXRSTlP9fYviW0NuAf784dnE593Vz6A01R0AAAAJcEhZcwAACxMAAAsTAQCanBgAAAA2SURBVAiZFcjJEYAwEAPBAdZIy2nlnyxFPxtpzbGV0ALpU+zBtIsn2Pj6h8YD3UkzhGq+XdIHMUwBoibKiCEAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Header/title.png
/* harmony default export */ var title = ({"src":"https://img1.tidb.net/_next/static/media/title.04d7dc5f.png","height":182,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEW5iE3pjEf8/v7P/eDt/f9kn7ZViNa4/OsSU1/SAAAACHRSTlMnKkJCLB8uNJgX9iAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVAiZY2BiYmJhYWdmZmBkZGRgYGBlAwABlgAqkO9GwQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Header/banner_image.png
/* harmony default export */ var banner_image = ({"src":"https://img1.tidb.net/_next/static/media/banner_image.65b1161a.png","height":571,"width":596,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAXVBMVEVMaXG5TAVEkeNlnuwyO+Td3eH3aATPWAE4Pug/SOwtzI/FUgA6RNkoNtcJLfbj4+Vsdof/8N4fikMAolUKsW0By3AFj0MAwF347eoBznAOoVp2sucDvGYwOdvLVwIq3lBBAAAAHHRSTlMAKTRpkkQuQj30DzV1dEyiFyhLLKKtpJ1Vz8KHmLi7BAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAD1JREFUCJkVxkkSgCAMAMGRAAEU913w/8+07FMTYuwYHNhqe9wEIeNHIwZoXs8j/JuX/aBVuEvZUOVM65U+OfICLHJQpdUAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Header/index.tsx
function Header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Header_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Header_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Header_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var Header_Header = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = Header_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Container, Header_objectSpread({}, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderStart, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderStartTitle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        paddingLeft: "20%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), Header_objectSpread({}, cube, {
                                        alt: ""
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), Header_objectSpread({}, title, {
                                    alt: "TiDB Hackathon 2022"
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderStartImage, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), Header_objectSpread({}, banner_image, {
                                alt: ""
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderStartButton, {
                            children: data.buttonItems.map(function(value) {
                                return value.children;
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderStartNav, {
                            children: data.navItems.map(function(value) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderStartNavItem, Header_objectSpread({}, value), value.href);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderEnd, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), Header_objectSpread({}, banner_image, {
                        alt: ""
                    }))
                })
            ]
        })
    }));
};
/* harmony default export */ var hackathon2022_Header = (Header_Header);

// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ThemeRace/index.styled.ts
function ThemeRace_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ThemeRace_index_styled_templateObject() {
    var data = ThemeRace_index_styled_taggedTemplateLiteral([
        ""
    ]);
    ThemeRace_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ThemeRace_index_styled_templateObject1() {
    var data = ThemeRace_index_styled_taggedTemplateLiteral([
        ""
    ]);
    ThemeRace_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ThemeRace_index_styled_templateObject2() {
    var data = ThemeRace_index_styled_taggedTemplateLiteral([
        "\n  height: 100%;\n  padding: 30px 36px 48px 36px;\n  border-width: 1px;\n  border-top-width: 16px !important;\n  border-style: solid;\n  border-color: ",
        ";\n"
    ]);
    ThemeRace_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ThemeRace_index_styled_templateObject3() {
    var data = ThemeRace_index_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    ThemeRace_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ThemeRace_index_styled_templateObject4() {
    var data = ThemeRace_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 26px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* or 175% */\n  color: #ffffff;\n"
    ]);
    ThemeRace_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ThemeRace_index_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: [
        32,
        32
    ]
})(ThemeRace_index_styled_templateObject());
var ThemeRaceListItem = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    lg: 12,
    md: 24
})(ThemeRace_index_styled_templateObject1());
var ThemeRaceListItemContainer = styled_components_browser_esm/* default.div */.ZP.div(ThemeRace_index_styled_templateObject2(), function(param) {
    var $color = param.$color;
    return $color;
});
var ThemeRaceListItemName = styled_components_browser_esm/* default.div */.ZP.div(ThemeRace_index_styled_templateObject3(), function(param) {
    var $color = param.$color;
    return $color;
});
var ThemeRaceListItemBody = styled_components_browser_esm/* default.div */.ZP.div(ThemeRace_index_styled_templateObject4());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ThemeRace/index.tsx
function ThemeRace_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThemeRace_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ThemeRace_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ThemeRace_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ThemeRace_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ThemeRace_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ThemeRace_ThemeRace = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = ThemeRace_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeRace_index_styled_Container, ThemeRace_objectSpread({}, rest, {
        children: data.map(function(value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeRaceListItem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeRaceListItemContainer, {
                    $color: value.color,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeRaceListItemName, {
                            $color: value.color,
                            children: value.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeRaceListItemBody, {
                            children: value.body
                        })
                    ]
                })
            }, value.name);
        })
    }));
};
/* harmony default export */ var hackathon2022_ThemeRace = (ThemeRace_ThemeRace);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/title-winner-icon.svg
var title_winner_icon_path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, title_winner_icon_defs;
function title_winner_icon_extends() { title_winner_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return title_winner_icon_extends.apply(this, arguments); }

var SvgTitleWinnerIcon = function SvgTitleWinnerIcon(props) {
  return /*#__PURE__*/react.createElement("svg", title_winner_icon_extends({
    width: 47,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), title_winner_icon_path || (title_winner_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.495 60.114V62.484c.002.158.08.315.236.405l11.897 6.868a1.814 1.814 0 0 0 1.814 0l20.063-11.583a.469.469 0 0 0 .236-.41v-2.358L6.495 60.114Z",
    fill: "url(#title-winner-icon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M6.73 60.531 18.628 67.4a1.814 1.814 0 0 0 1.814 0l20.063-11.583a.473.473 0 0 0 0-.82l-11.896-6.868a1.814 1.814 0 0 0-1.814 0L6.73 59.712a.473.473 0 0 0 0 .82Z",
    fill: "url(#title-winner-icon_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M37.384 22.153a2.132 2.132 0 0 1-1.068-3.98l2.61-1.507a7.62 7.62 0 0 0 3.8-6.581V4.999l-4.278 2.47a2.132 2.132 0 1 1-2.132-3.694l4.725-2.728a3.926 3.926 0 0 1 3.967 0c1.241.717 1.982 2 1.982 3.435v5.603c0 4.225-2.273 8.162-5.932 10.275l-2.61 1.507a2.123 2.123 0 0 1-1.064.286Z",
    fill: "#D7D7D7"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M8.992 46.253V59.6a.4.4 0 0 0 .202.346l10.162 5.867a1.55 1.55 0 0 0 1.549 0l17.137-9.894a.4.4 0 0 0 .202-.35V42.232L8.992 46.253Z",
    fill: "url(#title-winner-icon_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "m9.194 46.61 10.162 5.866a1.55 1.55 0 0 0 1.55 0l17.136-9.894a.404.404 0 0 0 0-.7l-10.161-5.867a1.549 1.549 0 0 0-1.55 0L9.194 45.909a.404.404 0 0 0 0 .7Z",
    fill: "url(#title-winner-icon_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "m26.628 38.28-7.169.641v4.816c-.005.48.281.94.874 1.282 1.296.748 3.56.654 5.057-.21.84-.485 1.26-1.11 1.237-1.697h.001v-4.831Z",
    fill: "url(#title-winner-icon_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M5.242 12.475v10.94c0 9.843 7.98 17.822 17.822 17.822 9.842 0 17.821-7.98 17.821-17.822V8.735l-35.643 3.74Z",
    fill: "url(#title-winner-icon_svg__f)"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M34.723 17.045c7.449-4.3 8.258-10.806 1.807-14.53C30.078-1.21 18.81-.744 11.36 3.558c-7.449 4.3-8.258 10.806-1.807 14.53 6.451 3.725 17.72 3.258 25.169-1.043Z",
    fill: "url(#title-winner-icon_svg__g)"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M32.43 15.721c5.986-3.456 6.636-8.684 1.451-11.677-5.184-2.993-14.24-2.618-20.226.838-5.986 3.456-6.636 8.684-1.452 11.677 5.184 2.994 14.24 2.618 20.226-.838Z",
    fill: "url(#title-winner-icon_svg__h)"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "m23.697 54.06 11.414-6.59v7.653l-11.414 6.59v-7.654Z",
    fill: "#C5BAEB"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M6.279 39.478a6.266 6.266 0 0 1-3.14-.851A6.215 6.215 0 0 1 0 33.189v-5.635c0-1.734.933-3.35 2.435-4.218l4.851-2.8a2.132 2.132 0 1 1 2.133 3.693l-4.851 2.8a.607.607 0 0 0-.303.525v5.635c0 1.05.704 1.57 1.007 1.744.303.175 1.105.525 2.014 0l2.027-1.17a2.133 2.133 0 0 1 2.132 3.693l-2.026 1.17a6.266 6.266 0 0 1-3.14.852Z",
    fill: "#D7D7D7"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "m34.568 55.436.542-1.037v-6.93l-.156.09-5.74 10.967 5.354-3.09Z",
    fill: "url(#title-winner-icon_svg__i)"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "m32.647 48.892-7.946 4.588-1.004 1.918v6.314l3.21-1.853 5.74-10.967Z",
    fill: "url(#title-winner-icon_svg__j)"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M37.384 22.153a2.132 2.132 0 0 1-1.068-3.98l2.61-1.507a7.62 7.62 0 0 0 3.8-6.581V4.999l-4.278 2.47a2.132 2.132 0 1 1-2.132-3.694l4.725-2.728a3.926 3.926 0 0 1 3.967 0c1.241.717 1.982 2 1.982 3.435v5.603c0 4.225-2.273 8.162-5.932 10.275l-2.61 1.507a2.123 2.123 0 0 1-1.064.286Z",
    fill: "#FFC538"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "m26.628 38.28-7.169.641v4.816c-.005.48.281.94.874 1.282 1.296.748 3.56.654 5.057-.21.84-.485 1.26-1.11 1.237-1.697h.001v-4.831Z",
    fill: "url(#title-winner-icon_svg__k)"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M5.242 12.475v10.94c0 9.843 7.98 17.822 17.822 17.822 9.842 0 17.821-7.98 17.821-17.822V8.735l-35.643 3.74Z",
    fill: "url(#title-winner-icon_svg__l)"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M34.723 17.045c7.449-4.3 8.258-10.806 1.807-14.53C30.078-1.21 18.81-.744 11.36 3.558c-7.449 4.3-8.258 10.806-1.807 14.53 6.451 3.725 17.72 3.258 25.169-1.043Z",
    fill: "url(#title-winner-icon_svg__m)"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M32.43 15.721c5.986-3.456 6.636-8.684 1.451-11.677-5.184-2.993-14.24-2.618-20.226.838-5.986 3.456-6.636 8.684-1.452 11.677 5.184 2.994 14.24 2.618 20.226-.838Z",
    fill: "url(#title-winner-icon_svg__n)"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M6.279 39.478a6.266 6.266 0 0 1-3.14-.851A6.215 6.215 0 0 1 0 33.189v-5.635c0-1.734.933-3.35 2.435-4.218l4.851-2.8a2.132 2.132 0 1 1 2.133 3.693l-4.851 2.8a.607.607 0 0 0-.303.525v5.635c0 1.05.704 1.57 1.007 1.744.303.175 1.105.525 2.014 0l2.027-1.17a2.133 2.133 0 0 1 2.132 3.693l-2.026 1.17a6.266 6.266 0 0 1-3.14.852Z",
    fill: "#FFC538"
  })), title_winner_icon_defs || (title_winner_icon_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__a",
    x1: 17.669,
    y1: 62.703,
    x2: 22.913,
    y2: 62.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#2D3180"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#3F46B0"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__b",
    x1: 13.181,
    y1: 63.789,
    x2: 45.813,
    y2: 44.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#5155A5"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#8F93DD"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__c",
    x1: 18.536,
    y1: 54.126,
    x2: 23.016,
    y2: 54.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#2D3080"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#3F45AF"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__d",
    x1: 14.704,
    y1: 49.392,
    x2: 42.578,
    y2: 33.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#5055A5"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#A8ABF2"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__e",
    x1: 19.459,
    y1: 41.903,
    x2: 26.628,
    y2: 41.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__f",
    x1: -6.305,
    y1: 40.048,
    x2: 35.382,
    y2: 15.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.165,
    stopColor: "#606060"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__g",
    x1: 11.361,
    y1: 3.571,
    x2: 23.035,
    y2: 23.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__h",
    x1: 33.776,
    y1: 4.104,
    x2: 12.417,
    y2: 16.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__i",
    x1: 38.109,
    y1: 56.431,
    x2: 31.252,
    y2: 52.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__j",
    x1: 35.853,
    y1: 59.737,
    x2: 24.491,
    y2: 53.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__k",
    x1: 19.459,
    y1: 41.903,
    x2: 26.628,
    y2: 41.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#FFC538"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__l",
    x1: -6.305,
    y1: 40.048,
    x2: 35.382,
    y2: 15.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.022,
    stopColor: "#E37C34"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.69,
    stopColor: "#F1C43D"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__m",
    x1: 11.361,
    y1: 3.571,
    x2: 23.035,
    y2: 23.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F7E041"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#FCF3B3"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "title-winner-icon_svg__n",
    x1: 33.776,
    y1: 4.104,
    x2: 12.417,
    y2: 16.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#FFC538"
  })))));
};
/* harmony default export */ var title_winner_icon = (SvgTitleWinnerIcon);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/GithubFilled.js
// This icon file is generated automatically.
var GithubFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] }, "name": "github", "theme": "filled" };
/* harmony default export */ var asn_GithubFilled = (GithubFilled);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 2 modules
var AntdIcon = __webpack_require__(84089);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/GithubFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GithubFilled_GithubFilled = function GithubFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_GithubFilled
  }));
};

GithubFilled_GithubFilled.displayName = 'GithubFilled';
/* harmony default export */ var icons_GithubFilled = (/*#__PURE__*/react.forwardRef(GithubFilled_GithubFilled));
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlayCircleFilled.js + 1 modules
var PlayCircleFilled = __webpack_require__(67874);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/index.styled.ts
function WinnerTeam_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function WinnerTeam_index_styled_templateObject() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        ""
    ]);
    WinnerTeam_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject1() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        ""
    ]);
    WinnerTeam_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject2() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    WinnerTeam_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject3() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 32px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: stretch;\n"
    ]);
    WinnerTeam_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject4() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        ""
    ]);
    WinnerTeam_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject5() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  //overflow: auto;\n  position: relative;\n  padding: 16px 24px;\n  #description {\n    display: none;\n    position: absolute;\n    width: calc(100% - (3 * 24px));\n  }\n  &:hover {\n    #basic {\n      display: none;\n    }\n    #description {\n      display: unset;\n    }\n  }\n"
    ]);
    WinnerTeam_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject6() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: ",
        "px;\n  border: 1px solid rgba(237, 237, 237, 0.2);\n  //height: 100%;\n  min-height: 360px;\n  width: ",
        "px;\n"
    ]);
    WinnerTeam_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject7() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    WinnerTeam_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject8() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  //width: 285px;\n  //width: 160px * 1.25;\n  //height: 90px * 1.25;\n  width: ",
        "px;\n  height: ",
        "px;\n  background: #a56161;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    WinnerTeam_index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject9() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-top: 16px;\n  font-weight: 600;\n  font-size: 16px;\n  color: #ffffff;\n"
    ]);
    WinnerTeam_index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject10() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-top: 8px;\n  font-weight: 400;\n  font-size: 14px;\n  /* M1 */\n  color: #ffffff;\n"
    ]);
    WinnerTeam_index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject11() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 100%;\n  font-size: 16px;\n  line-height: 2;\n  color: #ffffff;\n"
    ]);
    WinnerTeam_index_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject12() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        "\n  //position: relative;\n  margin-top: 24px;\n  a {\n    color: #fff;\n    height: 24px;\n    line-height: 1;\n  }\n  svg:hover,\n  a:hover {\n    color: ",
        ";\n  }\n"
    ]);
    WinnerTeam_index_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function WinnerTeam_index_styled_templateObject13() {
    var data = WinnerTeam_index_styled_taggedTemplateLiteral([
        ""
    ]);
    WinnerTeam_index_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var index_styled_MyContainer = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject());
var Section = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject1());
var index_styled_SectionTitle = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject2());
var SectionBody = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject3());
var Column = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    lg: 6,
    md: 8,
    sm: 12,
    xs: 24
})(WinnerTeam_index_styled_templateObject4());
var Item = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject5(), mixins/* transition */.eR());
var sizePxPadding = 10;
var sizePxWidth = 320;
var sizePxHeight = 180;
var Card = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject6(), sizePxPadding, sizePxWidth + 2 * sizePxPadding);
var Content = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject7());
var Picture = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject8(), mixins/* transition */.eR(), sizePxWidth, sizePxHeight);
var Name = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject9(), mixins/* transition */.eR());
var Bonus = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject10(), mixins/* transition */.eR());
var Description = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject11(), mixins/* transition */.eR());
var Action = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject12(), function(param) {
    var $color = param.$color;
    return $color;
});
var ActionItem = styled_components_browser_esm/* default.div */.ZP.div(WinnerTeam_index_styled_templateObject13());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/index.tsx
function WinnerTeam_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WinnerTeam_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WinnerTeam_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function WinnerTeam_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = WinnerTeam_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function WinnerTeam_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var WinnerTeam_WinnerTeam = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = WinnerTeam_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_MyContainer, WinnerTeam_objectSpread({}, rest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_SectionTitle, {
                        style: {
                            color: data.application.color
                        },
                        children: data.application.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionBody, {
                        children: data.application.items.map(function(value, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamItem, {
                                value: value,
                                color: data.application.color
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                style: {
                    marginTop: 48
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_SectionTitle, {
                        style: {
                            color: data.production.color
                        },
                        children: data.production.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionBody, {
                        children: data.production.items.map(function(value, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamItem, {
                                value: value,
                                color: data.production.color
                            }, index);
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var hackathon2022_WinnerTeam = (WinnerTeam_WinnerTeam);
function TeamItem(param) {
    var value = param.value, color = param.color;
    //const [showOverLayer, setShowOverLayer] = useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "basic",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), WinnerTeam_objectSpread({}, value.pictureImage, {
                                        alt: value.name
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                    children: value.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bonus, {
                                    children: value.prize
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "description",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                children: value.description
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                    $color: color,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                        size: 16,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: value.githubUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_GithubFilled, {
                                        style: {
                                            fontSize: 24
                                        }
                                    })
                                })
                            }),
                            !value.playbackUrl.startsWith("http") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                title: value.playbackUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleFilled/* default */.Z, {
                                            style: {
                                                fontSize: 24
                                            }
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: value.playbackUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleFilled/* default */.Z, {
                                        style: {
                                            fontSize: 24
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: value.rfcUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionItem, {
                                    children: "RFC"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/FinalistTeam/index.styled.ts
function FinalistTeam_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FinalistTeam_index_styled_templateObject() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    FinalistTeam_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject1() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        "\n  //width: 100%;\n  overflow: hidden;\n"
    ]);
    FinalistTeam_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject2() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 16px;\n"
    ]);
    FinalistTeam_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject3() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  overflow: hidden;\n  width: 100%;\n\n  table {\n    background: #282a36;\n    border: 1px solid rgba(237, 237, 237, 0.2);\n    font-weight: 500;\n    font-size: 14px;\n    color: #ffffff;\n    width: 100%;\n    thead {\n      tr {\n        padding: 0 !important;\n        th {\n          text-align: left;\n          white-space: nowrap;\n        }\n      }\n    }\n    tbody {\n      tr {\n        border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n        td {\n          div {\n            overflow: hidden;\n            height: 20px;\n            line-height: 20px;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    FinalistTeam_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject4() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        "\n  color: #ffffff;\n"
    ]);
    FinalistTeam_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject5() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        ""
    ]);
    FinalistTeam_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject6() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        "\n  font-size: 24px;\n  letter-spacing: 0.2em;\n"
    ]);
    FinalistTeam_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject7() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        "\n  color: #efefef;\n  //margin-top: 24px;\n  font-size: 12px;\n  line-height: 2;\n"
    ]);
    FinalistTeam_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject8() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 24px;\n  a {\n    color: #fff;\n    height: 24px;\n    line-height: 1;\n  }\n  svg:hover,\n  a:hover {\n    color: ",
        ";\n  }\n"
    ]);
    FinalistTeam_index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function FinalistTeam_index_styled_templateObject9() {
    var data = FinalistTeam_index_styled_taggedTemplateLiteral([
        ""
    ]);
    FinalistTeam_index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var FinalistTeam_index_styled_MyContainer = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject());
var index_styled_Section = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject1());
var FinalistTeam_index_styled_SectionTitle = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject2());
var index_styled_SectionBody = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject3());
var Tooltip = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject4());
var TeamName = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject5());
var TooltipProjectName = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject6());
var TooltipIntroduction = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject7());
var TooltipAction = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject8(), function(param) {
    var $color = param.$color;
    return $color;
});
var TooltipActionItem = styled_components_browser_esm/* default.div */.ZP.div(FinalistTeam_index_styled_templateObject9());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/production-0.jpg
/* harmony default export */ var production_0 = ({"src":"https://img1.tidb.net/_next/static/media/production-0.b51b78f3.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDBBExBSFB/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABgRAQADAQAAAAAAAAAAAAAAAAEAAhEh/9oADAMBAAIRAxEAPwCHHXc3bVKWFsji1745ckFmC7wdHW0RElgHkPXJ/9k="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/production-1.jpg
/* harmony default export */ var production_1 = ({"src":"https://img1.tidb.net/_next/static/media/production-1.46ec8850.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAH/xAAfEAABBAICAwAAAAAAAAAAAAABAAIDEQQFEiEGMVH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABcRAQEBAQAAAAAAAAAAAAAAAAEAIQL/2gAMAwEAAhEDEQA/AIfJ9jHtn4PMOIzmxCUk2GiPnVA1XVfe/aIil6wCc1b/2Q=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/production-2.jpg
/* harmony default export */ var production_2 = ({"src":"https://img1.tidb.net/_next/static/media/production-2.22ddf72a.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDBAVBERIV/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwb/xAAXEQEBAQEAAAAAAAAAAAAAAAACAQAh/9oADAMBAAIRAxEAPwCSc56MTKpxtCv1c0iWGANeeNE7REVWAYeTBd//2Q=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/production-3.jpg
/* harmony default export */ var production_3 = ({"src":"https://img1.tidb.net/_next/static/media/production-3.88ac4b69.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAABBAIDAQAAAAAAAAAAAAABAAIDBAUREyEkUf/EABUBAQEAAAAAAAAAAAAAAAAAAAIE/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIRAxEAPwCQt5yC9RZRZhMdWcC30RRnkOvpJ72iIqMgkFv/2Q=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/production-4.jpg
/* harmony default export */ var production_4 = ({"src":"https://img1.tidb.net/_next/static/media/production-4.d2c255d2.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFAABAAAAAAAAAAAAAAAAAAAAAP/EAB8QAAECBgMAAAAAAAAAAAAAAAEAAgMEBQYSIRETMf/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAZEQEAAgMAAAAAAAAAAAAAAAABAAIRIVH/2gAMAwEAAhEDEQA/AFZu+alLjp8u2A3rLzGeBEcMwQRgeSda9CIiHbCVXkQG2f/Z"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/production-5.jpg
/* harmony default export */ var production_5 = ({"src":"https://img1.tidb.net/_next/static/media/production-5.5d251bed.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAABBAEFAQAAAAAAAAAAAAABAAIDBBEFEyEiMjP/xAAVAQEBAAAAAAAAAAAAAAAAAAABBv/EABsRAAEFAQEAAAAAAAAAAAAAAAEAAgMEEQVR/9oADAMBAAIRAxEAPwCYdTguGCtLTyWsMUT9z59vWAOSiInTpU91bc1d7WxnBngX/9k="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/production-6.jpg
/* harmony default export */ var production_6 = ({"src":"https://img1.tidb.net/_next/static/media/production-6.81dbd11a.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAABAwMFAAAAAAAAAAAAAAABAAQRAhIhBTEzQVH/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AJvUW7ehrx1EETdebpx3tGfERFQf/9k="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/production-7.jpg
/* harmony default export */ var production_7 = ({"src":"https://img1.tidb.net/_next/static/media/production-7.13b44276.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAAABgIDAAAAAAAAAAAAAAAAAQIDBAUhQREjMf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACIf/aAAwDAQACEQMRAD8Aj514zYw0Q00tdEURp72GjS5j3PO9gACwchpv/9k="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/application-0.jpg
/* harmony default export */ var application_0 = ({"src":"https://img1.tidb.net/_next/static/media/application-0.761dd486.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAACAgMBAQAAAAAAAAAAAAABAgADBBEhBTH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAGREAAwADAAAAAAAAAAAAAAAAAAECAxEx/9oADAMBAAIRAxEAPwCZie61vm1ZN+HQ7vdolQVLcbrHfTsD5qIiPiUp4DyN7P/Z"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/application-1.jpg
/* harmony default export */ var application_1 = ({"src":"https://img1.tidb.net/_next/static/media/application-1.5ecac054.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABAwUBAAAAAAAAAAAAAAABAAIEAwUREjEj/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAXEQADAQAAAAAAAAAAAAAAAAAAAQIh/9oADAMBAAIRAxEAPwCTgXaRcYjrezxfRy51bJduACQNeDiIisnQapo//9k="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/application-2.jpg
/* harmony default export */ var application_2 = ({"src":"https://img1.tidb.net/_next/static/media/application-2.6f99e3fb.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAABBQADAAAAAAAAAAAAAAABAAIDBBETQVH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAv/EABURAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIRAxEAPwCBNNXFiOoaMJMlRruUaHBxJG+daiIrGN//2Q=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/application-3.jpg
/* harmony default export */ var application_3 = ({"src":"https://img1.tidb.net/_next/static/media/application-3.abc6c0b3.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAgEAABAgUFAAAAAAAAAAAAAAABAAQCAwUhMRETFCOR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIh/9oADAMBAAIRAxEAPwCTW6g3hYtaaWswnQ7k3kHsucgjNvERE3lB03//2Q=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/application-4.jpg
/* harmony default export */ var application_4 = ({"src":"https://img1.tidb.net/_next/static/media/application-4.0e0dfcd0.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAACAgIDAQAAAAAAAAAAAAABAgADBRIEEVGh/8QAFQEBAQAAAAAAAAAAAAAAAAAABAX/xAAXEQADAQAAAAAAAAAAAAAAAAABAhEA/9oADAMBAAIRAxEAPwCdrz1tfCvxqq6upBW1XAAHmuv3uIiUkdhYcdxZd//Z"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/application-5.jpg
/* harmony default export */ var application_5 = ({"src":"https://img1.tidb.net/_next/static/media/application-5.f3209b74.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAABBQEBAQAAAAAAAAAAAAABAAIDBAURIzH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABYRAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEQMRAD8AkLm3Bo1GUm4udULSPeCMiQ8B+kk96iIr5CLf/9k="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/application-6.jpg
/* harmony default export */ var application_6 = ({"src":"https://img1.tidb.net/_next/static/media/application-6.3e7b6385.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAABAwUAAwAAAAAAAAAAAAADAAECBAUGERIhUYH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABcRAQEBAQAAAAAAAAAAAAAAAAECACH/2gAMAwEAAhEDEQA/AIuNZDcLrMtPVzgQpC7gacOnHz5fTen38RETm0OadSL3f//Z"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/WinnerTeam/pictures/application-7.jpg
/* harmony default export */ var application_7 = ({"src":"https://img1.tidb.net/_next/static/media/application-7.9604a3b8.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAIDAQAAAAAAAAAAAAABAAIDBDFBBQYRE//EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAGREBAAIDAAAAAAAAAAAAAAAAAgAhAREx/9oADAMBAAIRAxEAPwCFL2InjrVKam2WcPcyOf6EBmB6GjedoiK4pY3cB32f/9k="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ParticipationWelfare/icon-0.svg
var icon_0_path;
function icon_0_extends() { icon_0_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_0_extends.apply(this, arguments); }

var SvgIcon0 = function SvgIcon0(props) {
  return /*#__PURE__*/react.createElement("svg", icon_0_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_0_path || (icon_0_path = /*#__PURE__*/react.createElement("path", {
    d: "M32 22a8 8 0 0 1 8-8h16a2 2 0 0 1 2 2v32a2 2 0 0 1-2 2H40a8 8 0 0 0-8 8M6 48a2 2 0 0 0 2 2h16a8 8 0 0 1 8 8V22a8 8 0 0 0-8-8H8a2 2 0 0 0-2 2v32Z",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var icon_0 = (SvgIcon0);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ParticipationWelfare/icon-1.svg
var icon_1_path, icon_1_path2;
function icon_1_extends() { icon_1_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_1_extends.apply(this, arguments); }

var SvgIcon1 = function SvgIcon1(props) {
  return /*#__PURE__*/react.createElement("svg", icon_1_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_1_path || (icon_1_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.625 50.375c-2.3-2.3-.775-7.125-1.95-9.95C10.5 37.6 6 35.125 6 32c0-3.125 4.45-5.5 5.675-8.425 1.225-2.925-.35-7.65 1.95-9.95 2.3-2.3 7.125-.775 9.95-1.95C26.4 10.5 28.875 6 32 6c3.125 0 5.5 4.45 8.425 5.675 2.925 1.225 7.65-.35 9.95 1.95 2.3 2.3.775 7.125 1.95 9.95C53.5 26.4 58 28.875 58 32c0 3.125-4.45 5.5-5.675 8.425-1.225 2.925.35 7.65-1.95 9.95-2.3 2.3-7.125.775-9.95 1.95C37.6 53.5 35.125 58 32 58c-3.125 0-5.5-4.45-8.425-5.675-2.925-1.225-7.65.35-9.95-1.95Z",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), icon_1_path2 || (icon_1_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M43 26 28.325 40 21 33",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var icon_1 = (SvgIcon1);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ParticipationWelfare/icon-2.svg
var icon_2_path;
function icon_2_extends() { icon_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_2_extends.apply(this, arguments); }

var SvgIcon2 = function SvgIcon2(props) {
  return /*#__PURE__*/react.createElement("svg", icon_2_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_2_path || (icon_2_path = /*#__PURE__*/react.createElement("path", {
    d: "M54 20H10a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-2 12v18a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2V32m20-12v32m11.325-34.825C40.475 20 32 20 32 20s0-8.475 2.825-11.325a6.01 6.01 0 1 1 8.5 8.5v0Zm-22.65 0C23.525 20 32 20 32 20s0-8.475-2.825-11.325a6.01 6.01 0 1 0-8.5 8.5v0Z",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var icon_2 = (SvgIcon2);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ParticipationWelfare/icon-3.svg
var icon_3_path, icon_3_path2;
function icon_3_extends() { icon_3_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_3_extends.apply(this, arguments); }

var SvgIcon3 = function SvgIcon3(props) {
  return /*#__PURE__*/react.createElement("svg", icon_3_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_3_path || (icon_3_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 54V14a2 2 0 0 1 2-2h44a2 2 0 0 1 2 2v40l-8-4-8 4-8-4-8 4-8-4-8 4Zm28-26h12m-12 8h12",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), icon_3_path2 || (icon_3_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M28 24H16v16h12V24Z",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var icon_3 = (SvgIcon3);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ParticipationWelfare/icon-4.svg
var icon_4_path, icon_4_path2;
function icon_4_extends() { icon_4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_4_extends.apply(this, arguments); }

var SvgIcon4 = function SvgIcon4(props) {
  return /*#__PURE__*/react.createElement("svg", icon_4_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_4_path || (icon_4_path = /*#__PURE__*/react.createElement("path", {
    d: "M38 20v30.925a1.974 1.974 0 0 0 .9 1.675l2.75 1.825a2 2 0 0 0 3.05-1.175L48 40",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), icon_4_path2 || (icon_4_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M48 40a10 10 0 0 0 0-20H38S24.375 20 11.275 9.025A2 2 0 0 0 8 10.55v38.9a2 2 0 0 0 3.275 1.525C24.375 40 38 40 38 40h10Z",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var icon_4 = (SvgIcon4);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ParticipationWelfare/icon-5.svg
var icon_5_path, icon_5_path2;
function icon_5_extends() { icon_5_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_5_extends.apply(this, arguments); }

var SvgIcon5 = function SvgIcon5(props) {
  return /*#__PURE__*/react.createElement("svg", icon_5_extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_5_path || (icon_5_path = /*#__PURE__*/react.createElement("path", {
    d: "M42 38c8.837 0 16-7.163 16-16S50.837 6 42 6s-16 7.163-16 16 7.163 16 16 16Zm11.325-4.675-22.65-22.65M25 39l-3 3",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), icon_5_path2 || (icon_5_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M26.2 24.475 7.025 50.625a1.975 1.975 0 0 0 .2 2.6l3.55 3.55a1.975 1.975 0 0 0 2.6.2L39.525 37.8",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var icon_5 = (SvgIcon5);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/陈昱.png
/* harmony default export */ var _ = ({"src":"https://img1.tidb.net/_next/static/media/陈昱.55487781.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAeFBMVEVMaXHYvrCfl5GFYFj8+vnPxLncsJzg2NCpfm3FvrlPPzptVk2VeW349/b//Pv08vDv5uOSi4a9gXHc1s4lLzvr5+b79vQaIC3b1c1ta2sOFCIPGCXFlYf59/aUjYilnJbSmol6c3hXUFOCenU9MzTl4+L0yLhtZGd3cEiJAAAAHHRSTlMA+uH+KiL+p/72+P758cSw/Rz+9NA70Dv38SzEIqUx1QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEdJREFUCJkFwYUBgDAQBLArVHHXfg3bf0MSQChjWg702XWXvuZQrsht9TQYnbbWdoTNySG8RFCe6cBogdiTll+cgeNMcVrxA5exBK1xIYDoAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/Chuang Pei-Han-特约嘉宾.png
/* harmony default export */ var Chuang_Pei_Han_ = ({"src":"https://img1.tidb.net/_next/static/media/Chuang Pei-Han-特约嘉宾.f8647a97.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAeFBMVEVMaXH//v4AAAAXGyT8+/qxpJzf3dz8/Pz////////Qu7b///+2i3vfrZj+/v6kZ0axeFmxsrFBJxT4+PimpqQ0IRL26ONwdH/JycmrY0Gnl4xuSDDU1Nb///8dHR2PVDKHZVDFnpT2+PlVVVLKnYAMCwxNUFaLXUL8T9whAAAAIXRSTlMAyjPLHPz+pyn2/uH+/rD+/vT58ff+/vL5/vr9O/////79DYx2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAARklEQVQImQXBhQHAIBAEsMOhRt0fqe0/YhNAmm40FpClStM9WJhL1W2vGRwVlY+a4GjO20OEhtYcd2KwS0jH+50AFyEIjh+QCgRsJTtILwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/高斌.png
/* harmony default export */ var avatar_ = ({"src":"https://img1.tidb.net/_next/static/media/高斌.e714dd08.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEVMaXH3+Pn+/ftya4GTk5e7lnOAZUjf3dv+/v62gmKFhYn9//+jgWPImnno6uyAVzj////49/ZscHW/sqFXV1y5p5T5+Pdvc3r09fX///+mlIO0iWnQspesf1l1TzKwra9uYGvn6u6+uLfcY8h1AAAAGHRSTlMAqirK+f75IPT+O+H+/qP+xLDx+Sz60P47fXQ4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVQImQXBBQKAMAwEsJsLMpx2gv3/kSSAG7UWEnBdvlL2EoKsGSxN8NSHUojhuYZQmTHT2tr+HnDLbcx3RmBT+lERP3wxA8Uw8qD6AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/郭磊涛.png
/* harmony default export */ var Judge_avatar_ = ({"src":"https://img1.tidb.net/_next/static/media/郭磊涛.ba2bc2de.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXHKln1KS0vUoIBmY2VycHJhSz9tam1ubG9tamxTVFXfnYYkKRpxb3Jxb3F3XE7tspVbRDdnZml1c3V0amZUUELlqII3PDCAenxycHSLcmJpaW1SS0mef29gWEq4gWa5g2WpLVZgAAAAGXRSTlMA/vP+/Rz8rPQp+/4z4cT4/v6j0PrQ/cQ7wCI0XwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEZJREFUCJkVxkcSgCAQBMAhRxNGdhH9/yst+9SAKTK6AJih2aX5gMLTrCyP8ExC3LXCa0rpj9P6ebe6IsiuDooXkM9Oe8YHe7QDxSNcm6gAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/黄东旭.png
/* harmony default export */ var hackathon2022_Judge_avatar_ = ({"src":"https://img1.tidb.net/_next/static/media/黄东旭.6c9c31ed.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAXVBMVEUWHy6IZmOEZGKOa2dgU1g3ND6ynp53Y2dMaXFtU09+Y2Sdd3J/ZmUjLUB3bnRxZWqGYV1lT1JlXWORbGggLUWRaGIrNEkgHB4eLkaHcG+EX1h2Xl6PbmmDgo9LRlO7TbhHAAAAGXRSTlP+qvPK/f3+IgD9M/79yv6j4fT4sCz38f07gkbObQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAERJREFUCJkFwQcCgDAIBLDrhC73glb//0wTMM1rMsSgxb9TshlGtxh9d7AqIlIHzt5LGXVg/5A0eAe6cAeEDD4a0B7+AXbhA0pxzlSFAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/黄潇.png
/* harmony default export */ var events_hackathon2022_Judge_avatar_ = ({"src":"https://img1.tidb.net/_next/static/media/黄潇.c6df9722.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAb1BMVEVMaXHSrKh1a2hKPjnw8PGZl5gUDwz6+vr//v78/Pz///+5tr3////Pz86ioaBZRkaqqKnd3Nx+eX1fUE/hv7nz8/PmvrfCw9D84dWAfnz////b0tFXVld3W1AsJyawsLCdgnvPytHl5O3brpqhm51h0jZiAAAAGnRSTlMA/v39HPz8KvWoyjvi9Pj++bHE/v7y/tH9/fKFYBwAAAAJcEhZcwAACxMAAAsTAQCanBgAAABHSURBVAiZHcZFEoAwEATAIbYR3Nkk+P/fSBV9akC5qu4IUGXcTZoIjnUzmMPDcizGvPGfOQuG4/Z8ZPIgq8X6ygBQf91LwAeGxwPtoiqqJgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/李雨来.png
/* harmony default export */ var pages_events_hackathon2022_Judge_avatar_ = ({"src":"https://img1.tidb.net/_next/static/media/李雨来.9e7b0cab.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAgVBMVEXS19/Q2efXwMDOubTM1Obk39rp49xMaXHk3tbn39fh39rUzsbm1s5HSUzr5Nx5cHLGqp96W06xwdvGytmok4QqJSG3sKjJw7y1rbDYt6DdsrK8tKfJxMfr8PTm4tqtoJrj4t+zkIPBwMWKhYCwfm0cGhe/hHrhwqzf6fuoqrDjz8GsTHDBAAAAHnRSTlMq/P7++LDpAPmjyhz++Bz+/v79xPn+9Pf9+v070DsNHHd9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVQImQXBhQGAMAADsM6Y4O5McP4/kAQy010vIBFH+9naCNAqzcvGGShlmT9ogNoSWlzTC+FI8ONnAM6r4WYrJGryLLP8AZUJBF9p0KvNAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/刘聪.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_ = ({"src":"https://img1.tidb.net/_next/static/media/刘聪.faa6dbf0.png","height":900,"width":900,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAbFBMVEUnIh8qJSAqJCFHPTo1MSvMsKSXjINMaXGTeXB5a26YjowwLCs4Q2VPUVa+rK/GoJZmW1fCnJBnVVRxYV1DMy2MfHKXd2/ctafDsKM+SXScf3fItas/REbVqJWCdW6Yg35mXl2wioErM1B/fIHGLp+CAAAAHXRSTlP+9Lv8K/knAP36+zD8+f7+s/7+r/js/v6vvf6zuU+aQ20AAAAJcEhZcwAACxMAAAsTAQCanBgAAABFSURBVAiZBcEFAsAgDASwQ1tszB1m///jEpAdnG81wU6qb26hsdZxNg4SpnKXLwDG81IYwPFxeRQkbEq7e0UA6TPGLdAPccIDQ7S3L3IAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/刘子东.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_0 = ({"src":"https://img1.tidb.net/_next/static/media/刘子东.1a5ce397.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEX+/v7//v6VmZzN2ef9/f3w5+D9/f3myr329/lMaXHu8vRmWFP///90Z2D////+/f3+///p0cTauqnx8vPOtKYmJSni4uR0eH6Bg4XV0tLVz87oz8JBj3zZAAAAE3RSTlP2sPbKHPqj/ioAO/jh+cTQ///+vnXfhgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEFJREFUCJkFwQUCwDAIBLCrAp0Blcn/H7oEkmuMgQV5v+d8wKh9Izv6CfRhNKCAGpGpImhxL3qBsdyXNgin90tNfmQSAvXy5pV+AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/马洪宾.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_1 = ({"src":"https://img1.tidb.net/_next/static/media/马洪宾.7d297eb5.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAclBMVEVMaXGHZE+zfWAVLXwNIWkQJ3heTFcNJnQJG1sdNYM4Qm7s7vgKG2ARGzPYm3QUK4IQKXVZRTlyaXULEz0zJxl/h5+6ub53ZVxtfqvHztUHGFYKHmWccVuFdn8IGlEULX0zLTAlMF6lqsB3VECfkY+GmLsc3ko/AAAAG3RSTlMA/v7KHOn+/PYv+jOj+P6jsP75sCjxxP3+0PqT8jAtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVQImUXGRxKAIBAEwEFAWDBnawnG/3/Ro31qQLXZdgQonY7+1ISKa9EMRsJyGYpo8p8xuTs4lpjmS6zvRoBfnrh7fIfQBB+NVUe8AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/沈旸.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_2 = ({"src":"https://img1.tidb.net/_next/static/media/沈旸.69664450.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEUpLjMjJy4mKjDDoYUhHh8xMTMpLjQhJi5MaXERERIoLDFzYlKUdl8mKS+ad11NOy81MjIAAABQTlSTjok4PUMTGiRCTVgnKzApLjMeIyljSjq4k3YAAACEbFgtQFVkgJ1WX2kb98GPAAAAGHRSTlP0HKP++f3IKgD9sPz+4f7++f79/Ts70KlXtbvwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVQImQXBhxHAIAwEsKfaQAqpZ0Pa/lNGAhvrfSaGGdO1JBCsplaCRkD94G4RQObJ9RqQQ229SARB1+2THUzxec+Df2e/A2LFx+LgAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/孙晓光.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_3 = ({"src":"https://img1.tidb.net/_next/static/media/孙晓光.493de5b8.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAbFBMVEXg4dv17+QfJDluT0eRg3/p6+S6t7NMaXH5+feHbWlwZmp/iZhpWlnc3dnazsdrcXkcJ0tLVGi5uLZzU1NSPjjp5tzZ2dbe4d+yo5uBiJGxrKp9Yl++vrx3VUyad24tKTPNzMmNc3KXjogVGStAuwqDAAAAG3RSTlP6Ksr+/KP2ABz+/Dv44f4oLPGw/v2w/cT6/tAfi6Z0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVQImQXBBQKAMAwEsJvRCe7QGfD/P5KArGmaTRBsp5lfCJjYOvb1AKLj5dkB9DmpjIo56pRO3Bimsip/BdAovyID/YPkA+e1AyKsAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/唐刘.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_4 = ({"src":"https://img1.tidb.net/_next/static/media/唐刘.44968be1.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEWnn5ynp622srZrVEu1srWxjoSxsLWzsLNMaXG3n5Gtp6qglZGggHN7X1GkpaxfXmwrKj2AamtzZGiCbGm+u7uuqquXkpJ7dXSrpaSUdnCrqq6mi4SsiXqRg4BtYWKqpqqNbWaztLlYQzyrSyrmAAAAHXRSTlP9O6r7Kf7K9wD+HP39+fEsxP7Q/rDh9/Sj/////rP3U/YAAAAJcEhZcwAACxMAAAsTAQCanBgAAABFSURBVAiZBcEHAoAgDASwY7bg3rLV/z/SBOzv69w1wx/1U4U0JFQyAyyobUsIXQRRCsahQb54smsWeix9dlGAp7mmVfAPhlIDzZ4EV24AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/王聪.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_5 = ({"src":"https://img1.tidb.net/_next/static/media/王聪.3a8ada39.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAhFBMVEVMaXFVOE4gFRxiQTU+UGV2Z23b3ucnIiaMYVeDdXNGS08qJCyxfmuu6v8ZGR4tKTbBzd3Fs7DYxsAsMDpYW2Wncm1eT1c0Rl9yRkrx+v5pYHWFTVusqr1xQUZiRkePZ2Q5JShyUV2IaGyQd43///93hpaEXlIUFiFEMTuepbRKPkGkvNGTNmaYAAAAI3RSTlMAO6P4JPv9Kf6w4cT+HPT5o/f08f7++fH9xPr+0ND//////rVtSVMAAAAJcEhZcwAACxMAAAsTAQCanBgAAABISURBVAiZBcEFAoAgAASwQwXE7pa2//8/NyAKCio4kCf6jN8xQnWEmRq+Gc0jY0WZR93J3jjmIa5S2cVt4O09WbMSgKda7gQ/qJ8FBk+vOMkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/吴海燕.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_6 = ({"src":"https://img1.tidb.net/_next/static/media/吴海燕.530ffaee.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEUzMjNJSk1HSEpEREYhFhGEZFRRT1FMaXFGRUcuKytDREdPTU8lJig5KyTls58xMDNERUfsvqg7OjxvU0fWnozSpohmY2c7Oz3Akn9fRTpBQkTYwrNEREeneGv34IEgAAAAF3RSTlP8HKOw/f75ACr+8cr9+f474f7Q/v79xFhZSYIAAAAJcEhZcwAACxMAAAsTAQCanBgAAABDSURBVAiZBcEHAoAgDASwY7ZlugHB/3/TBKQ0YJigNlgrgaGbdT0jwsu5l5EWvLhyjfTCrNw/aQc4+NuhVRA/c8ZKP1jcAwE3bW2NAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/谢孟军.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_7 = ({"src":"https://img1.tidb.net/_next/static/media/谢孟军.79b7ab5c.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAh1BMVEVMaXH69/jx7e6AV0dINjMzKCZyZWKwclDgqZewazObcGfvtakjKVXMfj+1gWR5SSs8HyFOLhbWyMaolo75yLmgeG338/ZnLwTJezw4OllKMzmAfImKa4HEvb9yVkvYrKOqbVLU0NMoLlSVZk9WTlGMYE/49/pgNyXhsKXNnJE0NEdNTWXcpq06HVsjAAAAH3RSTlMAKvcq+/v6HP76/P47o+H+sPejsP75xPnxxP3Q0P39B17dZQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEpJREFUCJkFwQUCgCAABLATkBC7W8CO/7/PDRA5zwoPEPHmM048RCuTZWVrqD2Qy0IO+InR+posUtWYO3gH0Pbs58eFAO3cN4b4AY9WBK8XYVmIAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/徐成选.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_8 = ({"src":"https://img1.tidb.net/_next/static/media/徐成选.ca68175e.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAe1BMVEVMaXFbZnXSta68pqTJ2PZxbnS8n5jV5PrB0/Tf7P/G1fTQy9PErqy1xuScrchlVVCbqMNqfJOPgoK3xuRRis7a2eLInJgAPacAV7M7d8EKV7IOXLSSsdzG1/fE0vGltdLLuLbRrZy9xuFxYFt2lr/Tx8dVfK8LXK8OW6+knSMnAAAAIXRSTlMA+/7+qvz+Kfkcyvz+4aP+sPT58fH5/izE/jvQO/7///6r7t1NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAR0lEQVQImQXBhQGAMAADsM6Y4W4z/P8LSQBdNqSWgC7IWYlOggfBsjYYqCOnWfQeylk63s6DuyElqwxkf0X2LDswze+3rfgBg98EXNEWXx8AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/avatar/张东晖.png
/* harmony default export */ var src_pages_events_hackathon2022_Judge_avatar_9 = ({"src":"https://img1.tidb.net/_next/static/media/张东晖.a5307628.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEVJRkOyjHZLR0TOqI97YlBjT0BOR0M7ODZMaXFRTkwjIiFAPTtKREBPSkcvLSwfHyA7ODY/ODM7OTYvLi3Zt52jgmyWe2m8moUTExQVFRY2MCuMbFRAPjwCTMX1AAAAGXRSTlP8/sr+/f3+KgD99ukcqjvEsPmj8f7+/v7QXiYrjAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAENJREFUCJkFwQcCgCAMBLBjtmW6tcD/32kCLkdKGzFKHiGMTKjLXy4sC8T7NR6AyOOMR0SVfc4oFnSqqo4Gpq76Nf4BZ9wDJ3u1DJoAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-1-1.png
/* harmony default export */ var logo_1_1 = ({"src":"https://img1.tidb.net/_next/static/media/logo-1-1.aa1d3e59.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEX29fX////s7e31y8336+zy29zz8PDeAFWFAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHklEQVQImWNghAIGBiZWZmYmJgYGRgYGFhYQBZMCAANOACzGjwCOAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-1-2.png
/* harmony default export */ var logo_1_2 = ({"src":"https://img1.tidb.net/_next/static/media/logo-1-2.9f5775ba.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEX///+wxNTQ2eKnuMq+y9jq8PR5pcL19/mRuM8swxjgAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHklEQVQImWNggAFWDkYmZmYWBgZWNkYmRkYWdrgMAAPwADYjlXR5AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-1-3.png
/* harmony default export */ var logo_1_3 = ({"src":"https://img1.tidb.net/_next/static/media/logo-1-3.18a69442.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEXt7e3////09PTp6enf39/KysrV1dWz9lFDAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAH0lEQVQImTXJsQEAAATAsFL8f7KFrCEOTgEmdmEKXwsECQA3yBp0rgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-1-4.png
/* harmony default export */ var logo_1_4 = ({"src":"https://img1.tidb.net/_next/static/media/logo-1-4.ebe1a525.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX7+/vKzdX////n5+jZ2t6+wMTp6u3f4eahDsgGAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIklEQVQImSXBAQ4AIAjEsA0O+f+PjbGF+uiO0UNmR22geC4FagBD6lyJFQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-2-1.png
/* harmony default export */ var logo_2_1 = ({"src":"https://img1.tidb.net/_next/static/media/logo-2-1.c14fa564.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEX///77+/vy8vP9+fDb3eChpq21usKpr7bt28Hy4cjx4MW+KjToAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJUlEQVQImRXBiQ0AIBDDsLT3wv4DI2yQhAQ5XdOVxLlrWxDB9wAG5gBdjG1xHAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-2-2.png
/* harmony default export */ var logo_2_2 = ({"src":"https://img1.tidb.net/_next/static/media/logo-2-2.1cf0889a.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEX////s6Orl5+z36+Hz9PTw+P/i5efY3efz7+2RuTAiAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHklEQVQImWNggAFWJmY2RiZGFgZWRmZ2ZiY2FrgMAAPnADio4yE/AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-2-3.png
/* harmony default export */ var logo_2_3 = ({"src":"https://img1.tidb.net/_next/static/media/logo-2-3.b59d49d1.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEX////2+vzw8fLX5fDh7/ne4uTn6ery/DbdAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIUlEQVQImWNgYGBgZGFkAAFGFmYIg42VGcJiZGJiYmAAAAK9ACnFI30sAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-2-4.png
/* harmony default export */ var logo_2_4 = ({"src":"https://img1.tidb.net/_next/static/media/logo-2-4.924f838a.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEXa3Nv///++vb21tbXExMSMyp7B4cnGxsb8/fz/gDegAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIElEQVQImWNghAIGNlYGJhZ2JgYQg5mJhZmBgZEDIgUABRoASXTurGkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-2-5.png
/* harmony default export */ var logo_2_5 = ({"src":"https://img1.tidb.net/_next/static/media/logo-2-5.b3dfeefd.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX////O3ei80eDa5u6HrMeux9qux9l1oL/M2COHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHElEQVQImWNggAMmFkZGNiYGBgZWdmZmRkaEBAACqgAl7LtOxgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-1.png
/* harmony default export */ var logo_3_1 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-1.af08644e.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAACVBMVEX+///o+fvT7vEC9hD6AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHUlEQVQImWNgYGBgZGSAABiDkYkJwmJiYmJiYAAAAQUAE19zypgAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-2.png
/* harmony default export */ var logo_3_2 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-2.06c88160.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX////X2tnMzMzBwcHj5uWb3+F2ybPd0mbx83JvAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHElEQVQImWNggANGdhZmZkYGBgZWNhYmJhADCgAC9QAoKAmowAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-3.png
/* harmony default export */ var logo_3_3 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-3.b48ae945.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEXd3+L////V19vk5ee4vcKvs7jWbt/AAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAG0lEQVQImWNghAIGJhZmBgYGBkYGJlYoAyYFAALgACZLV4SrAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-4.png
/* harmony default export */ var logo_3_4 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-4.79e93a23.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEX+/v/5/P+pwP+Vsf+z4Pzd6f6x0/8l8QsdAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVQImWNgYAQBBgYGRhYmZmYmVhCLiZmJjYUBBBgZgHIAA3cAL8/rDeMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-5.png
/* harmony default export */ var logo_3_5 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-5.898de2e3.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEX+//6Guu6u0vDx9/213b6l1rCb06+Qz6SWxOrUrTJgAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNggAFmRiZGJnYWCIODjRUuwQAAAzcAL9Yo8F8AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-6.png
/* harmony default export */ var logo_3_6 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-6.44fae174.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAD1BMVEX///+7zeKhuNXL1+elvNgWw0wYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGUlEQVQImWNggANmRiYmRkYwg4WRhQkhAQAB1AAaCA0MGgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-7.png
/* harmony default export */ var logo_3_7 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-7.fedc616e.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEXm+O3I8Nqy58X////0/Pfe9OWD3aotyKwiAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIElEQVQImWNghgIGBiYmBgYGVhYGBjYmVkZGRhYGmBQABaYAUhTtyuUAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-8.png
/* harmony default export */ var logo_3_8 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-8.7bf30949.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEXv7/Dp6en////g8vvH6Pi/5feUliadAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHElEQVQImWNgggIGZlYGCGBmYWBkZGRkYIBJAQAD1AA0QG16/QAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-9.png
/* harmony default export */ var logo_3_9 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-9.875995b1.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEX////u7u/V09LK4ezW1teWn+mkqeur1v6Iwfzn4+B4eSLsAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHElEQVQImWNggAM2dmZORkYGBgZWDmYmFiaEBAAD6AA0MOLtOAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-10.png
/* harmony default export */ var logo_3_10 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-10.d19b64da.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEXNzc3Z2dn////IxcPV0M792cT75dkQSUl6AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHUlEQVQImWNgggIGNhZGFkYGBkYGVmZmBjADJgUABMoAP0LfrwsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-11.png
/* harmony default export */ var logo_3_11 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-11.a7609660.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEX////t7/He4OPW2dvU5/7T1tmp0/+Vxf/b5fKD24d8AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHElEQVQImWNggAEWdkZmJiZmRgYWNhCDlREuAwADjQAwlpdh/AAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-12.png
/* harmony default export */ var logo_3_12 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-12.37e87c20.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX////W1tXg4N/S2vvw8/6Jnvbf4u5+lvkJYf3BAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHUlEQVQImWNgYGFmgABWdjYmJiYIg5GRkYEBJgUABJsAPE4FfNIAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-13.png
/* harmony default export */ var logo_3_13 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-13.a39f8aa1.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEX////g8Nfo9OLV7MrA4a6q15Lew5KZAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGUlEQVQImWNggAMWJkZmRiYGBgZWRigDCgACBAAbA54IngAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-14.png
/* harmony default export */ var logo_3_14 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-14.4bb9b4fd.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAD1BMVEX////w+P/l8v/A4P/V6f9W7ccTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHklEQVQImWNgYGBkYmJkAAFGZmYog4WZCcxgYADRAAIjABv4jQLLAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-15.png
/* harmony default export */ var logo_3_15 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-15.2d45491b.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX////i7Nvr8uWqxpXu9OqVuHvA1bC906wFvqpJAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHElEQVQImWNggAN2VmYmRhYGBgZGZjYmRkaEBAAC4wAl21m4pAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-16.png
/* harmony default export */ var logo_3_16 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-16.d549d6f6.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX14c7////+/Pr89/L68urtyqj36dvy2cLf0QtFAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJElEQVQImWNgZGZmBAEGRgZ2NjYGBiYGJlZWBgYQg5GFBSwFAAS4AD+tIYJ1AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-17.png
/* harmony default export */ var logo_3_17 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-17.311a4743.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAD1BMVEXN1eXw8vfX3erl6fL////Gkd6TAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHklEQVQImTXJsQEAIAACINT+v7mlWHEeGWWStRq/LgYSAFbGvMtEAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-18.png
/* harmony default export */ var logo_3_18 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-18.f3e6751d.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEX////k5OTBwcXe7fzo6OnNzdDe8+jW9snb29jb294aWBfpAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHklEQVQImWNggAFmdkZGRhZWFgZmNg4mJlYmTrgMAARXAEDUx459AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-19.png
/* harmony default export */ var logo_3_19 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-19.974ea42b.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEX+///d39/R0tTs9PHO7ODX7+ZgqIY1AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAG0lEQVQImWNggANGRkZWZkYGBgYmJkYWMAMKAAHcABrkKYH8AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-20.png
/* harmony default export */ var logo_3_20 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-20.b4b2c6df.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX////07e/l7/f+6OXf8PyvttC8xNpgufbe3/uoAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHklEQVQImWNgYGBgZmQAAxZWNgiLiZ2VGSLExAIkAQMOACw49A+nAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-21.png
/* harmony default export */ var logo_3_21 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-21.c0469ca0.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEX////v+fzg5enOzM1c3P/s6uex0emlyONglcfM8/5/5v89B3j0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIklEQVQImWNgYGBkZAADTi4WJmYmBgYGdg42VjCDkQksBQAE9ABE9ryjhAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-22.png
/* harmony default export */ var logo_3_22 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-22.ba04a3a7.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEX4+PnU3N7////g4ODI0uLd3d2+0tbx8/eyw9KipqeUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIElEQVQImWNgggIGdjZGFkZmZgYGBg42FkZWVgYGmBQABkcAV2drZtEAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-23.png
/* harmony default export */ var logo_3_23 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-23.689f3d5b.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEX///+5zp23vIz9+/q0wo75/PjIxGNJAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNggAFWRjBgZmBlYQIBZogwkAIAAqQAKIo1/TEAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-24.png
/* harmony default export */ var logo_3_24 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-24.fbf3d0e1.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEX////S09fDw8v66Ozq6+3y8/T//fPe3uG9zOjb5sfexZrP6NyVspzOAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIUlEQVQImWNggAFmDm4mRkZGVgZmLk4mRnYmFgYGNogUAAVNAE2QW6MiAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-25.png
/* harmony default export */ var logo_3_25 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-25.a58745de.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAKlBMVEX////R3/fY5P/p9P7k6/vi4+La+vzU1NTLycjR5OhlzO/IyNBfquPM6/yLu0LhAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJUlEQVQImWNgYGBhZGNmAAFeLh5GEM3KysnIAhJi5+BmYmJiAAAHOABuLhMcMQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-26.png
/* harmony default export */ var logo_3_26 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-26.d7c03bae.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX////Y3d6+u7rLzMjk5OTf29bJztbNvLw4TRh9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHklEQVQImWNggAEWNiZmRiZWBgYWRiZmRnZWuAQDAANvAC8ewMYoAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-27.png
/* harmony default export */ var logo_3_27 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-27.3b7f8dfc.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEX7+/ru7u709fbi4uHa2trMzMzk6PnU1NTFz/yjo6OXl5fU2vFOHFjlAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJklEQVQImSXBwQEAIAgDsWsBQd1/Xx8mePHN1OnexbqRihRYWPIDCHEAbk/c60wAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-28.png
/* harmony default export */ var logo_3_28 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-28.2f5db6e6.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEXV1tfp6Or////j5OXg4eLm9vrK3eopYXmLAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHUlEQVQImWNgggIGVjZGBhZmFkYwg4GBgZkBJgUABXAASOBfbo8AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-29.png
/* harmony default export */ var logo_3_29 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-29.f1ab618a.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAM1BMVEXq5uKVna/u7Ono6/CbutbO5/1nuP/29PLQ1d9LY5Ost8yRmqvHzduSm67c6PO94P/t9v73uV7/AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKElEQVQImQXBhwEAIAzAoKidzv5/rUCpasQePDPLzMkVkdNW4EB3/AMRggDX2l2tGwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-30.png
/* harmony default export */ var logo_3_30 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-30.b9edb3fc.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEXk5eb////d3uDw8fLp9P7i7PW/4P/U6/+lpK0BAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIElEQVQImWNghAIGFjZWBgYGJmYGFnZWBiYmJmYGmBQABIAAPtGCQhAAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-31.png
/* harmony default export */ var logo_3_31 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-31.3ad3f99d.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEX////l5ebm8PTn7O/w9/rY3+S/zNVTe5qessF+mK2JYatRAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNggAEOdjYWJmZGRgZWTlYIAwYABNwAP3RpNS0AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-32.png
/* harmony default export */ var logo_3_32 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-32.a928fb59.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJ1BMVEX////o4d3S1NTc1dK/a4Lt6/H4+Pj49/fLzc2tVF7TyLSYZH/26OoqbtHsAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVQImWNgYGBg5GIAA1ZuTh4wg5GFhRlEs3EwM3GwMwAABecAX31bw9sAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-33.png
/* harmony default export */ var logo_3_33 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-33.9c51b47e.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEX////p6Ona2trIyMjk5/2mzPjs9/R1Ea9xAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHElEQVQImWNggAEWVjZGRiZmRhCDiYmZmREuAwADsgAyK0HOrAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-34.png
/* harmony default export */ var logo_3_34 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-34.3c7bdbb7.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEX+/v7MzMvi4+Pb7P7Q09eRyv+i0f++3a+vAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIElEQVQImWNgYGBgZmaAADZWCM3ExMIEZjCyMDIyMAAAAoAAIwp52TMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-35.png
/* harmony default export */ var logo_3_35 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-35.709ff39f.png","height":240,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEX////66NXl5eXLzM3V1tfDwsLu28fS0dH9+/nsUQ7DAAAACXBIWXMAACE4AAAhOAFFljFgAAAAHUlEQVQImWNggANGRhYWZiYQg42ZlR3EYOAAywAAAt8AMA9BgdgAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-36.png
/* harmony default export */ var logo_3_36 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-36.108e65b6.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAADFBMVEX8+vb/////+O348uxzFjEZAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGElEQVQImWNghAIGZmYmBgYGJgYEAyYFAALMACWLqsSbAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-37.png
/* harmony default export */ var logo_3_37 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-37.323d9aa0.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEXq7ev19PXi4uL////e6eHd7ODykjfxAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAH0lEQVQImTXJsQEAIAwDIBLr/y+7VFac5U6CMC2NXw8FRgBIpwK9TQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/logo/logo-3-38.png
/* harmony default export */ var logo_3_38 = ({"src":"https://img1.tidb.net/_next/static/media/logo-3-38.410f5a37.png","height":160,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEX////e29v24uLl5OTy1tby1dQd08tTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNggAMmJiZGZmYQg5WFkZERIQEAAgwAHA8d+aQAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/data.tsx




//import pictureImage from './WinnerTeam/picture.jpg';























































































var signUpFormUrl = "https://forms.pingcap.com/f/hackathon-2022";
var joinGroupFormUrl = "https://pingcap.feishu.cn/share/base/shrcnaTxgdc234p8s9ri0xCXM9g";
var RfcSubmitFormUrl = "https://pingcap.feishu.cn/share/base/shrcncryHdlnkf5GfwnvrkRQ64c";
var RfcTemplateUrl = "https://pingkai.cn/tidbcommunity/forum/t/topic/903770";
var guideUrl = "https://pingkai.cn/tidbcommunity/forum/t/topic/903772";
var joinGroupHelpUrl = "https://pingkai.cn/tidbcommunity/forum/t/topic/903781";
var pptTemplateUrl = "https://docs.google.com/presentation/d/1OcIpL5MEZPPbjiSnbpnqHPwoO1cE5nBBq2oyVllmQ_4/edit?usp=sharing";
var askCompetitionUrl = "https://pingkai.cn/tidbcommunity/forum/c/Mutual-communication/Hackathon";
var scoreRule = "https://pingkai.cn/tidbcommunity/forum/t/topic/933123";
var liveUrl = "https://live.bilibili.com/4630260";
var replayUrl = "https://pingkai.cn/tidbcommunity/forum/t/topic/933124";
var ideaUrl = "https://pingkai.cn/tidbcommunity/forum/t/topic/963200";
var studyResourceUrl = "https://pingkai.cn/tidbcommunity/forum/t/topic/903772";
var dataHeader = {
    buttonItems: [
        {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderStartButtonSignUp, {
                children: "\u62A5\u540D\u5DF2\u622A\u6B62"
            })
        }, 
    ],
    navItems: [
        {
            children: "\u4ECB  \u7ECD",
            href: "#intro"
        },
        {
            children: "\u5956  \u9879",
            href: "#prize"
        },
        {
            children: "\u8BC4  \u59D4",
            href: "#judges"
        },
        {
            children: "\u5E38\u89C1\u95EE\u9898",
            href: "#faq"
        },
        {
            children: "\u5408\u4F5C\u4F19\u4F34",
            href: "#partner"
        }, 
    ]
};
var dataThemeRace = [
    {
        color: "#F67200",
        name: "\u5E94\u7528\u7EC4",
        body: "\u4EE5\u4F53\u73B0 TiDB \u4EA7\u54C1\u4EF7\u503C\u4E3A\u4E3B\uFF0C\u4F7F\u7528 TiDB \u6784\u5EFA\u4EE3\u7801\u5F00\u6E90\u7684\u4EA7\u54C1\u3001\u5DE5\u5177\u3001\u5E94\u7528\u7B49\u5747\u53EF\u3002\u90E8\u7F72\u65B9\u5F0F\u4E0A\uFF0C\u66F4\u63A8\u8350\u57FA\u4E8E Cloud \u6784\u5EFA TiDB \u76F8\u5173\u5E94\u7528\u3002\u5E38\u89C1\u5E94\u7528\u9886\u57DF\uFF1A \u6E38\u620F\u3001\u7535\u5546\u3001\u91D1\u878D\u79D1\u6280\u3001\u516C\u76CA\u7B49"
    },
    {
        color: "#00CF71",
        name: "TiDB \u4EA7\u54C1\u7EC4",
        body: "\u4E3A TiDB \u5185\u6838\u4EA7\u54C1\u4EE5\u53CA TiCDC\u3001TiDB Lightning\u3001TiUP \u7B49\u5468\u8FB9\u5DE5\u5177\u7684\u6027\u80FD\u3001\u7A33\u5B9A\u6027\u3001\u6613\u7528\u6027\u6216\u529F\u80FD\u7B49\u5404\u65B9\u9762\u505A\u51FA\u63D0\u5347\u3002"
    }, 
];
var dataWinnerTeam = {
    application: {
        name: "\u5E94\u7528\u7EC4",
        color: "#F67200",
        items: [
            {
                pictureImage: production_0,
                githubUrl: "https://github.com/Lloyd-Pottiger/DataDance",
                playbackUrl: "https://www.bilibili.com/video/BV1we411G75H/",
                rfcUrl: "https://gist.github.com/Lloyd-Pottiger/2f9bfabcfd0e86230251ebb54315cf3d",
                name: "\u56FE\u4E00\u4E50",
                description: "Data Dance\uFF0CTry TiDB online~",
                prize: "\u4E00\u7B49\u5956  \xa550,000\uFF0C\u7528\u6237\u4E4B\u9009\u5956 \xa55,000"
            },
            {
                pictureImage: production_1,
                githubUrl: "https://github.com/VelocityLight/yunji",
                playbackUrl: "https://space.bilibili.com/86485707",
                rfcUrl: "https://gist.github.com/VelocityLight/ccb4c50e569b1ee733f23a2bb97e8439",
                name: "\u4E0D\u4E0A\u73ED\u4F60\u517B\u6211\u554A",
                description: "\u4E91\u8FF9\uFF0C\u89E3\u51B3\u4F01\u4E1A\u5728\u4E91\u4E0A\u90E8\u7F72\u67B6\u6784\u4E0B\u7EDF\u4E00\u6210\u672C\u5206\u6790\u3001\u5173\u952E\u6307\u6807\u76D1\u63A7\u544A\u8B66\u7684\u95EE\u9898",
                prize: "\u4E8C\u7B49\u5956 \xa525,000 \uFF0C\u6700\u4F73\u4EBA\u6C14\u5956 \u952E\u9F20\u5957\u88C5/\u4EBA"
            },
            {
                pictureImage: production_2,
                githubUrl: "https://github.com/mirror-data/mirror",
                playbackUrl: "https://www.bilibili.com/video/BV1D14y157U4/",
                rfcUrl: "https://gist.github.com/wph95/bcb6f9fe3401a5978cedf3389afa7f75",
                name: "6c0c6375-462b-4320-9af2-03593d55b227",
                description: "Mirror-\u9B54\u955C\uFF0C\u4E0D\u7528\u5199\u590D\u6742 SQL \u5C31\u53EF\u4EE5\u7B80\u5355\u83B7\u5F97\u5206\u6790\u7ED3\u679C",
                prize: "\u4E8C\u7B49\u5956 \xa525,000 \uFF0C\u6700\u4F73\u521B\u610F\u5956 \xa55,000"
            },
            {
                pictureImage: production_3,
                githubUrl: "https://github.com/Daemonxiao/n8n/tree/tidb/packages/nodes-base/nodes/TiDB",
                playbackUrl: "https://www.bilibili.com/video/BV1784y1B7oB/",
                rfcUrl: "https://gist.github.com/shiyuhang0/ae6d9deab4c8e1708b80bea1de9df279",
                name: "cloud naive",
                description: "My Life\uFF0C\u8BB0\u5F55\u6211\u4EEC\u7684\u751F\u6D3B\u8F68\u8FF9\uFF0C\u5B58\u50A8\u5230 TiDB \u4E2D\uFF0C\u6700\u7EC8\u4EE5\u5404\u79CD\u65B9\u5F0F\u5C55\u73B0",
                prize: "\u4E09\u7B49\u5956 \xa515,000"
            },
            {
                pictureImage: production_4,
                githubUrl: "https://github.com/sydpz/pingcap_hackthon",
                playbackUrl: "https://www.bilibili.com/video/BV1Ue4y177vv/",
                rfcUrl: "https://gist.github.com/sydpz/2d5791eabb47058fdd377d4bdd4af775#file-md",
                name: "\u4E00\u5929\u4E00\u4E2A\u9879\u76EE",
                description: "HTAP Charts\uFF0C\u5728 TiDB \u5C42\u8BBE\u8BA1\u4E0E\u5B9E\u73B0 charts \u7EC4\u4EF6\uFF0C \u7528\u6237\u53EF\u4EE5\u57FA\u4E8E\u914D\u7F6E\u548C\u62D6\u62FD\u7684\u65B9\u5F0F\u751F\u6210\u81EA\u5DF1\u7684\u56FE\u8868\uFF0C\u7136\u540E\u5728\u7F51\u7AD9\u4E0A\u83B7\u53D6\u76F8\u5E94\u56FE\u6807\u7684 iframe \u4EE3\u7801\uFF0C\u5D4C\u5165\u81F3\u81EA\u5DF1\u7684\u5E94\u7528\u5185\u5373\u5B8C\u6210\u4E86\u56FE\u8868\u7684\u76F8\u5173\u6784\u5EFA",
                prize: "\u4E09\u7B49\u5956 \xa515,000"
            },
            {
                pictureImage: production_5,
                githubUrl: "https://github.com/cutecutecat/TiKey",
                playbackUrl: "https://www.bilibili.com/video/BV1Q14y157qk/",
                rfcUrl: "https://gist.github.com/cutecutecat/17e12ec4d5f677ff74482468221e34f9",
                name: "\u6572\u4EE3\u7801\u4E0D\u558A\u6211\u662F\u5427",
                description: "TiKey\uFF0C\u9879\u76EE\u7740\u773C\u4E8E\u5B9E\u73B0\u4ECE MySQL \u8FC1\u79FB\u5230 TiDB \u7684\u8FC1\u79FB\u6821\u9A8C\u5DE5\u5177",
                prize: "\u4E09\u7B49\u5956 \xa515,000 \uFF0C\u6700\u4F73\u6821\u56ED\u5956 \xa55,000"
            },
            {
                pictureImage: production_6,
                githubUrl: "https://github.com/ChenlingLu/NFTips",
                playbackUrl: "https://www.bilibili.com/video/BV1WP4y1S7S8/",
                rfcUrl: "https://github.com/ChenlingLu/NFTips",
                name: "\u83AB\u614C\uFF01\u6709\u6211\uFF01",
                description: "NFTips\uFF0C\u76F4\u63A5\u4F7F\u7528\u516C\u94FE\u6570\u636E\u5BF9 NFT \u6570\u5B57\u85CF\u54C1\u7684\u201C\u4E00\u751F\u201D\u505A\u53EF\u89C6\u5316\u5206\u6790",
                prize: "\u533A\u5757\u94FE\u4E13\u9879\u5956 \xa510,000 \uFF0C\u6280\u672F\u8D8B\u52BF\u5956 \xa55,000"
            },
            {
                pictureImage: production_7,
                githubUrl: "https://github.com/shizn/vscode-tidb-cloud",
                playbackUrl: "https://www.bilibili.com/video/BV1Re4y1e7NW/",
                rfcUrl: "https://gist.github.com/shizn/9d95122027d06b319fd1a8f97a2754e8",
                name: "\u8D35\u53F8\u8D35\u7EC4",
                description: "TiDB Cloud VS Code extension\uFF0C\u7528 VS Code \u76F4\u63A5\u7BA1\u7406 TiDB Cloud cluster\uFF0C\u8D4B\u80FD\u5F00\u53D1\u8005\u8FDB\u884C\u4E00\u7AD9\u5F0F\u6570\u636E\u5904\u7406\u548C\u5E94\u7528\u5F00\u53D1",
                prize: "Cloud \u5E94\u7528\u751F\u6001\u5956 \xa55,000"
            }, 
        ]
    },
    production: {
        name: "TiDB \u4EA7\u54C1\u7EC4",
        color: "#00CF71",
        items: [
            {
                pictureImage: application_0,
                githubUrl: "https://github.com/tangenta/tidb/tree/batch-point-get",
                playbackUrl: "https://www.bilibili.com/video/BV1YK411D7ek/",
                rfcUrl: "https://github.com/flowbehappy/double_my_tps",
                name: "\u6478\u9C7C\u5C31\u662F",
                description: "Double My QPS\uFF0C\u4E00\u952E\u53D8\u5F3A",
                prize: "\u4E00\u7B49\u5956 \xa550,000"
            },
            {
                pictureImage: application_1,
                githubUrl: "https://github.com/zanmato1984/tidb/commit/33dc07bfc0c0bbce7ae1951bfa445374dcda15e9",
                playbackUrl: "https://www.bilibili.com/video/BV1uD4y1k7WD/",
                rfcUrl: "https://gist.github.com/zanmato1984/e9177d3f9b30023c16765d0161b4f43f",
                name: "\u6211\u57AB\u4F60\u4EEC\u8E72",
                description: "TiFlash Collocated Optimization\uFF0CTiFlash \u652F\u6301 Collocated Join",
                prize: "\u4E8C\u7B49\u5956 \xa525,000"
            },
            {
                pictureImage: application_2,
                githubUrl: "https://github.com/12Cat-TiDB",
                playbackUrl: "https://www.bilibili.com/video/BV1ed4y1y7AU/",
                rfcUrl: "https://github.com/12Cat-TiDB/FRC#readme",
                name: "12\u53EA\u55B5",
                description: "MoreCat\uFF0C\u8BA9\u6240\u6709\u4EBA\u90FD\u80FD\u901A\u8FC7 tiup \u4E2A\u4EBA\u955C\u50CF\u5411 TiDB \u8D21\u732E\u7EC4\u4EF6\uFF0C\u6253\u9020\u7EC4\u4EF6\u5E02\u573A\u7684\u96CF\u5F62",
                prize: "\u4E8C\u7B49\u5956 \xa525,000"
            },
            {
                pictureImage: application_3,
                githubUrl: "https://github.com/tifancy2022/tidb",
                playbackUrl: "https://www.bilibili.com/video/BV1H84y1i78k/",
                rfcUrl: "https://pingcap.feishu.cn/docx/MvJOd0F7SoktdIxFvLacHKJVnDg",
                name: "TiFancy",
                description: "Fast at Scale\uFF0C\u53D7 OSSInsight.io \u542F\u53D1\uFF0C\u52A0\u5F3A TiDB HTAP \u4E2D\u5BF9\u4E8E AP \u8BF7\u6C42\u7684 Serving \u80FD\u529B\uFF0C\u901A\u8FC7\u8865\u5168 AP \u7684 Serving \u80FD\u529B\uFF0C\u8BA9\u7C7B\u4F3C OSSInsight \u8FD9\u7C7B\u7684 DaaS \u5E94\u7528\u76F4\u63A5\u53D7\u76CA\uFF0C\u4E3A\u7528\u6237\u4ECE\u6D77\u91CF\u6570\u636E\u4E2D\u83B7\u53D6\u5B9E\u65F6\u7CBE\u51C6\u7684\u4E1A\u52A1\u6D1E\u5BDF",
                prize: "\u4E09\u7B49\u5956 \xa515,000"
            },
            {
                pictureImage: application_4,
                githubUrl: "https://github.com/yisaer/tidb/tree/2022_hackathon",
                playbackUrl: "https://www.bilibili.com/video/BV1oe4y117vc/",
                rfcUrl: "https://pingcap.feishu.cn/docx/ZwhQdo5gNoKkEGxp7wCc9h0snCp",
                name: "\u5F66\u9752\u8BF4\u5F97\u961F",
                description: "Optimizer trace\uFF0C\u5BF9 TiDB \u4F18\u5316\u5668\u51B3\u7B56\u8FC7\u7A0B\u8FDB\u884C\u53EF\u89C6\u5316\u5C55\u793A",
                prize: "\u4E09\u7B49\u5956 \xa515,000 \uFF0C\u7528\u6237\u4E4B\u9009\u5956 \xa55,000"
            },
            {
                pictureImage: application_5,
                githubUrl: "https://github.com/Sibyl-TiDB",
                playbackUrl: "https://www.bilibili.com/video/BV1sV4y1G7zS/",
                rfcUrl: "https://github.com/Sibyl-TiDB/FRC/blob/main/README.md",
                name: "\u9E21\u4F60\u592A\u7F8E",
                description: '"Sibyl is an Easier-to-use SQL Diagnostics tool for TiDB.',
                prize: "\u4E09\u7B49\u5956 \xa515,000"
            },
            {
                pictureImage: application_6,
                githubUrl: "https://github.com/orgs/FWH-TiKV/repositories",
                playbackUrl: "https://www.bilibili.com/video/BV1cP4y1S7Xo/",
                rfcUrl: "https://gist.github.com/OneSizeFitsQuorum/da4b1e12b9f216fd3b42e88c57fd9e55",
                name: "\u70ED\u70B9\u6E05\u96F6",
                description: "Fearless Write Hotspot\uFF0C\u672C\u9879\u76EE\u5C06\u91C7\u7528 bottom-up \u7684\u8BBE\u8BA1\u601D\u8DEF\uFF0C\u4ECE\u66F4\u597D\u5730\u5229\u7528 CPU\u3001\u78C1\u76D8\u7B49\u8D44\u6E90\u7684\u89D2\u5EA6\u51FA\u53D1\uFF0C\u8003\u8651\u5982\u4F55\u81EA\u5E95\u5411\u4E0A\u89E3\u51B3 TiKV \u7684\u5199\u70ED\u70B9\u95EE\u9898\u3002",
                prize: "\u6700\u4F73\u6821\u56ED\u5956 \xa55,000"
            },
            {
                pictureImage: application_7,
                githubUrl: "https://github.com/mikechengwei/Hack-2022",
                playbackUrl: "https://www.bilibili.com/video/BV1yd4y1y78M/",
                rfcUrl: "https://github.com/mikechengwei/Hackathon-2022/blob/main/Hackathon%202022%20-%20%E9%BB%91%E9%A9%AC%E8%AD%A6%E9%95%BF%20team%E2%80%98s%20RFC.md",
                name: "\u9ED1\u9A6C\u8B66\u957F",
                description: "\u8FC1\u79FB\u4E00\u6761\u9F99\uFF0C\u7528\u5FC3\u8FDE\u63A5\u5BFC\u51FA\u5BFC\u5165\u3002\u79DF\u6237\u7684\u9694\u79BB\u9700\u6C42\u6709\u7684\u662F\u5F3A\u9700\u6C42\u6709\u7684\u662F\u5F31\u9700\u6C42\uFF0C\u6709\u7684\u79DF\u6237\u6682\u65F6\u53EA\u9700\u8981\u903B\u8F91\u9694\u79BB\uFF0C\u6709\u7684\u4E00\u5F00\u59CB\u5C31\u9700\u8981\u5F3A\u9694\u79BB\uFF0C\u6709\u7684\u4F1A\u968F\u7740\u4E1A\u52A1\u573A\u666F\u7684\u8F6C\u53D8\u7531\u5F31\u8F6C\u5F3A\uFF0C\u4F1A\u4EA7\u751F\u8FC1\u79FB\u7684\u9700\u6C42\u3002",
                prize: "\u6700\u4F73\u4EBA\u6C14\u5956 \u952E\u9F20\u5957\u88C5/\u4EBA"
            }, 
        ]
    }
};
var dataFinalist = [
    {
        name: "\u5E94\u7528\u7EC4",
        color: "#F67200",
        items: [
            {
                teamName: "\u56FE\u4E00\u4E50",
                projectName: "Data Dance",
                score: "88.94",
                rank: 1,
                githubUrl: "https://github.com/Lloyd-Pottiger/DataDance",
                playbackUrl: "https://www.bilibili.com/video/BV1we411G75H/",
                rfcUrl: "https://gist.github.com/Lloyd-Pottiger/2f9bfabcfd0e86230251ebb54315cf3d",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Try TiDB online~"
                    })
                })
            },
            {
                teamName: "\u4E0D\u4E0A\u73ED\u4F60\u517B\u6211\u554A",
                projectName: "\u4E91\u8FF9",
                score: "86.54",
                rank: 2,
                githubUrl: "https://github.com/VelocityLight/yunji",
                playbackUrl: "\u8BE5\u56E2\u961F\u7B54\u8FA9\u89C6\u9891\u4E0D\u5BF9\u5916",
                rfcUrl: "https://gist.github.com/VelocityLight/ccb4c50e569b1ee733f23a2bb97e8439",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u4E91\u6280\u672F\u6280\u672F\u6D6A\u6F6E\u4E0B\uFF0C\u4F01\u4E1A\u4E00\u65B9\u9762\u4EAB\u53D7\u5F39\u6027\u5E26\u6765\u7684\u751C\u5934\uFF0C\u4E00\u65B9\u9762\u82E6\u607C\u4E8E\u4E91\u4E0A\u8D44\u6E90\u6210\u672C\u7684\u7BA1\u7406\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u5FD8\u8BB0\u5173\u95ED\u8D44\u6E90\u3001\u7A0B\u5E8F\u6CC4\u6F0F\u8D44\u6E90\u3001\u8D39\u7528\u77AC\u65F6\u66B4\u589E\u8FD9\u4E9B\u95EE\u9898\u8BA9\u4F01\u4E1A\u4EBA\u5458\u90FD\u5934\u75DB\u4E0D\u5DF2\u3002\u4E9A\u9A6C\u900A\u5C06\u52E4\u4FED\u8282\u7EA6\uFF08Frugality\uFF09\u4F5C\u4E3A\u9886\u5BFC\u529B\u51C6\u5219\u4E4B\u4E00\uFF0C\u53EF\u89C1\u6210\u672C\u5BF9\u4E8E\u4E00\u5BB6\u4F01\u4E1A\u7684\u91CD\u8981\u610F\u4E49\uFF0C\u5BF9\u4E8E\u521B\u4E1A\u516C\u53F8\u66F4\u662F\u5982\u6B64\u3002\u6210\u672C\u4F18\u5316\u4E0D\u662F\u4E00\u4E2A\u516C\u53F8\u7684\u4EFB\u52A1\uFF0C\u6BCF\u4E2A\u4E91\u4E0A\u5F00\u53D1\u4EBA\u5458\u90FD\u9700\u8981\u5177\u5907\u7684 sence\uFF0C\u6781\u81F4\u4F18\u5316\u624D\u80FD\u8BDE\u751F\u4F1F\u5927\u7684\u8F6F\u4EF6\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u672C\u9879\u76EE\u7EC8\u6781\u76EE\u7684\u662F\u89E3\u51B3\u4F01\u4E1A\u5728\u4E91\u4E0A\u90E8\u7F72\u67B6\u6784\u4E0B\u7EDF\u4E00\u6210\u672C\u5206\u6790\u3001\u5173\u952E\u6307\u6807\u76D1\u63A7\u544A\u8B66\u7684\u95EE\u9898\u3002\u56E0\u8003\u8651\u5230\u6570\u636E\u91CF\u5DE8\u5927\uFF0C\u7EDF\u8BA1\u5206\u6790\u5B9E\u65F6\u67E5\u8BE2\u3001\u544A\u8B66\u8981\u6C42\u591A\uFF0C\u6211\u4EEC\u91C7\u7528 HTAP \u6570\u636E\u5E93\u7684 TiDB \u4F5C\u4E3A\u5B58\u50A8\u548C\u8BA1\u7B97\u5F15\u64CE\uFF0C\u53D1\u6325 TiDB \u5728\u5E94\u7528\u573A\u666F\u4E0B\u7684\u4EF7\u503C\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u671F\u5F85\u53EF\u4EE5\u901A\u8FC7\u4E91\u8FF9\uFF0C\u8282\u7EA6\u4F60\u7684\u91D1\u94B1\u4EBF\u70B9\u70B9\uFF01"
                        })
                    ]
                })
            },
            {
                teamName: "6c0c6375-462b-4320-9af2-03593d55b227",
                projectName: "Mirror-\u9B54\u955C",
                score: "84.08",
                rank: 3,
                githubUrl: "https://github.com/mirror-data/mirror",
                playbackUrl: "https://www.bilibili.com/video/BV1D14y157U4/",
                rfcUrl: "https://gist.github.com/wph95/bcb6f9fe3401a5978cedf3389afa7f75",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u58A8\u955C\uFF0C\u4E0D\u7528\u5199\u590D\u6742 SQL \u5C31\u53EF\u4EE5\u7B80\u5355\u83B7\u5F97\u5206\u6790\u7ED3\u679C\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u961F\u540D\u542F\u53D1\uFF1A\u9B54\u955C\u9B54\u955C\u544A\u8BC9\u6211\uFF0C\u8C01\u662F\u4E16\u754C\u4E0A\u6DA6\u7684\u6700\u5FEB\u7684\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u9996\u5148\u9B54\u955C\u4F1A\u81EA\u52A8\u8BFB\u53D6 TIDB Cloud\uFF0C\u83B7\u53D6\u6570\u636E\u5E93\u7684\u5404\u4E2A\u5143\u4FE1\u606F\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u63A5\u7740\u901A\u8FC7\u6DF1\u5EA6\u5B66\u4E60\u5C06\u7528\u6237\u8F93\u5165\u7684\u81EA\u7136\u8BED\u8A00\u8F6C\u6362\u6210 SQL\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u6700\u540E\u5C06\u7ED3\u679C\u901A\u8FC7 GPT3 \u751F\u6210\u7B80\u8981\u3002"
                        })
                    ]
                })
            },
            {
                teamName: "cloud naive",
                projectName: "My Life",
                score: "83.23",
                rank: 4,
                githubUrl: "https://github.com/Daemonxiao/n8n/tree/tidb/packages/nodes-base/nodes/TiDB",
                playbackUrl: "https://www.bilibili.com/video/BV1784y1B7oB/",
                rfcUrl: "https://gist.github.com/shiyuhang0/ae6d9deab4c8e1708b80bea1de9df279",
                introduction: "My Life \u662F\u6211\u4EEC\u60F3\u6CD5\u7684\u4E00\u4E2A example\uFF0C\u4ED6\u80FD\u8BB0\u5F55\u6211\u4EEC\u7684\u751F\u6D3B\u8F68\u8FF9\uFF0C\u5B58\u50A8\u5230 TiDB \u4E2D\uFF0C\u6700\u7EC8\u4EE5\u5404\u79CD\u65B9\u5F0F\u5C55\u73B0\u3002"
            },
            {
                teamName: "\u4E00\u5929\u4E00\u4E2A\u9879\u76EE",
                projectName: "HTAP Charts",
                score: "82.88",
                rank: 5,
                githubUrl: "https://github.com/sydpz/pingcap_hackthon",
                playbackUrl: "https://www.bilibili.com/video/BV1Ue4y177vv/",
                rfcUrl: "https://gist.github.com/sydpz/2d5791eabb47058fdd377d4bdd4af775#file-md",
                introduction: "\u5728TiDB \u5C42\u8BBE\u8BA1\u4E0E\u5B9E\u73B0 charts \u7EC4\u4EF6\uFF0C \u7528\u6237\u53EF\u4EE5\u57FA\u4E8E\u914D\u7F6E\u548C\u62D6\u62FD\u7684\u65B9\u5F0F\u751F\u6210\u81EA\u5DF1\u7684\u56FE\u8868\uFF0C\u7136\u540E\u5728\u7F51\u7AD9\u4E0A\u83B7\u53D6\u76F8\u5E94\u56FE\u6807\u7684 iframe \u4EE3\u7801\uFF0C\u5D4C\u5165\u81F3\u81EA\u5DF1\u7684\u5E94\u7528\u5185\u5373\u5B8C\u6210\u4E86\u56FE\u8868\u7684\u76F8\u5173\u6784\u5EFA"
            },
            {
                teamName: "\u6572\u4EE3\u7801\u4E0D\u558A\u6211\u662F\u5427",
                projectName: "TiKey",
                score: "82.54",
                rank: 6,
                githubUrl: "https://github.com/cutecutecat/TiKey",
                playbackUrl: "https://www.bilibili.com/video/BV1Q14y157qk/",
                rfcUrl: "https://gist.github.com/cutecutecat/17e12ec4d5f677ff74482468221e34f9",
                introduction: "\u9879\u76EE\u7740\u773C\u4E8E\u5B9E\u73B0\u4ECEMySQL\u8FC1\u79FB\u5230 TiDB \u7684\u8FC1\u79FB\u6821\u9A8C\u5DE5\u5177\u3002\u5229\u7528SQL\u8BCD\u6CD5\u89E3\u6790\u5668\u548C\u9884\u5B9A\u4E49\u89C4\u5219\uFF0C\u8BBE\u8BA1\u4E00\u4E2A\u5177\u6709\u826F\u597D\u62D3\u5C55\u6027\u7684\u81EA\u52A8\u5316\u68C0\u67E5\u5668\uFF0C\u53EF\u4EE5\u68C0\u67E5SQL\u8BED\u53E5\u662F\u5426\u7B26\u5408 TiDB \u7684\u8981\u6C42\uFF0C\u80FD\u591F\u8FDB\u884C\u81EA\u52A8\u8FC1\u79FB\uFF0C\u5E76\u5BF9\u4E8E\u4E0D\u5408\u8981\u6C42\u4E4B\u5904\u7ED9\u51FA\u5EFA\u8BAE\u548C\u76F8\u5173\u94FE\u63A5\u3002"
            },
            {
                teamName: "Ti \u6D41\u6279",
                projectName: "Ti \u6D41\u6279",
                score: "81.66",
                rank: 7,
                githubUrl: "https://github.com/TiStore/TiLiupi",
                playbackUrl: "https://www.bilibili.com/video/BV1Se41137ke",
                rfcUrl: "https://gist.github.com/AndreMouche/bc9cf1c4a02ca19af27a79dfd728a88b",
                introduction: "\u57FA\u4E8E TiDB + Flink Table Store \u5B9E\u73B0\u6D41\u6279\u4E00\u4F53\u5B58\u50A8\u7CFB\u7EDF\uFF0C\u4EE5\u5B9E\u73B0\u964D\u672C\u589E\u6548"
            },
            {
                teamName: "\u5F00\u5FC3\u5C31\u597D",
                projectName: "cool",
                score: "81.63",
                rank: 8,
                githubUrl: "https://github.com/yuliang119110/cool",
                playbackUrl: "https://www.bilibili.com/video/BV1dG4y187mL/",
                rfcUrl: "https://gist.github.com/yuliang119110/eb0d454a0090ee6cf5c649aaabdf5078",
                introduction: "\u5B9E\u65F6\u5904\u7406\u548C\u5E76\u4E14\u5206\u6790\u533A\u5757\u94FETB\u7EA7\u7684\u6570\u636E\uFF0C\u4E0A\u4EBF\u89C4\u6A21\u7684\u4EA4\u6613\u6570\u636E"
            },
            {
                teamName: "\u81EA\u5DF1\u5199 \u81EA\u5DF1\u67E5 \u81EA\u5DF1\u7F51\u7AD9\u4E0A\u6302",
                projectName: "OSSInsight Marketplace",
                score: "81.61",
                rank: 9,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1D8411e7ks/",
                rfcUrl: "https://gist.github.com/Icemap/9dd1e38abea4e771f3581f3c672c196d",
                introduction: "\u672C\u5C0F\u961F\u8BA1\u5212\u5728 Hackathon 2022 \u4E2D\u5B8C\u6210 OSSInsight \u7684 Marketplace \u6A21\u5757\u3002\u7528\u6237\u53EF\u81EA\u7531\u4E0A\u4F20\u81EA\u5DF1\u7F16\u5199\u7684\u7EC4\u4EF6\uFF0C\u901A\u8FC7\u5BA1\u6838\u540E\uFF0C\u5176\u4ED6\u7528\u6237\u53EF\u4F7F\u7528\u6B64\u7EC4\u4EF6\uFF0C\u5E76\u53EF\u5C06\u7EC4\u4EF6\u5D4C\u5165\u5230\u4EFB\u610F\u9875\u9762\u4E2D\uFF08iframe \u65B9\u5F0F\uFF09\u3002"
            },
            {
                teamName: "1' or '1' = '1",
                projectName: "TiSQLi",
                score: "81.44",
                rank: 10,
                githubUrl: "",
                playbackUrl: "\u4E0A\u4F20\u89C6\u9891\uFF0C\u540E\u7EED\u518D\u66F4\u65B0",
                rfcUrl: "https://gist.github.com/flily/c1009c65e08eaed28e9f39f1d371cea7",
                introduction: "SQL-injection detection method with TiDB SQL parser"
            },
            {
                teamName: "\u83AB\u614C\uFF01\u6709\u6211\uFF01",
                projectName: "NFTips",
                score: "81.41",
                rank: 11,
                githubUrl: "https://github.com/ChenlingLu/NFTips",
                playbackUrl: "https://www.bilibili.com/video/BV1WP4y1S7S8/",
                rfcUrl: "https://github.com/ChenlingLu/NFTips",
                introduction: "\u76F4\u63A5\u4F7F\u7528\u516C\u94FE\u6570\u636E\u5BF9 NFT \u6570\u5B57\u85CF\u54C1\u7684\u201C\u4E00\u751F\u201D\u505A\u53EF\u89C6\u5316\u5206\u6790\uFF0C\u5E2E\u52A9\u4E70\u5BB6\u53D1\u73B0\u85CF\u54C1\u6F5C\u529B\uFF0C\u5224\u65AD\u6295\u8D44\u98CE\u9669\uFF1B\u53EF\u80FD\u4E5F\u80FD\u5BF9\u5356\u5BB6\u53D1\u5E03\u6570\u5B57\u85CF\u54C1\uFF08\u5B9A\u4EF7\u3001\u9884\u4F30\u6210\u4EA4\u4EF7\u3001\u5224\u65AD\u8F6C\u624B\u6B21\u6570\u7B49\u65B9\u9762\uFF09\u63D0\u4F9B\u6D1E\u5BDF\u3002"
            },
            {
                teamName: "Ti\u53EF\u7ACB\u523B",
                projectName: "Ti-Click++",
                score: "81.32",
                rank: 12,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1St4y1u7Su",
                rfcUrl: "https://github.com/ti-click/pingcap-hackathon-2022",
                introduction: "\u4E3A\u4E86\u8BA9\u7528\u6237\u53EF\u4EE5\u66F4\u5FEB\u901F\u7684\u5C1D\u8BD5TiDB\u548CTiDB Cloud\uFF0C\u65E0\u9700\u7528\u6237\u8FDB\u884C\u672C\u5730\u7684\u90E8\u7F72\u548C\u73AF\u5883\u8C03\u8BD5\uFF0C\u5C1D\u8BD5\u4E3A\u7528\u6237\u63D0\u4F9B\u5728\u7EBFIDE\u73AF\u5883\u4EE5\u53CASample App"
            },
            {
                teamName: "Second State",
                projectName: "A serverless ETL runtime for the TiDB Cloud",
                score: "79.75",
                rank: 13,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1Be4y177WK/",
                rfcUrl: "https://gist.github.com/juntao/785f9505eed335431d774f6c801a9f1f",
                introduction: "We propose to create a cloud-native ETL application framework based on the WasmEdge WebAssembly runtime for developers to filter, map, and transform data going into TiDB cloud databases. Developers will be able to create secure, lightweight, fast and cross-platform ETL functions that are located close to or even embedded in TiDB Cloud's infrastructure. The ETL functions can be deployed as serverless functions and receive data from a variety of sources including event queues, webhook callbacks and data streaming pipelines. The outcomes are written into user configured TiDB tables for later analysis."
            },
            {
                teamName: "\u4E09\u4EBA\u884C",
                projectName: "Python Playground",
                score: "79.27",
                rank: 14,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1384y1B7rj/",
                rfcUrl: "https://gist.github.com/zhangyangyu/7929a2293c4d1f25b225e93cb3129209",
                introduction: "Go \u8BED\u8A00\u7684 Go Playground \u662F\u4E00\u4E2A\u975E\u5E38\u597D\u7684\u7B80\u6613 Go \u8BED\u8A00\u4EE3\u7801\u7247\u6BB5\u5B66\u4E60\u3001\u5206\u4EAB\u5DE5\u5177\uFF0C\u4F7F\u7528\u8005\u53EF\u4EE5\u7528\u5B83\u6765\u5B66\u4E60\u3001\u9A8C\u8BC1\u8BED\u8A00\u3001\u5E93\u7684\u57FA\u672C\u80FD\u529B\uFF0C\u540C\u65F6\u4E5F\u53EF\u4EE5\u901A\u8FC7\u94FE\u63A5\u5206\u4EAB\u7ED9\u4ED6\u4EBA\uFF0C\u5728 stackoverflow \u4E0A\u8FDB\u884C\u63D0\u95EE\u3001\u56DE\u7B54\u65F6\uFF0C\u4E5F\u503E\u5411\u4E8E\u901A\u8FC7\u5B83\u6765\u5206\u4EAB\u4EE3\u7801\u3002\u4F46 Python \u8BED\u8A00\u5B98\u65B9\u5374\u6CA1\u6709\u4E00\u4E2A\u5982\u6B64\u7684\u5DE5\u5177\uFF0CPython Playground \u5E0C\u671B\u57FA\u4E8E WSAM \u548C TiDB Cloud \u6765\u5B9E\u73B0\u6B64\u529F\u80FD\u3002"
            },
            {
                teamName: "\u8D35\u53F8\u8D35\u7EC4",
                projectName: "TiDB Cloud VS Code extension",
                score: "78.78",
                rank: 15,
                githubUrl: "https://github.com/shizn/vscode-tidb-cloud",
                playbackUrl: "https://www.bilibili.com/video/BV1Re4y1e7NW/",
                rfcUrl: "https://gist.github.com/shizn/9d95122027d06b319fd1a8f97a2754e8",
                introduction: "\u7528VS Code\u76F4\u63A5\u7BA1\u7406TiDB Cloud cluster, \u8D4B\u80FD\u5F00\u53D1\u8005\u8FDB\u884C\u4E00\u7AD9\u5F0F\u6570\u636E\u5904\u7406\u548C\u5E94\u7528\u5F00\u53D1\u3002"
            },
            {
                teamName: "\u4E09\u6052\u8BF8\u6D6A",
                projectName: "SSO \u5B9E\u73B0 TiDB \u767B\u5F55\u6743\u9650\u6821\u9A8C",
                score: "78.61",
                rank: 16,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1SG4y187CA/",
                rfcUrl: "https://gist.github.com/Sindweller/59bb18dc9140b3a3c51c9e73def197d6",
                introduction: "\u672C\u9879\u76EE\u5C06\u81F4\u529B\u4E8E\u4F7F\u7528 SSO\u4F5C\u4E3ATiDB\u7684\u767B\u5F55\u8BA4\u8BC1\u65B9\u5F0F\uFF0C\u4F7F\u5F97\u7528\u6237\u53EF\u4EE5\u907F\u514D\u4F7F\u7528\u76F4\u63A5\u7684\u6570\u636E\u5E93\u7528\u6237\u540D\u5BC6\u7801\u8FDE\u63A5TiDB\uFF0C\u589E\u5F3A\u5B89\u5168\u6027\u4E0E\u6743\u9650\u63A7\u5236\u3002"
            },
            {
                teamName: "Cloooudy",
                projectName: "ETiCD",
                score: "78.31",
                rank: 17,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1nP4y1S7Z3",
                rfcUrl: "https://gist.github.com/fgksgf/2cbf26f6c1ddda74c691cb69d0a00b25",
                introduction: "Etcd as a Service, powered by TiDB."
            },
            {
                teamName: "KubeBrain",
                projectName: "KubeBrain",
                score: "77.91",
                rank: 18,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1Qe4y177fG/",
                rfcUrl: "https://gist.github.com/divanodestiny/fd4f957cdc3a099414e7a93459168958",
                introduction: "\u57FA\u4E8E TiDB \u5B9E\u73B0 kubernetes \u5143\u4FE1\u606F\u5B58\u50A8\u7CFB\u7EDF"
            },
            {
                teamName: "42",
                projectName: "ETCD with TiDB ",
                score: "77.35",
                rank: 19,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1ZG411L7KN/",
                rfcUrl: "https://gist.github.com/NageNalock/e47fde8dfff1000d66bbe11e2b0f6527",
                introduction: "Ectd \u7684\u5BB9\u91CF\u6709\u9650\u5236\uFF0C\u53EF\u4EE5\u505A\u4E00\u4E2A\u4E2D\u95F4\u4EF6\u5B9E\u73B0 etcd \u7684\u63A5\u53E3\uFF0C\u80CC\u540E\u662F tidb"
            },
            {
                teamName: "HOTPOOR",
                projectName: "FindMaster",
                score: "77.21",
                rank: 20,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1JW4y1E7sR/",
                rfcUrl: "https://gist.github.com/hotpoor/e34569767c75cec0b5f7a21f6bd5aaa6",
                introduction: "\u50CF\u505Appt\u4E00\u6837\u505A\u7F51\u7AD9"
            },
            {
                teamName: "MindBase",
                projectName: "MindBase",
                score: "76.43",
                rank: 21,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1EK411U7QZ/",
                rfcUrl: "https://gist.github.com/Hu-Wentao/3f259f05d5e4e34637619a17559325ee",
                introduction: "MindBase - \u4EE5Flutter\u4E0ETiCloud\u4E3A\u57FA\u7840\uFF0C\u6253\u9020\u4E00\u4E2ADBaaS\u670D\u52A1\u548C\u5185\u5BB9\u7BA1\u7406\u7CFB\u7EDF\uFF08CMS\uFF09\u3002"
            },
            {
                teamName: "Give Me Five",
                projectName: "Public Data Market Service",
                score: "75.75",
                rank: 22,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1wD4y1b78S/",
                rfcUrl: "https://gist.github.com/zhangjinpeng1987/a5a491687cf0cf29f266981e818219fd",
                introduction: "Store public data like (public block-chain data, public stock market data, public news) in TiDB Cloud, and leverage the HTAP ability of TiDB Cloud to provide public data retrieving/analysis service."
            },
            {
                teamName: "\u53D1\u9645\u7EBF\u4FDD\u62A4\u534F\u4F1A",
                projectName: "\u57FA\u4E8Ekine\u52A0\u5165\u9002\u914D\u5C42\u540E\u7AEF\u4F7F\u7528tidb\u6269\u5C55etcd",
                score: "74.97",
                rank: 23,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1RD4y1t7Dq/",
                rfcUrl: "https://gist.github.com/kksh3ll/ccc7c3ccb247b88cad34752e7b6527fe",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "etcd \u57FA\u4E8E BoltDB\uFF0C\u5BB9\u91CF\u5177\u6709\u4E0A\u9650\uFF0C\u8FD9\u4E9B\u81EA\u8EAB\u7684\u67B6\u6784\u95EE\u9898\uFF0C\u5BFC\u81F4etcd\u5728\u6570\u636E\u5B58\u50A8\u65B9\u9762\u6709\u7F3A\u9677\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u4F5C\u4E3A\u9002\u914D\u4E2D\u95F4\u5C42\uFF0Ckine\u9879\u76EE\u5B8C\u6574\u5730\u5B9E\u73B0\u4E86 etcd \u9700\u8981\u652F\u6301\u7684 watch \u529F\u80FD\uFF0C\u4E14\u6A21\u62DF\u4E86 etcd \u7684 MVCC \u7279\u6027\uFF0C\u652F\u6301 Compact\u3002"
                        })
                    ]
                })
            },
            {
                teamName: "\u4E2D\u676F \u5927\u676F \u8D85\u5927\u676F",
                projectName: "TiTicket",
                score: "74.56",
                rank: 24,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1L14y157jZ/",
                rfcUrl: "https://gist.github.com/HikawaRin/7dcd7cf58de6ddd08a24290539580679",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "TiDB\u552E\u7968\u5904\uFF0C\u57FA\u4E8ESSO\u8FDB\u884C\u7528\u6237\u8BA4\u8BC1\uFF0C\u5B9E\u73B0\u5728TiDB\u4E0A\u7684\u81EA\u52A9\u6CE8\u518C\u53CA\u6743\u9650\u7533\u8BF7"
                    })
                })
            },
            {
                teamName: "TINOCO",
                projectName: "TiNocoDB",
                score: "73.84",
                rank: 25,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1AP4y1S7Tj/",
                rfcUrl: "https://gist.github.com/meathill/32ca25112194965724913b34de76dafd",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "AirTable \u662F\u5F88\u68D2\u7684\u4F4E\u4EE3\u7801\u7BA1\u7406\u5DE5\u5177\uFF0C\u53EF\u60DC\u4ED6\u4EEC\u7528\u6536\u8D39\u5899\u9650\u5236\u514D\u8D39\u7528\u6237\u4F7F\u7528 row-based \u6743\u9650\u7BA1\u7406\u3002NocoDB \u662F\u5176\u5F00\u6E90\u66FF\u4EE3\u54C1\uFF0C\u53EF\u60DC MySQL \u540E\u7AEF\u4F1A\u5728\u4E0D\u8FDC\u7684\u672A\u6765\u6210\u4E3A\u67B7\u9501\u3002\u6211\u4EEC\u76F8\u4FE1 TiDB \u5F3A\u5927\u7684 scalable \u7279\u6027\u4F1A\u5F7B\u5E95\u91CA\u653E\u667A\u80FD\u8868\u683C\u7684\u6F5C\u529B\uFF0C\u8BA9\u7528\u6237\u4ECE\u5F31\u5230\u5F3A\u540E\u987E\u65E0\u5FE7\u3002\u6240\u4EE5\u6211\u4EEC\u5E0C\u671B\u5C06 NocoDB \u5AC1\u63A5\u5230 TiDB\u3002"
                    })
                })
            },
            {
                teamName: "\u4E94\u6E56\u56DB\u6D77",
                projectName: "SSO \u5B9E\u73B0 TiDB \u767B\u5F55\u6743\u9650\u6821\u9A8C",
                score: "71.56",
                rank: 26,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1WV4y1G7s7/",
                rfcUrl: "https://github.com/qiao511869361/tidb_hackathon_2022/blob/main/hackathon_2022_\u4E94\u6E56\u56DB\u6D77_RFC.md",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "SSO \u5B9E\u73B0 TiDB \u767B\u5F55\u6743\u9650\u6821\u9A8C"
                    })
                })
            },
            {
                teamName: "\u5927\u660E\u6E56\u7554\u7684\u5C0F\u5929\u53F0",
                projectName: "MIXED HTAP ON K8S",
                score: "69.49",
                rank: 27,
                githubUrl: "",
                playbackUrl: "https://www.bilibili.com/video/BV1584y1B7Wr/",
                rfcUrl: "https://github.com/WholeWorld-Timothy/OneEntrance/blob/main/README.md",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u73B0\u5728TiFlash\u8FD8\u6CA1\u6709\u5B9E\u73B0\u9AD8\u541E\u5410\u7684\u76F4\u63A5\u5199\u5165\uFF0C\u5BF9\u4E8E\u79BB\u7EBF\u8BA1\u7B97\u4E0D\u662F\u5F88\u53CB\u597D\uFF0C\u5C1D\u8BD5\u7EC4\u5408\u51E0\u4E2A\u5F00\u6E90\u4EA7\u54C1\uFF0C\u5B9E\u73B0\u57FA\u4E8ETiDB\u7684\u9AD8\u541E\u5410AP\u4FA7\u5B9E\u73B0"
                    })
                })
            }, 
        ]
    },
    {
        name: "TiDB \u4EA7\u54C1\u7EC4",
        color: "#00CF71",
        items: [
            {
                teamName: "\u6478\u9C7C\u5C31\u662F",
                projectName: "Double My QPS",
                score: "83.49",
                rank: 1,
                playbackUrl: "https://www.bilibili.com/video/BV1YK411D7ek/",
                rfcUrl: "https://github.com/flowbehappy/double_my_tps",
                githubUrl: "https://github.com/tangenta/tidb/tree/batch-point-get",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u4E00\u952E\u53D8\u5F3A"
                    })
                })
            },
            {
                teamName: "\u6211\u57AB\u4F60\u4EEC\u8E72",
                projectName: "TiFlash Collocated Optimization",
                score: "82.20",
                rank: 2,
                playbackUrl: "https://www.bilibili.com/video/BV1uD4y1k7WD/",
                rfcUrl: "https://gist.github.com/zanmato1984/e9177d3f9b30023c16765d0161b4f43f",
                githubUrl: "https://github.com/zanmato1984/tidb/commit/33dc07bfc0c0bbce7ae1951bfa445374dcda15e9",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "TiFlash \u652F\u6301 Collocated Join"
                    })
                })
            },
            {
                teamName: "12\u53EA\u55B5",
                projectName: "MoreCat",
                score: "81.59",
                rank: 3,
                playbackUrl: "https://www.bilibili.com/video/BV1ed4y1y7AU/",
                rfcUrl: "https://github.com/12Cat-TiDB/FRC#readme",
                githubUrl: "https://github.com/12Cat-TiDB",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "\u8BA9\u6240\u6709\u4EBA\u90FD\u80FD\u901A\u8FC7 tiup \u4E2A\u4EBA\u955C\u50CF\u5411 tidb \u8D21\u732E\u7EC4\u4EF6\uFF0C\u6253\u9020\u7EC4\u4EF6\u5E02\u573A\u7684\u96CF\u5F62"
                })
            },
            {
                teamName: "TiFancy",
                projectName: "TiFancy",
                score: "79.65",
                rank: 4,
                playbackUrl: "\u7B49\u5F85\u89C6\u9891\u5185\u5BB9",
                rfcUrl: "https://pingcap.feishu.cn/docx/MvJOd0F7SoktdIxFvLacHKJVnDg",
                githubUrl: "https://github.com/tifancy2022/tidb",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Fast at Scale\u3002\u672C\u9879\u76EE\u53D7 OSSInsight.io \u542F\u53D1\uFF0C\u65E8\u5728\u52A0\u5F3A TiDB \u7684 HTAP \u4E2D\u5BF9\u4E8E AP \u8BF7\u6C42\u7684 Serving \u80FD\u529B\uFF0C\u901A\u8FC7\u8865\u5168 AP \u7684 Serving \u80FD\u529B\uFF0C\u8BA9\u7C7B\u4F3C OSSInsight \u8FD9\u7C7B\u7684 DaaS (Data as a Service) \u5E94\u7528\u76F4\u63A5\u53D7\u76CA\uFF0C\u4E3A\u7528\u6237\u4ECE\u6D77\u91CF\u6570\u636E\u4E2D\u83B7\u53D6\u5B9E\u65F6\u7CBE\u51C6\u7684\u4E1A\u52A1\u6D1E\u5BDF\u3002"
                    })
                })
            },
            {
                teamName: "\u5F66\u9752\u8BF4\u5F97\u961F",
                projectName: "Optimizer trace",
                score: "79.25",
                rank: 5,
                playbackUrl: "https://www.bilibili.com/video/BV1oe4y117vc/",
                rfcUrl: "https://pingcap.feishu.cn/docx/ZwhQdo5gNoKkEGxp7wCc9h0snCp",
                githubUrl: "https://github.com/yisaer/tidb/tree/2022_hackathon",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u5BF9 tidb \u4F18\u5316\u5668\u51B3\u7B56\u8FC7\u7A0B\u8FDB\u884C\u53EF\u89C6\u5316\u5C55\u793A"
                    })
                })
            },
            {
                teamName: "\u9E21\u4F60\u592A\u7F8E",
                projectName: "Sibyl",
                score: "79.12",
                rank: 6,
                playbackUrl: "https://www.bilibili.com/video/BV1sV4y1G7zS/",
                rfcUrl: "https://github.com/Sibyl-TiDB/FRC/blob/main/README.md",
                githubUrl: "https://github.com/Sibyl-TiDB",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Sibyl is an Easier-to-use SQL Diagnostics tool for TiDB."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u5C0F\u767D\u4E5F\u80FD\u7528\u7684 SQL \u4F18\u5316\u5DE5\u5177\u3002"
                        })
                    ]
                })
            },
            {
                teamName: "The Powerful Elephants",
                projectName: "make table cache a little better",
                score: "77.09",
                rank: 7,
                playbackUrl: "https://www.bilibili.com/video/BV1u84y1B7VB/",
                rfcUrl: "https://github.com/dbsid/Better-Table-Cache-RFC",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "table cache \u6539\u826F\u8BA1\u5212"
                    })
                })
            },
            {
                teamName: "Canopus",
                projectName: "TiDB \u8BA1\u7B97\u5FAE\u670D\u52A1",
                score: "76.55",
                rank: 8,
                playbackUrl: "https://www.bilibili.com/video/BV1ie4y1U7tQ/",
                rfcUrl: "https://gist.github.com/Benjamin2037/adde8cde57c1b820c5fe4a4e3b6a2983",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u4F5C\u4E3A\u6570\u636E\u5E93\u6838\u5FC3\u6A21\u5757\u7684\u8BA1\u7B97\u5C42\uFF0C\u5728\u6570\u636E\u5E93\u5B9E\u73B0\u4E0A\u4E91\u4E4B\u540E\uFF0C\u662F\u5426\u80FD\u591F\u4E5F\u80FD\u591F\u5C06\u5176\u4E2D\u7684\u8BA1\u7B97\u8FDB\u884C\u5FAE\u670D\u52A1\u5316\u6539\u9020\u5462\uFF1F\u6211\u4EEC\u8FD9\u4E2A\u9879\u76EE\u5C06\u4F1A\u5BF9\u4E8E\u8FD9\u90E8\u5206\u529F\u80FD\u505A\u4E00\u4E2A\u975E\u5E38\u6709\u610F\u601D\u7684\u5C1D\u8BD5\u3002"
                    })
                })
            },
            {
                teamName: "go.unwrap()",
                projectName: "ticli-rs",
                score: "76.05",
                rank: 9,
                playbackUrl: "https://www.bilibili.com/video/BV1bP4y1S737/",
                rfcUrl: "https://github.com/hackathon-2022-ticli/rfc",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "tcli in rust!"
                    })
                })
            },
            {
                teamName: "BLEACH",
                projectName: "BLEACH",
                score: "75.95",
                rank: 10,
                playbackUrl: "https://www.bilibili.com/video/BV1rP411A7mf/",
                rfcUrl: "https://gist.github.com/winoros/035369300804a7804dfb62599f94f8a5",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u4E3A TiDB \u63D0\u4F9B\u4E00\u4E2A\u57FA\u4E8E\u5B66\u4E60\u548C\u89C4\u5219\u7684 SQL \u6587\u672C\u6539\u5199\u524D\u7AEF"
                    })
                })
            },
            {
                teamName: "\u70ED\u70B9\u6E05\u96F6",
                projectName: "Fearless Write Hotspot",
                score: "75.59",
                rank: 11,
                playbackUrl: "https://www.bilibili.com/video/BV1cP4y1S7Xo/",
                rfcUrl: "https://gist.github.com/OneSizeFitsQuorum/da4b1e12b9f216fd3b42e88c57fd9e55",
                githubUrl: "https://github.com/orgs/FWH-TiKV/repositories",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u672C\u9879\u76EE\u5C06\u91C7\u7528 bottom-up \u7684\u8BBE\u8BA1\u601D\u8DEF\uFF0C\u4ECE\u66F4\u597D\u5730\u5229\u7528 CPU\u3001\u78C1\u76D8\u7B49\u8D44\u6E90\u7684\u89D2\u5EA6\u51FA\u53D1\uFF0C\u8003\u8651\u5982\u4F55\u81EA\u5E95\u5411\u4E0A\u89E3\u51B3 TiKV \u7684\u5199\u70ED\u70B9\u95EE\u9898\u3002"
                    })
                })
            },
            {
                teamName: "Leonardo",
                projectName: "WAY@TiDB GIS support",
                score: "74.42",
                rank: 12,
                playbackUrl: "https://www.bilibili.com/video/BV16e41137Vf/",
                rfcUrl: "https://github.com/yiwen92/Hackathon2022_GIS/blob/main/README.md",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Leonardo da Vinci is a versatile talent in history, in this WAY program, we would like to support spatial data in TiDB, make TiDB to support multi-model and become uniform data platform in future."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u5386\u53F2\u4E0A\u7684\u83B1\u6602\u7EB3\u591A.\u8FBE\u82AC\u5947\u662F\u4E00\u4E2A\u5168\u9762\u53D1\u5C55\u7684\u5929\u624D\uFF0C\u5728 WAY \u8FD9\u4E2A\u9879\u76EE\u91CC\uFF0C\u6211\u4EEC\u5E0C\u671B\u5F00\u53D1 TiDB \u4F7F\u5176\u652F\u6301\u7A7A\u95F4\u4FE1\u606F\u6570\u636E\uFF0C\u6269\u5C55 TiDB \u5728\u591A\u6A21\u6570\u636E\u5E93\u4E0A\u7684\u80FD\u529B\u548C\u5E94\u7528\u573A\u666F\uFF0C\u671F\u5F85\u672A\u6765 TiDB \u6210\u4E3A\u4E00\u4E2A\u66F4\u52A0\u901A\u7528\u3001\u5B8C\u6574\u4E14\u7EDF\u4E00\u7684\u5927\u6570\u636E\u5E73\u53F0\u3002"
                        })
                    ]
                })
            },
            {
                teamName: "\u4F60\u8BF4\u90FD\u5BF9",
                projectName: "\u914D\u7F6E\u517C\u5BB9\u6027\u770B\u62A4",
                score: "74.15",
                rank: 13,
                playbackUrl: "https://www.bilibili.com/video/BV1Ue4y1e7jH/",
                rfcUrl: "https://gist.github.com/seiya-annie/95272e315b8ecab27731c579f4d6c2f6",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u914D\u7F6E\u517C\u5BB9\u6027\u770B\u62A4\u5DE5\u5177\u53EF\u4EE5\u5BF9\u914D\u7F6E\u53D8\u66F4\u9879\u8FDB\u884C\u6EAF\u6E90\u627E\u5230\u5F15\u5165\u53D8\u66F4\u7684 PR\uFF1B\u4E5F\u53EF\u4EE5\u5BF9\u7248\u672C\u95F4\u7684\u914D\u7F6E\u517C\u5BB9\u6027\u8FDB\u884C\u6D4B\u8BD5\u53D1\u73B0\u517C\u5BB9\u6027\u95EE\u9898\u3002\u4FDD\u969C\u7248\u672C\u95F4\u7684\u914D\u7F6E\u53D8\u66F4\u4E0D\u4F1A\u5F15\u8D77\u517C\u5BB9\u6027\u95EE\u9898\u3002"
                    })
                })
            },
            {
                teamName: "\u9F99\u54E5\u8BF4\u7684\u90FD",
                projectName: "Placement Rules \u53EF\u89C6\u5316\u914D\u7F6E",
                score: "74.06",
                rank: 14,
                playbackUrl: "https://www.bilibili.com/video/BV1JP4y1S7AY/",
                rfcUrl: "https://gist.github.com/disksing/d9c2b2360e4aaafb260664e450855bfd",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Placement Rules \u53EF\u89C6\u5316\u914D\u7F6E"
                    })
                })
            },
            {
                teamName: "\u66F4\u5B9E\u7528\uFF0C\u66F4\u6613\u7528",
                projectName: "Tidb holding hands with S3",
                score: "73.27",
                rank: 15,
                playbackUrl: "https://www.bilibili.com/video/BV1ZK411D7Ee/",
                rfcUrl: "https://gist.github.com/elsa0520/eea6b02bae43df83bf3f33e3e97b40b9",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u652F\u6301\u5C06\u67E5\u8BE2\u7684\u7ED3\u679C\u96C6\u76F4\u63A5\u5BFC\u51FA\u5230\u6307\u5B9A\u7684s3\u6587\u4EF6\u4E2D"
                    })
                })
            },
            {
                teamName: "P2T",
                projectName: "Postegre sql to TiDB",
                score: "72.55",
                rank: 16,
                playbackUrl: "https://www.bilibili.com/video/BV1Cm4y1w7Ef/",
                rfcUrl: "https://gist.github.com/lichunzhu/8fb7345e29dd2e5ec29fb28043f2b4cf",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u652F\u6301\u8FC1\u79FB postegre sql \u6570\u636E\u5E93\u81F3 TiDB"
                    })
                })
            },
            {
                teamName: "\u4F60\u8BF4\u4E86\u7B97",
                projectName: "AutoIndex",
                score: "72.50",
                rank: 17,
                playbackUrl: "https://www.bilibili.com/video/BV12G411L7vh/",
                rfcUrl: "https://gist.github.com/LittleFall/7f0ddfb2dd6d029e06d22760f6eb1de1",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u4E3A\u4E91\u4E0A TiDB \u96C6\u7FA4\u7ED9\u51FA\u81EA\u52A8\u6DFB\u52A0\u7D22\u5F15\u548C TiFlash \u526F\u672C\u7684\u5EFA\u8BAE\uFF0C\u4EE5\u9AD8\u6548\u4F18\u5316\u7528\u6237\u67E5\u8BE2\u3002"
                    })
                })
            },
            {
                teamName: "Jiekun",
                projectName: "FSDS",
                score: "72.43",
                rank: 18,
                playbackUrl: "https://www.bilibili.com/video/BV1JP4y1S7Nh/",
                rfcUrl: "https://gist.github.com/jiekun/ac4387b613e91c2d4142df35614cab34",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u5BF9\u5916\u5C55\u793A\uFF1A\u4E3A TiDB \u63D0\u4F9B\u5168\u91CF\u6570\u636E\u5BFC\u51FA\u7684\u652F\u6301\uFF0C\u65B9\u4FBF\u6784\u5EFA\u5F02\u6784\u5B58\u50A8/\u6B21\u7EA7\u5B58\u50A8\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "SDS (Full State Data Synchronization)It's very common to use a heterogeneous storage. One important procedure is to replicate full data + change data from TiDB to other storage. With current toolset we need to do this by different setup. TiSync provide low latency, lock-free, 0 write I/O and 0 extra space way to achieve this goal."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u5F02\u6784\u6570\u636E\u5728\u65E5\u5E38\u5F00\u53D1\u4E2D\u975E\u5E38\u5E38\u89C1\uFF0C\u5176\u4E2D\u4E00\u4E2A\u91CD\u8981\u6B65\u9AA4\u662F\u914D\u7F6E\u5168\u91CF+\u589E\u91CF\u6570\u636E\u540C\u6B65\u5230\u5176\u4ED6\u5B58\u50A8\u3002\u4EE5\u73B0\u6709\u7684\u5DE5\u5177\u96C6\u6211\u4EEC\u9700\u8981\u5206\u4E24\u6B65\u6765\u5B8C\u6210\u3002TiSync \u63D0\u4F9B\u4F4E\u5EF6\u8FDF\u3001\u65E0\u9501\u3001\u65E0\u989D\u5916\u5199 I/O \u548C\u65E0\u989D\u5916\u78C1\u76D8\u7A7A\u95F4\u7684\u5168\u91CF+\u589E\u91CF\u540C\u6B65\u5B9E\u73B0\u3002"
                        })
                    ]
                })
            },
            {
                teamName: "cdc-plg",
                projectName: "cdc sink plugin",
                score: "71.25",
                rank: 19,
                playbackUrl: "https://www.bilibili.com/video/BV1se4y1e7bv/",
                rfcUrl: "https://github.com/mischaZhang/cdc-plg/blob/main/README.md",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u6211\u4EEC\u8981\u628Acdc\u7684sink\u4EE5plugin\u7684\u5F62\u5F0F\u4EA4\u4ED8\u7528\u6237\uFF0C\u8BA9\u7528\u6237\u4E0D\u9700\u8981\u91CD\u65B0\u7F16\u8BD1Tiflow\u9879\u76EE\u6253\u5305TiCDC\u5C31\u53EF\u4EE5\u76F4\u63A5\u81EA\u5B9A\u4E49\u903B\u8F91\uFF01\u8BA9\u7528\u6237\u53EF\u4EE5\u628ATiKV\u7684\u6570\u636E\u4ECETiCDC\u53D1\u53BB\u5168\u4E16\u754C\u4EFB\u4F55\u5B58\u50A8\u4E0A\uFF01"
                    })
                })
            },
            {
                teamName: "\u7231\u5403\u82E6\u74DC\u548C\u5927\u7C73",
                projectName: "TiPipeline",
                score: "71.05",
                rank: 20,
                playbackUrl: "https://www.bilibili.com/video/BV1GG4y1h7Sb/",
                rfcUrl: "https://github.com/TiPipeline/rfc",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Better TiFlash execution model\uFF01"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u57FA\u4E8E Hyper morsel driven \u7684\u8BBE\u8BA1\uFF0C\u5B9E\u73B0 thread per core \u7684\u7EBF\u7A0B\u6A21\u578B\uFF0C\u8BA9 TiFlash \u5728\u9AD8\u5E76\u53D1\u573A\u666F\u4E0B\u6709\u5F88\u597D\u7684\u6267\u884C\u6548\u7387\u548C query \u516C\u5E73\u8C03\u5EA6\u3002"
                        })
                    ]
                })
            },
            {
                teamName: "TiDB, YES\uFF01",
                projectName: "fiberpunk",
                score: "70.85",
                rank: 21,
                playbackUrl: "https://www.bilibili.com/video/BV1xe4y127er/",
                rfcUrl: "https://gist.github.com/ywqzzy/b525765462eae7d90a7e41831a6632b3",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u5C06\u4E00\u90E8\u5206\u7EBF\u7A0B\u6C60\u66FF\u6362\u4E3A\u534F\u7A0B\uFF0C\u4ECE\u800C\u63A7\u5236tiflash\u7EBF\u7A0B\u6570\u91CF\u5E76\u5F97\u5230\u4E00\u5B9A\u7684\u6027\u80FD\u63D0\u5347"
                    })
                })
            },
            {
                teamName: "\u5468\u8FB9\u771F\u597D\u770B",
                projectName: "\u5468\u8FB9\u771F\u597D\u770B",
                score: "68.80",
                rank: 22,
                playbackUrl: "https://www.bilibili.com/video/BV1814y157sS/",
                rfcUrl: "https://gist.github.com/waynexia/258ee46f1b88113c383caf1f69ad1ae2",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u57FA\u4E8E eBPF \u8FDB\u884C\u6027\u80FD\u4F18\u5316"
                    })
                })
            },
            {
                teamName: "\u5C0F\u7070\u7070yyds",
                projectName: "TiDB Unified Execution Engine",
                score: "67.40",
                rank: 23,
                playbackUrl: "https://www.bilibili.com/video/BV1wG4y1h7sQ/",
                rfcUrl: "https://gist.github.com/guo-shaoge/e384ea0e06a6508b241dae8877996a6f",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u501F\u52A9 Velox\uFF0C\u4E3A TiDB \u5404\u7EC4\u4EF6\u5B9E\u73B0\u7EDF\u4E00\u7684\u6267\u884C\u5F15\u64CE"
                    })
                })
            },
            {
                teamName: "\u9ED1\u9A6C\u8B66\u957F",
                projectName: "\u8FC1\u79FB\u4E00\u6761\u9F99",
                score: "66.85",
                rank: 24,
                playbackUrl: "https://www.bilibili.com/video/BV1yd4y1y78M/",
                rfcUrl: "https://github.com/mikechengwei/Hackathon-2022/blob/main/Hackathon%202022%20-%20%E9%BB%91%E9%A9%AC%E8%AD%A6%E9%95%BF%20team%E2%80%98s%20RFC.md",
                githubUrl: "https://github.com/mikechengwei/Hack-2022",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u7528\u5FC3\u8FDE\u63A5\u5BFC\u51FA\u5BFC\u5165\u3002\u79DF\u6237\u7684\u9694\u79BB\u9700\u6C42\u6709\u7684\u662F\u5F3A\u9700\u6C42\u6709\u7684\u662F\u5F31\u9700\u6C42\uFF0C\u6709\u7684\u79DF\u6237\u6682\u65F6\u53EA\u9700\u8981\u903B\u8F91\u9694\u79BB\uFF0C\u6709\u7684\u4E00\u5F00\u59CB\u5C31\u9700\u8981\u5F3A\u9694\u79BB\uFF0C\u6709\u7684\u4F1A\u968F\u7740\u4E1A\u52A1\u573A\u666F\u7684\u8F6C\u53D8\u7531\u5F31\u8F6C\u5F3A\uFF0C\u4F1A\u4EA7\u751F\u8FC1\u79FB\u7684\u9700\u6C42\u3002"
                    })
                })
            },
            {
                teamName: "\u961F\u957F\u8D1F\u8D23\u5E26\u996D",
                projectName: "TiBee",
                score: "66.80",
                rank: 25,
                playbackUrl: "https://www.bilibili.com/video/BV1gD4y1k78a/",
                rfcUrl: "https://gist.github.com/devillove084/f16402cfb982f43fa11560471246cc7f",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "2003 \u5E74\uFF0C\u5728 SQL \u7684\u6807\u51C6\u4E2D\u589E\u52A0\u4E86\u4E00\u4E2A\u540D\u4E3A\u201C SQL / MED \u201D\uFF0C\u7FFB\u8BD1\u8FC7\u6765\u662F\u5916\u90E8\u6570\u636E\u7684 SQL \u7BA1\u7406\uFF0C\u662F SQL \u4E3A\u4E86\u7BA1\u7406\u5916\u90E8\u6570\u636E\uFF0C\u4F46\u662F\u53EF\u4EE5\u4F7F\u7528\u6807\u51C6 SQL \u67E5\u8BE2\u7684\u8865\u5145\u534F\u8BAE\u3002\u5176\u53E6\u5916\u4E00\u4E2A\u540D\u5B57 Foreign data wrapper(FDW ) \u53EF\u80FD\u66F4\u8033\u719F\u4E00\u4E9B\u3002\u800C\u672C\u6B21\u9879\u76EE\u5C31\u4E3A\u4E86\u5C1D\u8BD5\u89E3\u51B3 TiDB \u7F3A\u5931\u7684 FDW \u673A\u5236\u63D0\u51FA\u7684\u65B0\u8BBE\u8BA1\u3002"
                    })
                })
            },
            {
                teamName: "Sightseeing",
                projectName: "\u57FA\u4E8EeBPF\u7684TiDB\u6570\u636E\u6D41\u76D1\u63A7\u5DE5\u5177",
                score: "66.60",
                rank: 26,
                playbackUrl: "https://www.bilibili.com/video/BV1me4y177ow/?",
                rfcUrl: "https://gist.github.com/ri-char/9fdf7d070bedb3c934b15757c6f9e35c",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u8BE5\u9879\u76EE\u901A\u8FC7eBPF\u4EE5\u53CATiDB\u3001TiKV\u7684\u63D2\u4EF6\u7CFB\u7EDF\uFF0C\u5B9E\u73B0\u5BF9\u6570\u636E\u6D41\u7684\u7EDF\u8BA1\u76D1\u63A7\uFF0C\u7ED8\u5236\u51FA\u5B9E\u65F6\u7684\u6570\u636E\u6D41\u56FE\uFF0C\u5F25\u8865DashBoard\u5173\u4E8E\u8BE5\u65B9\u9762\u7684\u4E0D\u8DB3\u3002"
                    })
                })
            },
            {
                teamName: "BetterTP",
                projectName: "BetterTP",
                score: "65.45",
                rank: 27,
                playbackUrl: "https://www.bilibili.com/video/BV14g411z7LA/",
                rfcUrl: "https://github.com/TiDBHackers/rfc/blob/master/text/why_and_how_does_round_trip_matters.md",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u5C1D\u8BD5\u5BFB\u627E TiDB OLTP \u6027\u80FD\u4F18\u5316\u65B9\u5411"
                    })
                })
            },
            {
                teamName: "ng-raft-engine",
                projectName: "ng-raft-engine",
                score: "64.12",
                rank: 28,
                playbackUrl: "https://www.bilibili.com/video/BV1gG411j7en/",
                rfcUrl: "https://gist.github.com/JaySon-Huang/e5910520ea377c65d1a68da013874530",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Next generation raft engine"
                    })
                })
            },
            {
                teamName: "\u716E\u9152\u8BBA\u82F1\u96C4",
                projectName: "TiInverted",
                score: "63.47",
                rank: 29,
                playbackUrl: "https://www.bilibili.com/video/BV1LV4y1G7fC/",
                rfcUrl: "https://gist.github.com/Dousir9/3600403b85739a8653906e89fa6371bd",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "TiInverted \u4E3B\u8981\u89E3\u51B3 TiDB \u76EE\u524D\u7F3A\u5C11\u5BF9\u5168\u6587\u641C\u7D22(Full-Text Search)\u7684\u652F\u6301\u95EE\u9898\uFF0C\u89E3\u51B3\u7528\u6237\u5728\u68C0\u7D22\u6587\u672C\u65F6\u9047\u5230\u7684\u75DB\u70B9\u3002TiInverted \u4E3A TiDB \u65B0\u589E\u4E00\u4E2A\u529F\u80FD\uFF0C\u4F7F\u5F97\u7528\u6237\u53EF\u4EE5\u5728\u57FA\u4E8E\u6587\u672C\u7684\u5217(CHAR\u3001VARCHAR\u3001TEXT \u7B49)\u4E0A\u5EFA\u7ACB\u5012\u6392\u7D22\u5F15\uFF0C\u5E76\u9002\u914DMySQL\u7684\u5168\u6587\u641C\u7D22\u529F\u80FD\u7684\u8BED\u6CD5\uFF0C\u4ECE\u800C\u5B9E\u73B0\u5728\u8FD9\u4E00\u5217\u4E0A\u66F4\u9AD8\u6548\u3001\u66F4\u590D\u6742\u6570\u636E\u68C0\u7D22\uFF0C\u6B64\u5916\u8FD8\u53EF\u4EE5\u7ED3\u5408NLP\u7684\u6280\u672F\uFF0C\u5141\u8BB8\u7528\u6237\u8BBE\u5B9A\u6A21\u5F0F\uFF0C\u4EE5\u5728\u68C0\u7D22\u65F6\u83B7\u53D6\u76F8\u5173\u6027\u66F4\u9AD8\u7684\u641C\u7D22\u7ED3\u679C\uFF0C\u5B9E\u73B0\u6570\u636E\u5E93\u667A\u80FD\u5316\uFF08AI4DB\uFF09\u7684\u5B8F\u89C2\u76EE\u6807\u3002"
                    })
                })
            },
            {
                teamName: "\u82CD\u8747\u817F\u4E5F\u662F\u8089",
                projectName: "\u4F18\u5316\u5668\u652F\u6301 INDEX SKIP SCAN",
                score: "61.10",
                rank: 30,
                playbackUrl: "https://www.bilibili.com/video/BV1HP4y1S7Xh/",
                rfcUrl: "https://gist.github.com/maguoshun/3d72c5610fb979f20f9a9ee563529de9",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u7ED9 TiDB \u4F18\u5316\u5668\u652F\u6301 index skip scan\uFF0C\u5E76\u590D\u7528 index skip scan \u7684\u80FD\u529B\uFF0C\u5B9E\u73B0 group by \u548C distinct \u7684 loose index scan"
                    })
                })
            },
            {
                teamName: "\u5C0F\u874C\u86AA\u627E\u5988\u5988",
                projectName: "TiQ",
                score: "60.20",
                rank: 31,
                playbackUrl: "https://www.bilibili.com/video/BV1iG411L7AV/",
                rfcUrl: "https://gist.github.com/hunknownz/287910f1d661d35952f4c2bc758d7eaa",
                githubUrl: "",
                introduction: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "TiDB\u5185\u7F6E\u6D88\u606F\u961F\u5217\uFF0CSQL\u8BED\u6CD5\u4E0A\u652F\u6301\u8BA2\u9605"
                    })
                })
            }, 
        ]
    }, 
];
var dataPrize = {
    topPrize: {
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "\u5404\u8D5B\u9053 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#00CF71"
                    },
                    children: "Top 6"
                }),
                " \u5747\u53EF\u83B7\u5F97\u73B0\u91D1"
            ]
        }),
        items: [
            {
                name: "\u51A0\u519B",
                thing: "\xa5 50,000",
                target: "1 \u652F\u961F\u4F0D / \u8D5B\u9053"
            },
            {
                name: "\u4E9A\u519B",
                thing: "\xa5 25,000",
                target: "2 \u652F\u961F\u4F0D / \u8D5B\u9053"
            },
            {
                name: "\u5B63\u519B",
                thing: "\xa5 15,000",
                target: "3 \u652F\u961F\u4F0D / \u8D5B\u9053"
            }, 
        ]
    },
    prizes: [
        {
            name: "\u7279\u522B\u5956\u9879",
            categories: [
                {
                    name: "\u4EC5\u5E94\u7528\u7EC4",
                    items: [
                        {
                            name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "\u6700\u4F73\u521B\u610F\u5956"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            fontSize: 14,
                                            color: "#CCC"
                                        },
                                        children: "\u7531\u4E91\u542F\u8D44\u672C\u51A0\u540D\u8D5E\u52A9"
                                    })
                                ]
                            }),
                            thing: "\xa5 5,000",
                            target: "1 \u652F\u961F\u4F0D"
                        },
                        {
                            name: "\u516C\u76CA\u8D21\u732E\u5956",
                            thing: "\xa5 5,000",
                            target: "1 \u652F\u961F\u4F0D"
                        },
                        {
                            name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "\u6280\u672F\u8D8B\u52BF\u5956"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            fontSize: 14,
                                            color: "#CCC"
                                        },
                                        children: "\u7531\u534E\u521B\u8D44\u672C\u51A0\u540D\u8D5E\u52A9"
                                    })
                                ]
                            }),
                            thing: "\xa5 5,000",
                            target: "1 \u652F\u961F\u4F0D"
                        },
                        {
                            name: "Cloud \u5E94\u7528\u751F\u6001\u5956\uFF08API\uFF09",
                            thing: "\xa5 5,000",
                            target: "1 \u652F\u961F\u4F0D"
                        }, 
                    ]
                },
                {
                    name: "\u5E94\u7528\u7EC4 & TiDB \u4EA7\u54C1\u7EC4",
                    items: [
                        {
                            name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "\u6700\u4F73\u4EBA\u6C14\u5956"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            fontSize: 14,
                                            color: "#CCC"
                                        },
                                        children: "\u7531 GGV \u8D44\u672C\u51A0\u540D\u8D5E\u52A9"
                                    })
                                ]
                            }),
                            thing: "\u952E\u9F20\u5957\u88C5 / \u4EBA ",
                            target: "1 \u652F\u961F\u4F0D / \u8D5B\u9053"
                        },
                        {
                            name: "\u6700\u4F73\u6821\u56ED\u5956",
                            thing: "\xa5 5,000",
                            target: "1 \u652F\u961F\u4F0D / \u8D5B\u9053"
                        },
                        {
                            name: "\u7528\u6237\u4E4B\u9009\u5956",
                            thing: "\xa5 5,000",
                            target: "1 \u652F\u961F\u4F0D / \u8D5B\u9053"
                        }, 
                    ]
                }, 
            ]
        }, 
    ],
    footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "\u6CE8\uFF1A\u6240\u6709\u5956\u9879\u5956\u91D1\u5747\u4E3A\u7A0E\u524D\u91D1\u989D\uFF0C\u5956\u9879\u8BC4\u9009\u89C4\u5219\u53EF\u53C2\u8003",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                href: scoreRule,
                children: "\u8BC4\u5206\u89C4\u5219"
            }),
            "\u3002"
        ]
    })
};
var dataParticipationWelfare = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_0, {}),
        text: "\u4E13\u4E1A\u5BFC\u5E08\u8D5B\u524D\u8F85\u5BFC"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_1, {}),
        text: "\u6280\u672F\u540C\u597D\u73B0\u573A\u4EA4\u6D41"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_2, {}),
        text: "\u8BC4\u59D4\u5927\u5496\u4E13\u4E1A\u6307\u5BFC"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_3, {}),
        text: "\u4E07\u5143\u4E30\u539A\u73B0\u91D1\u5956\u52B1"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_4, {}),
        text: "\u53C2\u8D5B\u4E13\u5C5E\u5468\u8FB9\u793C\u5305"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_5, {}),
        text: "\u4F18\u79C0\u9879\u76EE\u591A\u91CD\u66DD\u5149"
    }, 
];
var dataJudge = [
    {
        avatar: _,
        name: "\u9648\u6631",
        title: "\u4E91\u542F\u8D44\u672C\u5408\u4F19\u4EBA",
        quotation: "\u91CD\u70B9\u5173\u6CE8\u57FA\u7840\u8F6F\u4EF6\u3001\u5927\u6570\u636E\u3001\u4E91\u8BA1\u7B97\u3001\u667A\u80FD\u9A7E\u9A76\u548C\u673A\u5668\u4EBA\u7B49\u9886\u57DF\u7684\u6295\u8D44\u3002\u4E3B\u5BFC\u6295\u8D44\u4E86 PingCAP\u3001Zilliz\u3001Jina AI\u3001Singularity\u3001TigerGraph\u3001Cloudchef\u3001\u5143\u620E\u542F\u884C\u3001\u64CE\u6717\u667A\u80FD\u3001\u667A\u9F7F\u79D1\u6280\u3001\u5FB7\u98CE\u79D1\u6280\u3001\u65B0\u77F3\u5668\u3001\u4E00\u9020\u673A\u5668\u4EBA\u7B49\u4F18\u79C0\u4F01\u4E1A\u3002"
    },
    {
        avatar: Chuang_Pei_Han_,
        name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "Chuang Pei-Han"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        color: "#00CF71"
                    },
                    children: "\uFF08\u7279\u7EA6\u4E13\u9879\u8BC4\u59D4\uFF09"
                })
            ]
        }),
        title: "Morpheus Labs CEO",
        quotation: "A serial entrepreneur with years of experience in business development, product marketing and partnership management. He has successfully raised series of fundings for his businesses, including a USD 7 digits seed funding round. One of the earliest adopters of blockchain technology\n"
    },
    {
        avatar: avatar_,
        name: "\u9AD8\u658C",
        title: "PingCAP \u6570\u636E\u5E73\u53F0\u4EA7\u54C1\u8D1F\u8D23\u4EBA",
        quotation: "\u6570\u636E\u5E93\u9886\u57DF\u4ECE\u4E1A20\u5E74\u8001\u5175\uFF0C\u5BF9\u4E8E\u5173\u7CFB\u578B\u6570\u636E\u5E93\u76F8\u5173\u9886\u57DF\u6709\u6DF1\u5165\u4E86\u89E3\u3002\u51FA\u7248\u8FC7\u4E13\u8457\u300AOracle RAC \u6838\u5FC3\u6280\u672F\u8BE6\u89E3\u300B"
    },
    {
        avatar: Judge_avatar_,
        name: "\u90ED\u78CA\u6D9B",
        title: "\u7231\u5947\u827A\u6570\u636E\u5E93\u670D\u52A1\u8D1F\u8D23\u4EBA",
        quotation: "\u76EE\u524D\u81F4\u529B\u4E8E\u7231\u5947\u827A\u6DF7\u5408\u4E91\u6570\u636E\u5E93\u5EFA\u8BBE\u53CA\u4E91\u539F\u751F\u67B6\u6784\u843D\u5730\u3002"
    },
    {
        avatar: hackathon2022_Judge_avatar_,
        name: "\u9EC4\u4E1C\u65ED",
        title: "PingCAP \u8054\u5408\u521B\u59CB\u4EBA\u517C CTO",
        quotation: "\u8D44\u6DF1\u57FA\u7840\u8F6F\u4EF6\u5DE5\u7A0B\u5E08\uFF0C\u67B6\u6784\u5E08\uFF0C\u66FE\u5C31\u804C\u4E8E\u5FAE\u8F6F\u4E9A\u6D32\u7814\u7A76\u9662\uFF0C\u7F51\u6613\u6709\u9053\u53CA\u8C4C\u8C46\u835A\uFF0C\u64C5\u957F\u5206\u5E03\u5F0F\u7CFB\u7EDF\u4EE5\u53CA\u6570\u636E\u5E93\u5F00\u53D1\uFF0C\u5728\u5206\u5E03\u5F0F\u5B58\u50A8\u9886\u57DF\u6709\u4E30\u5BCC\u7684\u7ECF\u9A8C\u548C\u72EC\u5230\u7684\u89C1\u89E3\u3002\u72C2\u70ED\u7684\u5F00\u6E90\u7231\u597D\u8005\u4EE5\u53CA\u5F00\u6E90\u8F6F\u4EF6\u4F5C\u8005\uFF0C\u4EE3\u8868\u4F5C\u54C1\u5206\u5E03\u5F0F Redis \u7F13\u5B58\u65B9\u6848 Codis\uFF0C\u4EE5\u53CA\u5206\u5E03\u5F0F\u5173\u7CFB\u578B\u6570\u636E\u5E93 TiDB\u30022015 \u5E74\u521B\u4E1A\uFF0C\u6210\u7ACB PingCAP\uFF0C\u5728 PingCAP \u7684\u4E3B\u8981\u5DE5\u4F5C\u662F\u4ECE\u96F6\u5F00\u59CB\u8BBE\u8BA1\u5E76\u7814\u53D1\u5F00\u6E90 NewSQL \u6570\u636E\u5E93 TiDB\uFF0C\u76EE\u524D GitHub \u4E0A\u8BE5\u9879\u76EE\u7D2F\u79EF star \u6570\u8D85\u8FC7 29000+\uFF0C\u6210\u4E3A\u672C\u9886\u57DF\u5168\u7403\u9876\u7EA7\u7684\u5F00\u6E90\u9879\u76EE\u3002"
    },
    {
        avatar: events_hackathon2022_Judge_avatar_,
        name: "\u9EC4\u6F47",
        title: "PingCAP Outbound PM",
        quotation: "\u524D\u7F8E\u56E2 DBA Leader \u548C\u524D TUG \u5317\u4EAC\u533A Leader\uFF0C10+ \u5E74 DBA\u3001DevOps \u7ECF\u9A8C"
    },
    {
        avatar: pages_events_hackathon2022_Judge_avatar_,
        name: "\u674E\u96E8\u6765",
        title: "TiDB Committer, Seaweedfs Contributor",
        quotation: ""
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_,
        name: "\u5218\u806A",
        title: "PingCAP \u8D44\u6DF1\u5F00\u53D1\u5DE5\u7A0B\u5E08",
        quotation: "15 \u5E74\u5B58\u50A8\u9886\u57DF\u6280\u672F\u4E13\u5BB6\uFF0C\u52A0\u5165 PingCAP \u540E\u5728 TiKV \u3001PD \u7B49\u9886\u57DF\u6DF1\u5165\u7CBE\u8015\u591A\u5E74"
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_0,
        name: "\u5218\u5B50\u4E1C",
        title: "\u5C0F\u7C73\u6570\u636E\u5E93\u5DE5\u7A0B\u5E08\uFF0CTiDB Committer",
        quotation: ""
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_1,
        name: "\u9A6C\u6D2A\u5BBE",
        organization: "kyligence",
        title: "Kyligence \u6280\u672F\u5408\u4F19\u4EBA\uFF0CApache Kylin \u793E\u533A PMC \u6210\u5458",
        quotation: ""
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_2,
        name: "\u6C88\u65F8",
        title: "\u8054\u6613\u878D\u526F\u603B\u88C1",
        quotation: "\u8054\u6613\u878D\u526F\u603B\u88C1\uFF0C\u524D\u795E\u5DDE\u6570\u7801\u96C6\u56E2\u526F\u603B\u88C1\u517C CIO\u3002\u5728\u96C6\u56E2\u6570\u5B57\u5316\u8F6C\u578B\u3001SAP\u54A8\u8BE2\u3001\u6570\u5B57\u4E2D\u53F0\u3001\u8425\u9500\u79C1\u57DF\u8FD0\u8425\u3001\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u3001\u5F00\u6E90 ERP\u3001SAAS \u7B49\u9886\u57DF\u7684\u5F00\u53D1\u7BA1\u7406\u5DE5\u4F5C\u6709\u4E30\u5BCC\u7684\u7ECF\u9A8C\uFF0C\u9886\u5BFC Tidb4PG \u5F00\u6E90\u9879\u76EE\u3002"
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_3,
        name: "\u5B59\u6653\u5149",
        organization: "PingCAP",
        title: "TiDB Cloud Ecosystem \u7814\u53D1\u8D1F\u8D23\u4EBA",
        quotation: ""
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_4,
        name: "\u5510\u5218",
        title: "PingCAP \u7814\u53D1\u526F\u603B\u88C1",
        quotation: "TiDB Maintainer \uFF0C\u76EE\u524D\u4E3B\u8981\u8D1F\u8D23\u6784\u5EFA TiDB Cloud\u3002"
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_5,
        name: "\u738B\u806A",
        title: "PingCAP SQL \u7814\u53D1\u8D1F\u8D23\u4EBA",
        quotation: ""
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_6,
        name: "\u5434\u6D77\u71D5",
        title: "\u534E\u521B\u8D44\u672C\u7BA1\u7406\u5408\u4F19\u4EBA",
        quotation: "\u8D1F\u8D23\u534E\u521B\u8D44\u672C\u57FA\u91D1\u7BA1\u7406\u5DE5\u4F5C\uFF0C\u5E76\u7275\u5934\u8D1F\u8D23\u534E\u521B\u4F01\u4E1A\u8F6F\u4EF6\u9886\u57DF\u7684\u6295\u8D44\uFF0C\u6BD5\u4E1A\u4E8E\u6E05\u534E\u5927\u5B66\u3002"
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_7,
        name: "\u8C22\u5B5F\u519B",
        title: "\u79EF\u68A6\u667A\u80FD CEO\uFF0CGoCN \u793E\u533A\u53D1\u8D77\u4EBA",
        quotation: ""
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_8,
        name: "\u5F90\u6210\u9009",
        title: "PingCAP DM \u7814\u53D1\u8D1F\u8D23\u4EBA",
        quotation: "10 \u5E74\u57FA\u7840\u67B6\u6784\u53CA\u6570\u636E\u5E73\u53F0\u7814\u53D1\u7ECF\u9A8C\uFF0CKingshard \u6838\u5FC3\u5F00\u53D1\uFF0CGaea\uFF08\u5206\u5E93\u5206\u8868\u4E2D\u95F4\u4EF6\uFF09\u4F5C\u8005\uFF0CTiDB ToC \u6210\u5458"
    },
    {
        avatar: src_pages_events_hackathon2022_Judge_avatar_9,
        name: "\u5F20\u4E1C\u6656",
        title: "PingCAP \u4EA7\u7814\u987E\u95EE",
        quotation: "\u66FE\u5728\u5FAE\u8F6F\u4ECE\u4E8B\u4EA7\u54C1\u7814\u53D1 15 \u5E74\uFF0C\u4E4B\u540E\u5728\u963F\u91CC\u4E91\u53C2\u4E0E\u98DE\u5929\u3001\u5927\u6570\u636E\u5E73\u53F0\u3001\u548C\u4E91\u8BA1\u7B97\u5E73\u53F0\u7684\u5F00\u53D1\u548C\u4EA7\u54C1\u5DE5\u4F5C\u3002\u7ECF\u5386\u4E86\u5F00\u6E90\u8F6F\u4EF6\u6539\u53D8\u8F6F\u4EF6\u884C\u4E1A\u7684\u5386\u53F2\uFF0C\u5BF9\u5F00\u6E90\u793E\u533A\u548C\u6570\u636E\u5E93\u3001\u4E91\u8BA1\u7B97\u3001\u4EBA\u5DE5\u667A\u80FD\u6280\u672F\u6709\u6301\u4E45\u7684\u5174\u8DA3\u3002"
    }, 
];
var dataFAQ = {
    items: [
        {
            question: "1. \u6BCF\u652F\u53C2\u8D5B\u961F\u4F0D\u6700\u591A\u51E0\u4E2A\u4EBA\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "\u56E2\u961F\u53C2\u8D5B\u6700\u591A 4 \u4EBA\u4E3A\u4E00\u4E2A\u5C0F\u7EC4\u3002\u5355\u4EBA\u53C2\u8D5B\u4E5F\u652F\u6301\u54E6\uFF5E"
                })
            })
        },
        {
            question: "2. \u6CA1\u6709\u961F\u53CB\u600E\u4E48\u529E\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    children: [
                        "\u53EF\u4EE5\u5728",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                            href: joinGroupHelpUrl,
                            children: "\u7EC4\u961F\u6307\u5357"
                        }),
                        "\u53D1\u5E03\u5BFB\u627E\u961F\u53CB\u3001\u81EA\u6211\u63A8\u8350\uFF0C\u627E\u5230\u56E2\u961F\u7F3A\u5C11\u7684\u961F\u53CB\uFF0C\u4E5F\u53EF\u4EE5\u627E\u5230\u5408\u9002\u7684\u961F\u4F0D\u52A0\u5165\u3002"
                    ]
                })
            })
        },
        {
            question: "3. \u60F3\u4E0D\u5230\u597D\u7684\u521B\u610F\u60F3\u6CD5\u600E\u4E48\u529E\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "\u9501\u5B9A 9 \u6708 17 \u65E5\u300CTiDB Hackathon 2022 \u975E\u6B63\u5F0F\u4F1A\u8C08 \u2014 \u4E1C\u65ED\u521B\u610F\u8111\u66B4\u4F1A\u300D\uFF0C\u542C\u542C\u8D44\u6DF1\u67B6\u6784\u5E08\u4EEC\u7684\u521B\u610F\u60F3\u6CD5\uFF0C\u627E\u5230\u5C5E\u4E8E\u4F60\u7684\u7075\u611F\u3002",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: liveUrl,
                                children: "\u9884\u7EA6\u76F4\u64AD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "\u4E5F\u53EF\u4EE5\u5728",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: ideaUrl,
                                children: "\u521B\u610F\u5E93"
                            }),
                            "\u770B\u770B\u793E\u533A\u5F00\u53D1\u8005\u4EEC\u7684\u60F3\u6CD5\uFF0C\u6FC0\u53D1\u4F60\u7684\u521B\u610F"
                        ]
                    })
                ]
            })
        },
        {
            question: "4. \u4E3B\u529E\u65B9\u63D0\u4F9B\u9910\u996E\u548C\u4F4F\u5BBF\u5417\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "\u6211\u4EEC\u63D0\u4F9B\u53C2\u8D5B\u8005\u548C\u5FD7\u613F\u8005\u6BD4\u8D5B\u671F\u95F4\u7684\u9910\u996E\uFF08\u4E24\u4EFD\u5348\u9910\u3001\u4E00\u4EFD\u65E9\u9910\u3001\u4E24\u4EFD\u665A\u9910\uFF09\uFF0C\u53C2\u8D5B\u9009\u624B\u53EF\u7559\u5728\u6BD4\u8D5B\u573A\u5730\u8FC7\u591C\uFF0C\u5982\u9700\u5728\u573A\u5730\u9644\u8FD1\u79DF\u4F4F\u5BBE\u9986\u8BF7\u81EA\u884C\u89E3\u51B3\uFF5E"
                })
            })
        },
        {
            question: "5. \u6BD4\u8D5B\u4F1A\u7531\u4E8E\u75AB\u60C5\u53D6\u6D88\u5417\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "\u6211\u4EEC\u4F1A\u5BC6\u5207\u5173\u6CE8\u75AB\u60C5\u52A8\u5411\uFF0C\u5982\u6709\u4E0D\u53EF\u6297\u529B\u5219\u6BD4\u8D5B\u4F1A\u6539\u4E3A\u5168\u7A0B\u7EBF\u4E0A\uFF0C\u4E0D\u4F1A\u53D6\u6D88\u54E6\uFF5E"
                })
            })
        },
        {
            question: "6. \u4F1A\u573A\u5206\u522B\u5728\u54EA\u4E9B\u57CE\u5E02\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "\u4E0A\u6D77\u3001\u5317\u4EAC\u3001\u5E7F\u5DDE\u3001\u6210\u90FD\u3001\u65B0\u52A0\u5761\uFF0C\u4E0A\u8FF0\u5730\u533A\u8FDB\u5165\u51B3\u8D5B\u961F\u4F0D\u8D85\u8FC7\u4E94\u7EC4\u65F6\uFF0C\u8BE5\u573A\u5730\u5C06\u5F00\u542F\u7EBF\u4E0B\u4F1A\u573A\u3002\u6B22\u8FCE\u5C31\u8FD1\u73B0\u573A\u53C2\u52A0\u3002"
                })
            })
        },
        {
            question: "7. \u4EC0\u4E48\u65F6\u5019\u53EF\u4EE5\u5F00\u59CB\u7F16\u5199\u4EE3\u7801\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "\u51B3\u8D5B\u73B0\u573A coding\u3002\u672C\u6B21\u6D3B\u52A8\u4E0D\u5141\u8BB8\u5077\u8DD1\u54DF\uFF0C\u51B3\u8D5B\u73B0\u573A\u8BC4\u59D4\u4F1A\u4E25\u683C\u5BA1\u67E5\u53C2\u8D5B\u9009\u624B\u7684\u4F5C\u54C1\u662F\u5426\u7B26\u5408\u201C\u7B2C\u4E00\u884C\u4EE3\u7801\u63D0\u4EA4\u65F6\u95F4\u9700\u5728\u521D\u8D5B\u7ED3\u679C\u516C\u793A\u540E\u201D\u8FD9\u4E00\u89C4\u5219\u3002"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "\u5982\u679C\u9047\u5230",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: studyResourceUrl,
                                children: "\u5B66\u4E60\u8D44\u6599"
                            }),
                            "\u4E2D\u5C1A\u672A\u89E3\u7B54\u7684\u95EE\u9898\uFF0C\u53EF\u4EE5\u6DFB\u52A0\u5C0F\u52A9\u624B\u5FAE\u4FE1\uFF1Adbasupport\uFF0C\u52A0\u5165 Hackathon 2022 \u53C2\u8D5B\u7FA4\uFF0C\u7FA4\u5185\u5C06\u6709\u5BFC\u5E08\u4E0D\u5B9A\u671F\u7EBF\u4E0A\u7B54\u7591\uFF0C\u4EE5\u53CA\u96C6\u4E2D\u76F4\u64AD\u5206\u4EAB\u3002"
                        ]
                    })
                ]
            })
        },
        {
            question: "8. \u6700\u4F73\u6821\u56ED\u5956\u53C2\u4E0E\u8BC4\u5956\u7684\u4EBA\u7FA4\u662F\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "\u56E2\u961F\u6210\u5458\u9700\u8981\u5168\u5458\u7686\u4E3A\uFF1A\u5728\u6821\u672C\u79D1\u751F\u3001\u7855\u58EB\u7814\u7A76\u751F\u3001\u535A\u58EB\u7814\u7A76\u751F\uFF0C\u4E14\u8FDB\u5165\u51B3\u8D5B\u73AF\u8282\u3002"
                })
            })
        },
        {
            question: "9. \u62A5\u540D\u53C2\u8D5B\u5C31\u53EF\u4EE5\u83B7\u5F97\u672C\u6B21\u83B7\u5F97\u7684\u53C2\u8D5B\u5927\u793C\u5305\u5417\uFF1F",
            answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "\u53C2\u8D5B\u5F00\u53D1\u8005\u9700\u8981\u63D0\u4EA4 RFC \u540E\uFF0CRFC \u901A\u8FC7\u521D\u5BA1\uFF0C\u8FDB\u5165\u51B3\u8D5B\u5C31\u53EF\u4EE5\u73B0\u573A\u9886\u53D6\u53C2\u8D5B\u5927\u793C\u5305\u54DF\uFF5E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: RfcSubmitFormUrl,
                                children: "\u5B8C\u6210 RFC \u63D0\u4EA4"
                            }),
                            "\uFF0C\u53EF\u53C2\u4E0E\u62BD\u5956 \uFF1A\u6BD4\u8D5B\u5F00\u59CB\u540E\uFF0C\u5C06\u4ECE\u7279\u5B9A\u65F6\u95F4\u6BB5\u5185\u6210\u529F\u63D0\u4EA4 RFC \u7684\u56E2\u961F\u62BD\u53D6\u82E5\u5E72\u652F\u56E2\u961F\uFF0C\u9001\u51FA TiDB \u793E\u533A\u795E\u79D8\u793C\u5305",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "9/13 - 9/22 \uFF1A\u62BD\u53D6 4 \u652F"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "9/22 - 9/30 \uFF1A\u62BD\u53D6 3 \u652F"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "10/1 - 10/14\uFF1A\u62BD\u53D6 2 \u652F"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }, 
    ],
    footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "\u66F4\u591A\u95EE\u7B54\uFF0C\u8BF7\u70B9\u51FB",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                href: askCompetitionUrl,
                children: "\u8D5B\u4E8B FAQ"
            })
        ]
    })
};
var dataPartner = [
    {
        name: "\u91D1\u724C\u8D5E\u52A9",
        items: [
            {
                image: logo_1_1
            },
            {
                image: logo_1_2
            },
            {
                image: logo_1_3
            }
        ]
    },
    {
        name: "\u94F6\u724C\u8D5E\u52A9",
        items: [
            {
                image: logo_1_4
            }
        ]
    },
    {
        name: "\u4E91\u8D44\u6E90\u8D5E\u52A9/\u4E91\u6280\u672F\u670D\u52A1\u652F\u6301",
        items: [
            {
                image: logo_2_1
            },
            {
                image: logo_2_2
            },
            {
                image: logo_2_3
            }
        ]
    },
    {
        name: "\u534F\u529E\u65B9",
        items: [
            {
                image: logo_2_4
            },
            {
                image: logo_2_5
            }
        ]
    },
    {
        name: "\u5408\u4F5C\u793E\u533A",
        items: [
            {
                image: logo_3_1
            },
            {
                image: logo_3_2
            },
            {
                image: logo_3_3
            },
            {
                image: logo_3_4
            },
            {
                image: logo_3_5
            },
            {
                image: logo_3_6
            },
            {
                image: logo_3_7
            },
            {
                image: logo_3_8
            },
            {
                image: logo_3_9
            },
            {
                image: logo_3_10
            },
            {
                image: logo_3_11
            },
            {
                image: logo_3_12
            },
            {
                image: logo_3_13
            },
            {
                image: logo_3_14
            },
            {
                image: logo_3_15
            },
            {
                image: logo_3_16
            },
            {
                image: logo_3_17
            },
            {
                image: logo_3_18
            },
            {
                image: logo_3_19
            },
            {
                image: logo_3_20
            },
            {
                image: logo_3_21
            },
            {
                image: logo_3_22
            },
            {
                image: logo_3_23
            },
            {
                image: logo_3_24
            },
            {
                image: logo_3_25
            },
            {
                image: logo_3_26
            },
            {
                image: logo_3_27
            },
            {
                image: logo_3_28
            },
            {
                image: logo_3_29
            },
            {
                image: logo_3_30
            },
            {
                image: logo_3_31
            },
            {
                image: logo_3_32
            },
            {
                image: logo_3_33
            },
            {
                image: logo_3_34
            },
            {
                image: logo_3_35
            },
            {
                image: logo_3_36
            },
            {
                image: logo_3_37
            },
            {
                image: logo_3_38
            }, 
        ]
    }, 
];

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/FinalistTeam/index.tsx
function FinalistTeam_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FinalistTeam_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FinalistTeam_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FinalistTeam_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = FinalistTeam_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function FinalistTeam_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var FinalistTeam_FinalistTeam = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = FinalistTeam_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalistTeam_index_styled_MyContainer, FinalistTeam_objectSpread({}, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
            gutter: [
                24,
                24
            ],
            children: dataFinalist.map(function(group) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    md: 24,
                    lg: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalistTeam_index_styled_SectionTitle, {
                                style: {
                                    color: group.color
                                },
                                children: group.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_SectionBody, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    cellPadding: 8,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                style: {
                                                    background: group.color
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "\u56E2\u961F\u540D\u79F0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "\u9879\u76EE\u540D\u79F0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "\u51B3\u8D5B\u5F97\u5206"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "\u51B3\u8D5B\u6392\u540D"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                            children: group.items.map(function(value) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                                                placement: "topLeft",
                                                                title: value.teamName,
                                                                color: "#20222B",
                                                                overlayInnerStyle: {
                                                                    padding: 16,
                                                                    color: "#FFF",
                                                                    fontSize: 12,
                                                                    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.25)"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamName, {
                                                                    children: value.teamName
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            style: {
                                                                color: group.color
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                                                placement: "bottom",
                                                                color: "#20222B",
                                                                overlayInnerStyle: {
                                                                    padding: 16,
                                                                    color: "#FFF",
                                                                    fontSize: 12,
                                                                    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.25)"
                                                                },
                                                                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipIntroduction, {
                                                                            children: value.introduction
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipAction, {
                                                                            $color: group.color,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                                                                size: 16,
                                                                                children: [
                                                                                    value.githubUrl.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                                                        href: value.githubUrl,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipActionItem, {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_GithubFilled, {
                                                                                                style: {
                                                                                                    fontSize: 24
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    }),
                                                                                    !value.playbackUrl.startsWith("http") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                                                                        title: value.playbackUrl,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipActionItem, {
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleFilled/* default */.Z, {
                                                                                                    style: {
                                                                                                        fontSize: 24
                                                                                                    }
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                                                        href: value.playbackUrl,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipActionItem, {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleFilled/* default */.Z, {
                                                                                                style: {
                                                                                                    fontSize: 24
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                                                        href: value.rfcUrl,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipActionItem, {
                                                                                            children: "RFC"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: value.projectName
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: value.score
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: value.rank
                                                            })
                                                        })
                                                    ]
                                                }, value.teamName);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                });
            })
        })
    }));
};
/* harmony default export */ var hackathon2022_FinalistTeam = (FinalistTeam_FinalistTeam);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/CompetitionProcess/index.styled.ts
function CompetitionProcess_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompetitionProcess_index_styled_templateObject() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        ""
    ]);
    CompetitionProcess_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject1() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  padding: 6px 10px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  background-color: #82c1ed;\n  color: #ffffff !important;\n  border: 1px solid #82c1ed;\n  &:hover {\n    background-color: #00cf71;\n    border-color: #00cf71;\n  }\n  a {\n  }\n"
    ]);
    CompetitionProcess_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject2() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  padding: 6px 10px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  color: #82c1ed;\n  border: 1px solid #82c1ed;\n  cursor: pointer;\n  &:hover {\n    color: #00cf71;\n    border-color: #00cf71;\n  }\n"
    ]);
    CompetitionProcess_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject3() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  padding: 6px 10px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  color: #82c1ed;\n  border: 1px solid #82c1ed;\n  &:hover {\n    color: #00cf71;\n    border-color: #00cf71;\n  }\n"
    ]);
    CompetitionProcess_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject4() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  //overflow: hidden;\n  //padding-bottom: 8px;\n"
    ]);
    CompetitionProcess_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject5() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        ""
    ]);
    CompetitionProcess_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject6() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  /* M5 */\n  background: #282a36;\n  border: 1px solid rgba(237, 237, 237, 0.2);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  padding: 34px 40px 24px 40px;\n  a {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 28px;\n    /* identical to box height, or 175% */\n    color: #82c1ed;\n  }\n"
    ]);
    CompetitionProcess_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject7() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        ""
    ]);
    CompetitionProcess_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject8() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 20px;\n  a:hover {\n    color: #00cf71;\n  }\n"
    ]);
    CompetitionProcess_index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject9() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 42px;\n  /* identical to box height, or 150% */\n  letter-spacing: 0.2em;\n  color: ",
        ";\n"
    ]);
    CompetitionProcess_index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject10() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 6px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 28px;\n  /* identical to box height */\n  color: #82c1ed;\n"
    ]);
    CompetitionProcess_index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject11() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  //display: flex;\n  //align-items: flex-start;\n  svg {\n    position: relative;\n    top: 4px;\n    margin-right: 8px;\n  }\n  margin-top: 12px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* or 175% */\n  /* M1 */\n  color: #ffffff;\n"
    ]);
    CompetitionProcess_index_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function CompetitionProcess_index_styled_templateObject12() {
    var data = CompetitionProcess_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 24px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* or 175% */\n  /* F3 */\n  color: #999999;\n"
    ]);
    CompetitionProcess_index_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var index_styled_button = function() {
    return css(CompetitionProcess_index_styled_templateObject());
};
var ButtonPrimary = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(CompetitionProcess_index_styled_templateObject1(), mixins/* transition */.eR());
var ButtonDiv = styled_components_browser_esm/* default.div */.ZP.div(CompetitionProcess_index_styled_templateObject2(), mixins/* transition */.eR());
var Button = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(CompetitionProcess_index_styled_templateObject3(), mixins/* transition */.eR());
var CompetitionProcess_index_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: [
        32,
        32
    ]
})(CompetitionProcess_index_styled_templateObject4());
var index_styled_Column = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    md: 8,
    sm: 12,
    xs: 24
})(CompetitionProcess_index_styled_templateObject5());
var index_styled_Item = styled_components_browser_esm/* default.div */.ZP.div(CompetitionProcess_index_styled_templateObject6(), mixins/* transition */.eR());
var Start = styled_components_browser_esm/* default.div */.ZP.div(CompetitionProcess_index_styled_templateObject7());
var End = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z).attrs({
    size: [
        40,
        40
    ]
})(CompetitionProcess_index_styled_templateObject8());
var Step = styled_components_browser_esm/* default.div */.ZP.div(CompetitionProcess_index_styled_templateObject9(), function(param) {
    var $active = param.$active;
    return $active ? "#82C1ED" : "rgba(255, 255, 255, 0.2)";
});
var Title = styled_components_browser_esm/* default.div */.ZP.div(CompetitionProcess_index_styled_templateObject10());
var index_styled_Date = styled_components_browser_esm/* default.div */.ZP.div(CompetitionProcess_index_styled_templateObject11());
var Paragraph = styled_components_browser_esm/* default.div */.ZP.div(CompetitionProcess_index_styled_templateObject12());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/CompetitionProcess/date.svg
var date_path, date_path2;
function date_extends() { date_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return date_extends.apply(this, arguments); }

var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/react.createElement("svg", date_extends({
    width: 19,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), date_path || (date_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.75 2.5h-15a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75Zm-3-1.5v3m-9-3v3M1 7h16.5",
    stroke: "#999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), date_path2 || (date_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m12.625 10.75-4.378 4.125-2.372-2.25",
    stroke: "#999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var date = (SvgDate);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/CompetitionProcess/index.tsx
function CompetitionProcess_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CompetitionProcess_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CompetitionProcess_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CompetitionProcess_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = CompetitionProcess_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CompetitionProcess_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var CompetitionProcess_CompetitionProcess = function(props) {
    //function SectionTitle(props: IProps) {
    var children = props.children, rest = CompetitionProcess_objectWithoutProperties(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompetitionProcess_index_styled_Container, CompetitionProcess_objectSpread({}, rest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Start, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                    $active: true,
                                    children: "STEP 1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: "\u62A5\u540D"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Date, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(date, {}),
                                        " \u5373\u65E5\u8D77 - 10 \u6708 17 \u65E5"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                                    children: [
                                        "\u53EA\u8981\u4F60\u5BF9\u67D0\u4E2A\u8D5B\u9053\u611F\u5174\u8DA3\uFF0C\u70ED\u7231\u521B\u9020\u3001\u52C7\u4E8E\u63A2\u7D22\uFF0C\u90FD\u53EF\u4EE5\u62A5\u540D\u53C2\u52A0\uFF0C\u70B9\u51FB",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                            href: guideUrl,
                                            children: "\u53C2\u8D5B\u6307\u5357"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(End, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    href: signUpFormUrl,
                                    children: "\u7ACB\u5373\u62A5\u540D"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPrimary, {
                                    href: joinGroupFormUrl,
                                    children: "\u5B8C\u6210\u7EC4\u961F"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Start, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                    $active: true,
                                    children: "PLUS \u73AF\u8282"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: "\u975E\u6B63\u5F0F\u4F1A\u8C08 \u2014\u2014 \u521B\u610F\u8111\u66B4\u4F1A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Date, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(date, {}),
                                        " \u65E5\u671F\uFF1A9 \u6708 17 \u65E5 10:30-12:00\uFF08GTM+8\uFF09"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    children: "\u7279\u9080\u4E1C\u65ED\u4EE5\u53CA\u8D44\u6DF1\u67B6\u6784\u5E08\u4EEC\u5728\u7EBF\u8111\u66B4\uFF0C\u8D85\u591A\u521B\u610F idea\uFF0C\u7ED9\u4F60\u8D85\u4E30\u5BCC\u9879\u76EE\u7075\u611F"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Date, {
                                    style: {
                                        marginTop: 34,
                                        marginBottom: 0
                                    },
                                    children: "\u8D21\u732E\u9879\u76EE\u521B\u610F\uFF1A9 \u6708 17 \u65E5 - 9 \u6708 28 \u65E5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    style: {
                                        marginTop: 12
                                    },
                                    children: "\u5982\u679C\u4F60\u6709\u4E00\u4E9B\u5B9E\u73B0\u7075\u611F\uFF0C\u65E0\u9700\u62A5\u540D\uFF0C\u4E5F\u975E\u5E38\u6B22\u8FCE\u5206\u4EAB\u5929\u9A6C\u884C\u7A7A\u7684\u521B\u610F"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(End, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    href: replayUrl,
                                    children: "\u5BFB\u627E idea"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    href: ideaUrl,
                                    children: "\u9879\u76EE\u516C\u793A"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Start, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                    $active: true,
                                    children: "STEP 2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: "\u63D0\u4EA4\u9879\u76EE RFC"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Date, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(date, {}),
                                        " \u62A5\u540D\u540E - 10 \u6708 17 \u65E5"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                                    children: [
                                        "\u63D0\u4EA4\u56E2\u961F\u9879\u76EE\u60F3\u6CD5\u4EE5\u53CA\u5177\u4F53\u5B9E\u73B0\u65B9\u6848\uFF0C\u8FD9\u5C06\u662F\u4F60\u901A\u5F80\u51B3\u8D5B\u7684\u5165\u573A\u5238\uFF0C\u70B9\u51FB\u67E5\u770B",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                            href: RfcTemplateUrl,
                                            children: "RFC \u6A21\u677F"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(End, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                href: RfcSubmitFormUrl,
                                children: "\u63D0\u4EA4 RFC"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Start, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                $active: false,
                                children: "STEP 3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "\u521D\u8D5B\u7ED3\u679C\u516C\u793A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Date, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(date, {}),
                                    " \u65E5\u671F\uFF1A10 \u6708 19 \u65E5"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                children: "\u516C\u5E03\u5165\u56F4\u51B3\u8D5B\u540D\u5355\uFF0C\u5404\u8D5B\u9053\u524D 30 \u7EC4\u8FDB\u5165\u51B3\u8D5B"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Start, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                $active: false,
                                children: "STEP 4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "\u51B3\u8D5B\u73B0\u573A Coding"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Date, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(date, {}),
                                    " \u65E5\u671F\uFF1A10 \u6708 22 \u65E5 - 10 \u6708 23 \u65E5"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                children: "\u73B0\u573A coding\uFF0C\u5B9E\u73B0\u4F60\u7684\u521B\u610F\u60F3\u6CD5\u3002\u5317\u4EAC\u3001\u4E0A\u6D77\u3001\u5E7F\u5DDE\u3001\u6210\u90FD\u3001\u65B0\u52A0\u5761\u4EFB\u9009\u4E00\u5904\u51B3\u8D5B\u53C2\u8D5B\u70B9\uFF0C\u8FD8\u53EF\u4EE5\u8D70\u8FDB PingCAP Office \u611F\u53D7 P \u793E\u6587\u5316"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                                children: [
                                    "\u672C\u6B21\u6D3B\u52A8\u4E0D\u5141\u8BB8\u5077\u8DD1\u54DF\uFF0C\u8BE6\u89C1",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                        href: scoreRule,
                                        children: "\u8BC4\u5206\u89C4\u5219"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Start, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                    $active: false,
                                    children: "STEP 5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: "\u51B3\u8D5B\u7B54\u8FA9+\u9881\u5956"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Date, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(date, {}),
                                        " \u65E5\u671F\uFF1A10 \u6708 23 \u65E5"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    children: "\u51B3\u8D5B\u73B0\u573A\u5982\u706B\u5982\u837C\uFF0C20+ \u5956\u9879\u7B49\u4F60\u62FF\uFF01"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(End, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                href: pptTemplateUrl,
                                children: "\u4E0B\u8F7D\u7B54\u8FA9 PPT \u6A21\u677F"
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var hackathon2022_CompetitionProcess = (CompetitionProcess_CompetitionProcess);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Prize/normal.png
/* harmony default export */ var normal = ({"src":"https://img1.tidb.net/_next/static/media/normal.2d339abc.png","height":566,"width":520,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAPFBMVEUoK3AYGTQXGDEdIEgkJ2MnK20iJVtCQ2wgIlUcHkcODiAYGTUqLoNLTXIrMIU8PWIYGTcpLoMpLoIkJ2NJhLxwAAAAEXRSTlP+tUXX/c/S6v79BazXzs3F/mUBmDsAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA1SURBVAiZFcEJEoAgDATB4UhU8CDk/3+1tpvnkI9774h4McTw7NnT8FOcdkmjLJmMWtas4wdA/gH+BG4ndgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Prize/gold.png
/* harmony default export */ var gold = ({"src":"https://img1.tidb.net/_next/static/media/gold.567ae529.png","height":675,"width":520,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAARVBMVEVxa5W3nUl9ailXTQ+WhU2fiULbr0yLdS7EpkKgiDleVh9hY7lHSZuBbSqNdzCOfUedhTeqkT3FpkN8aimymESwjDHOoDpNVUo8AAAAE3RSTlMB/boh7sHL/f3+MJR5jsrm8PLBCkKJHwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADRJREFUCJkVwYkRgCAMAMFDEiAK8tt/qQ67qIhIZaQDXc6tjpqZNd54UOb+5gU+hBsgP/ADLw0Bmd8k/rgAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Prize/sliver.png
/* harmony default export */ var sliver = ({"src":"https://img1.tidb.net/_next/static/media/sliver.bcf550b5.png","height":675,"width":520,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAOVBMVEWBgYBgYGBjY2OXl6KFhYaVlZWNjY1naadtbW2BgYFRUVBhZLhEQz1GSZpubm6hoaGgoKBhYWF1dXRewnY/AAAAEHRSTlP9wInUvf78Af7tMpQfecO6BZyAHwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADBJREFUCJkdwQESgCAMBLFVWk4QxPr/xzolwVpivQmr7l4xtudKnPERBxpWupDmLf0rzAGAPaXXtwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Prize/bronze.png
/* harmony default export */ var bronze = ({"src":"https://img1.tidb.net/_next/static/media/bronze.a78aec76.png","height":675,"width":520,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAQlBMVEWMbjx0WCmGclOPcD+jg06YeEVlSyJMaXGriE53WiuMd1drTyOPckevlHJcX7E/RJtwVCeBbk+KeFusiE+JcUt8Xy+lJo8mAAAAFnRSTlP8wu3A/vsrAP3+7/6u4q5VjuXBwe3+piRisgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADZJREFUCJkdwYkRwCAIBMATwRPymOjQf6tOsosZIfJi9Q+qqaqh4lfS3RPPkeYFbOfVCHLc5AYpEgGE3SwinQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Prize/index.styled.ts
function Prize_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Prize_index_styled_templateObject() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    Prize_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject1() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  text-align: center;\n  /* F3 */\n  color: #999999;\n"
    ]);
    Prize_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject2() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 78px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  /* identical to box height */\n  text-align: center;\n  letter-spacing: 0.2em;\n  color: #ffffff;\n"
    ]);
    Prize_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject3() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 24px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  text-align: center;\n  /* F3 */\n  color: #999999;\n"
    ]);
    Prize_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject4() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 74px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  text-align: center;\n  /* F3 */\n  color: #999999;\n"
    ]);
    Prize_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject5() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 56px;\n  width: 100%;\n"
    ]);
    Prize_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject6() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    Prize_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject7() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  background-image: url(",
        ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 252px;\n  height: 272px;\n  text-align: center;\n  padding-top: 44px;\n  padding-left: 24px;\n  padding-right: 24px;\n"
    ]);
    Prize_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject8() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  height: 22px;\n  text-align: center;\n  letter-spacing: 0.2em;\n  color: #ffffff;\n"
    ]);
    Prize_index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject9() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 48px;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 34px;\n  height: 34px;\n  /* identical to box height */\n  text-align: center;\n  color: #ffffff;\n"
    ]);
    Prize_index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject10() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 32px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  height: 22px;\n  color: #ffffff;\n"
    ]);
    Prize_index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject11() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  background-image: url(",
        ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 252px;\n  height: 334px;\n  text-align: center;\n  padding-top: 44px;\n  padding-left: 24px;\n  padding-right: 24px;\n"
    ]);
    Prize_index_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject12() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  background-image: url(",
        ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 252px;\n  height: 334px;\n  text-align: center;\n  padding-top: 44px;\n  padding-left: 24px;\n  padding-right: 24px;\n"
    ]);
    Prize_index_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject13() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  background-image: url(",
        ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 252px;\n  height: 334px;\n  text-align: center;\n  padding-top: 44px;\n  padding-left: 24px;\n  padding-right: 24px;\n"
    ]);
    Prize_index_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject14() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 24px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  text-align: center;\n  /* F3 */\n  color: #999999;\n"
    ]);
    Prize_index_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject15() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: left;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  /* F3 */\n  color: #999999;\n"
    ]);
    Prize_index_styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject16() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 26px;\n"
    ]);
    Prize_index_styled_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject17() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        ""
    ]);
    Prize_index_styled_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject18() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  width: 160px;\n  height: 80px;\n  background-color: #fff;\n"
    ]);
    Prize_index_styled_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function Prize_index_styled_templateObject19() {
    var data = Prize_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 74px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  text-align: center;\n  /* F3 */\n  color: #999999;\n  a,\n  a:hover {\n    color: #888dff;\n    text-decoration: underline;\n  }\n"
    ]);
    Prize_index_styled_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}






var Prize_index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject());
var index_styled_Description = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject1());
var SpecialPrizeTitle = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject2());
var SpecialPrizeTitleFirst = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject3());
var SpecialPrizeTitleSecond = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject4());
var SpecialPrizeList = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: [
        16,
        16
    ],
    justify: "space-between"
})(Prize_index_styled_templateObject5());
var SpecialPrizeTopListColumn = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    lg: 6,
    md: 12,
    sm: 12,
    xs: 24
})(Prize_index_styled_templateObject6());
var SpecialPrizeTopListColumnItem = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject7(), normal.src);
var SpecialPrizeTopListColumnItemName = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject8());
var SpecialPrizeTopListColumnItemThing = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject9());
var SpecialPrizeTopListColumnItemTarget = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject10());
var SpecialPrizeTopListItemGold = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject11(), gold.src);
var SpecialPrizeTopListItemSliver = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject12(), sliver.src);
var SpecialPrizeTopListItemBronze = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject13(), bronze.src);
var SpecialPrizeDescription = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject14());
var index_styled_Title = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject15());
var List = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: [
        64,
        64
    ]
})(Prize_index_styled_templateObject16());
var Prize_index_styled_Column = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    md: 4,
    sm: 8,
    xs: 12
})(Prize_index_styled_templateObject17());
var Prize_index_styled_Item = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject18());
var Footer = styled_components_browser_esm/* default.div */.ZP.div(Prize_index_styled_templateObject19());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Prize/index.tsx
function Prize_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Prize_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Prize_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Prize_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Prize_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Prize_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Prize_Prize = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = Prize_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Prize_index_styled_Container, Prize_objectSpread({}, rest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Description, {
                children: data.topPrize.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialPrizeList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialPrizeTopListItemGold, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemName, {
                                    children: data.topPrize.items[0].name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemThing, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemTarget, {
                                    style: {
                                        marginTop: 8
                                    },
                                    children: data.topPrize.items[0].target
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialPrizeTopListItemSliver, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemName, {
                                    children: data.topPrize.items[1].name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemThing, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemTarget, {
                                    style: {
                                        marginTop: 8
                                    },
                                    children: data.topPrize.items[1].target
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialPrizeTopListItemBronze, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemName, {
                                    children: data.topPrize.items[2].name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemThing, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemTarget, {
                                    style: {
                                        marginTop: 8
                                    },
                                    children: data.topPrize.items[2].target
                                })
                            ]
                        })
                    })
                ]
            }),
            data.prizes.map(function(prize, index1) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTitle, {
                            children: prize.name
                        }),
                        prize.categories.map(function(category, index2) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    category.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTitleSecond, {
                                        children: category.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeList, {
                                        children: category.items.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumn, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialPrizeTopListColumnItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemName, {
                                                            children: item.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemThing, {
                                                            children: item.thing
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPrizeTopListColumnItemTarget, {
                                                            children: item.target
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            }, index2);
                        })
                    ]
                }, index1);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                children: data.footer
            })
        ]
    }));
};
/* harmony default export */ var hackathon2022_Prize = (Prize_Prize);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ParticipationWelfare/index.styled.ts
function ParticipationWelfare_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ParticipationWelfare_index_styled_templateObject() {
    var data = ParticipationWelfare_index_styled_taggedTemplateLiteral([
        ""
    ]);
    ParticipationWelfare_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ParticipationWelfare_index_styled_templateObject1() {
    var data = ParticipationWelfare_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n"
    ]);
    ParticipationWelfare_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ParticipationWelfare_index_styled_templateObject2() {
    var data = ParticipationWelfare_index_styled_taggedTemplateLiteral([
        "\n  margin-right: 42px;\n  //img,\n  //svg {\n  //  width: ",
        ";\n  //  height: ",
        ";\n  //}\n"
    ]);
    ParticipationWelfare_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ParticipationWelfare_index_styled_templateObject3() {
    var data = ParticipationWelfare_index_styled_taggedTemplateLiteral([
        "\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n  /* identical to box height */\n  color: #ffffff;\n"
    ]);
    ParticipationWelfare_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ParticipationWelfare_index_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    justify: "space-between",
    gutter: [
        24,
        48
    ]
})(ParticipationWelfare_index_styled_templateObject());
var ParticipationWelfare_index_styled_Item = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    lg: 8,
    md: 12,
    sm: 24
})(ParticipationWelfare_index_styled_templateObject1());
var index_styled_iconSize = "52px";
var index_styled_Icon = styled_components_browser_esm/* default.div */.ZP.div(ParticipationWelfare_index_styled_templateObject2(), index_styled_iconSize, index_styled_iconSize);
var index_styled_Text = styled_components_browser_esm/* default.div */.ZP.div(ParticipationWelfare_index_styled_templateObject3());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/ParticipationWelfare/index.tsx
function ParticipationWelfare_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ParticipationWelfare_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ParticipationWelfare_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ParticipationWelfare_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ParticipationWelfare_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ParticipationWelfare_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ParticipationWelfare_ParticipationWelfare = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = ParticipationWelfare_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipationWelfare_index_styled_Container, ParticipationWelfare_objectSpread({}, rest, {
        children: data.map(function(value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ParticipationWelfare_index_styled_Item, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Icon, {
                        children: value.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Text, {
                        children: value.text
                    })
                ]
            }, value.text);
        })
    }));
};
/* harmony default export */ var hackathon2022_ParticipationWelfare = (ParticipationWelfare_ParticipationWelfare);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/index.styled.ts
function Judge_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Judge_index_styled_templateObject() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        ""
    ]);
    Judge_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject1() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        ""
    ]);
    Judge_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject2() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  overflow: auto;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  //justify-content: center;\n  align-items: center;\n  text-align: center;\n  max-width: 304px;\n  height: 100%;\n  min-height: 402px;\n  margin: 0 auto;\n  padding: 50px 24px 24px 28px;\n  /* M5 */\n  background: #282a36;\n  border: 1px solid rgba(0, 207, 113, 0.5);\n"
    ]);
    Judge_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject3() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  //justify-content: center;\n  align-items: center;\n  text-align: center;\n"
    ]);
    Judge_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject4() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  img,\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    Judge_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject5() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-top: 44px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 27px;\n  /* identical to box height, or 150% */\n  text-align: center;\n  /* M1 */\n  color: #ffffff;\n"
    ]);
    Judge_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject6() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-top: 8px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 32px;\n  /* identical to box height, or 200% */\n  letter-spacing: 0.1em;\n  /* M1 */\n  color: #ffffff;\n"
    ]);
    Judge_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject7() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  //",
        ";\n  position: absolute;\n  //top: 0;\n  //left: 0;\n  //max-width: 304px;\n  //padding: 60px 38px;\n  padding: 0 32px;\n  padding-bottom: 32px;\n  text-align: left;\n  //width: 100%;\n  overflow: auto;\n"
    ]);
    Judge_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject8() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 27px;\n  /* identical to box height, or 150% */\n  /* M1 */\n  color: #ffffff;\n"
    ]);
    Judge_index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject9() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  padding-top: 8px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 32px;\n  /* identical to box height, or 200% */\n  letter-spacing: 0.1em;\n  /* M1 */\n  color: #ffffff;\n"
    ]);
    Judge_index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Judge_index_styled_templateObject10() {
    var data = Judge_index_styled_taggedTemplateLiteral([
        "\n  //margin-top: 48px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* or 175% */\n  color: #ffffff;\n"
    ]);
    Judge_index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var Judge_index_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: [
        32,
        32
    ]
})(Judge_index_styled_templateObject());
var Judge_index_styled_Column = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    lg: 6,
    md: 8,
    sm: 12,
    xs: 24
})(Judge_index_styled_templateObject1());
var Judge_index_styled_Item = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject2(), mixins/* transition */.eR());
var Profile = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject3());
var avatarSize = "150px";
var Avatar = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject4(), mixins/* transition */.eR(), avatarSize, avatarSize);
var index_styled_Name = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject5(), mixins/* transition */.eR());
var Judge_index_styled_Title = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject6(), mixins/* transition */.eR());
var OverLayer = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject7(), mixins/* transition */.eR());
var OverLayerName = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject8());
var OverLayerTitle = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject9());
var OverLayerQuotation = styled_components_browser_esm/* default.div */.ZP.div(Judge_index_styled_templateObject10());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Judge/index.tsx
function Judge_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Judge_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Judge_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Judge_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Judge_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Judge_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Judge_Judge = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = Judge_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Judge_index_styled_Container, Judge_objectSpread({}, rest, {
        children: data.map(function(value, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Judge_index_styled_Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JudgeItem, {
                    value: value
                })
            }, index);
        })
    }));
};
/* harmony default export */ var hackathon2022_Judge = (Judge_Judge);
function JudgeItem(param) {
    var value = param.value;
    var ref = (0,react.useState)(false), showOverLayer = ref[0], setShowOverLayer = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Judge_index_styled_Item, {
        onMouseOver: function() {
            return setShowOverLayer(true);
        },
        onMouseOut: function() {
            return setShowOverLayer(false);
        },
        children: showOverLayer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverLayer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OverLayerName, {
                    children: value.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OverLayerTitle, {
                    children: value.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OverLayerQuotation, {
                    children: value.quotation
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Profile, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), Judge_objectSpread({}, value.avatar, {
                        alt: value.name
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Name, {
                    children: value.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Judge_index_styled_Title, {
                    children: value.title
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/FAQ/index.styled.ts
function FAQ_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FAQ_index_styled_templateObject() {
    var data = FAQ_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    FAQ_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FAQ_index_styled_templateObject1() {
    var data = FAQ_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    FAQ_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FAQ_index_styled_templateObject2() {
    var data = FAQ_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  border-bottom: 1px dashed #82c1ed;\n"
    ]);
    FAQ_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FAQ_index_styled_templateObject3() {
    var data = FAQ_index_styled_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    FAQ_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FAQ_index_styled_templateObject4() {
    var data = FAQ_index_styled_taggedTemplateLiteral([
        "\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #ffffff;\n"
    ]);
    FAQ_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FAQ_index_styled_templateObject5() {
    var data = FAQ_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ",
        ";\n  height: ",
        ";\n  color: #82c1ed;\n  border: 1px solid #82c1ed;\n  padding: 8px;\n  border-radius: ",
        ";\n"
    ]);
    FAQ_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FAQ_index_styled_templateObject6() {
    var data = FAQ_index_styled_taggedTemplateLiteral([
        "\n  //",
        ";\n  width: 100%;\n  display: ",
        ";\n  box-sizing: content-box;\n  overflow: hidden;\n  padding-top: 14px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  //line-height: 22px;\n  /* F3 */\n  color: #999999;\n  ul {\n    margin-bottom: 0;\n  }\n  a,\n  a:hover {\n    color: #82c1ed;\n  }\n"
    ]);
    FAQ_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function FAQ_index_styled_templateObject7() {
    var data = FAQ_index_styled_taggedTemplateLiteral([
        "\n  text-align: center;\n  margin-top: 80px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  /* F3 */\n  color: #999999;\n  a,\n  a:hover {\n    color: #82c1ed;\n  }\n"
    ]);
    FAQ_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var FAQ_index_styled_Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({})(FAQ_index_styled_templateObject());
var index_styled_List = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({})(FAQ_index_styled_templateObject1());
var FAQ_index_styled_Item = styled_components_browser_esm/* default.div */.ZP.div(FAQ_index_styled_templateObject2(), mixins/* transition */.eR());
var index_styled_Header = styled_components_browser_esm/* default.div */.ZP.div(FAQ_index_styled_templateObject3());
var Question = styled_components_browser_esm/* default.div */.ZP.div(FAQ_index_styled_templateObject4());
var buttonSize = "28px";
var index_styled_Button = styled_components_browser_esm/* default.div */.ZP.div(FAQ_index_styled_templateObject5(), buttonSize, buttonSize, buttonSize);
var Body = styled_components_browser_esm/* default.div */.ZP.div(FAQ_index_styled_templateObject6(), mixins/* transition */.eR(undefined, "500ms", "linear"), function(param) {
    var $show = param.$show;
    return $show ? "block" : "none";
});
var FAQ_index_styled_Description = styled_components_browser_esm/* default.div */.ZP.div(FAQ_index_styled_templateObject7());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/FAQ/index.tsx
function FAQ_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FAQ_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FAQ_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FAQ_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = FAQ_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function FAQ_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var FAQ_FAQ = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = FAQ_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FAQ_index_styled_Container, FAQ_objectSpread({}, rest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_List, {
                children: data.items.map(function(value) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ_Item, {
                        value: value
                    }, value.question);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ_index_styled_Description, {
                children: data.footer
            })
        ]
    }));
};
/* harmony default export */ var hackathon2022_FAQ = (FAQ_FAQ);
function FAQ_Item(param) {
    var value1 = param.value;
    var ref = (0,react.useState)(false), showAnswer = ref[0], setShowAnswer = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FAQ_index_styled_Item, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Header, {
                onClick: function() {
                    return setShowAnswer(function(value) {
                        return !value;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Question, {
                        children: value1.question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Button, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: showAnswer ? "-" : "+"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                $show: showAnswer,
                children: value1.answer
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/index.styled.ts
function Partner_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Partner_index_styled_templateObject() {
    var data = Partner_index_styled_taggedTemplateLiteral([
        ""
    ]);
    Partner_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Partner_index_styled_templateObject1() {
    var data = Partner_index_styled_taggedTemplateLiteral([
        ""
    ]);
    Partner_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Partner_index_styled_templateObject2() {
    var data = Partner_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: left;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height, or 175% */\n  /* F3 */\n  color: #999999;\n"
    ]);
    Partner_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Partner_index_styled_templateObject3() {
    var data = Partner_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 26px;\n"
    ]);
    Partner_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Partner_index_styled_templateObject4() {
    var data = Partner_index_styled_taggedTemplateLiteral([
        ""
    ]);
    Partner_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Partner_index_styled_templateObject5() {
    var data = Partner_index_styled_taggedTemplateLiteral([
        "\n  width: 160px;\n  height: 80px;\n  background-color: #fff;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    Partner_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Partner_index_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z).attrs({
    direction: "vertical",
    size: 74
})(Partner_index_styled_templateObject());
var Category = styled_components_browser_esm/* default.div */.ZP.div(Partner_index_styled_templateObject1());
var Partner_index_styled_Title = styled_components_browser_esm/* default.div */.ZP.div(Partner_index_styled_templateObject2());
var Partner_index_styled_List = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: [
        32,
        32
    ]
})(Partner_index_styled_templateObject3());
var Partner_index_styled_Column = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    md: 4,
    sm: 8,
    xs: 12
})(Partner_index_styled_templateObject4());
var Partner_index_styled_Item = styled_components_browser_esm/* default.div */.ZP.div(Partner_index_styled_templateObject5());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/Partner/index.tsx
function Partner_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Partner_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Partner_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Partner_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Partner_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Partner_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Partner_Partner = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = Partner_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner_index_styled_Container, Partner_objectSpread({}, rest, {
        children: data.map(function(value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner_Category, {
                value: value
            }, value.name);
        })
    }));
};
/* harmony default export */ var hackathon2022_Partner = (Partner_Partner);
function Partner_Category(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Category, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner_index_styled_Title, {
                children: value.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner_index_styled_List, {
                children: value.items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner_index_styled_Column, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner_index_styled_Item, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), Partner_objectSpread({}, item.image, {
                                alt: ""
                            }))
                        })
                    }, item.image.src);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/PastReview/index.styled.ts
function PastReview_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PastReview_index_styled_templateObject() {
    var data = PastReview_index_styled_taggedTemplateLiteral([
        ""
    ]);
    PastReview_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PastReview_index_styled_templateObject1() {
    var data = PastReview_index_styled_taggedTemplateLiteral([
        ""
    ]);
    PastReview_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PastReview_index_styled_templateObject2() {
    var data = PastReview_index_styled_taggedTemplateLiteral([
        "\n  display: block;\n  //width: 300px;\n  //height: 200px;\n  img {\n    width: 100%;\n    height: 100%;\n    //width: 300px;\n    //height: 200px;\n  }\n  //background-color: #fff;\n"
    ]);
    PastReview_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var PastReview_index_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: [
        32,
        32
    ]
})(PastReview_index_styled_templateObject());
var PastReview_index_styled_Column = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    md: 6,
    sm: 12,
    xs: 24
})(PastReview_index_styled_templateObject1());
var PastReview_index_styled_Item = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(PastReview_index_styled_templateObject2());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/PastReview/TiDB_Hackathon_2021.jpg
/* harmony default export */ var TiDB_Hackathon_2021 = ({"src":"https://img1.tidb.net/_next/static/media/TiDB_Hackathon_2021.d8a4140b.jpg","height":400,"width":608,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAAABgMBAAAAAAAAAAAAAAAAAQIDBCEFERJh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAMAwEAAhEDEQA/AIecwmFicfNQfTkltXRKJNaqq9AAFEI5f//Z"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/PastReview/TiDB_Hackathon_2020.jpg
/* harmony default export */ var TiDB_Hackathon_2020 = ({"src":"https://img1.tidb.net/_next/static/media/TiDB_Hackathon_2020.650b8434.jpg","height":400,"width":608,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAACAwEAAAAAAAAAAAAAAAABEQACAwT/xAAVAQEBAAAAAAAAAAAAAAAAAAABA//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AJxt001FRXlyzQAJq2UE4iJQP//Z"});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/PastReview/TiDB_Hackathon_2019.jpg
/* harmony default export */ var TiDB_Hackathon_2019 = ({"src":"https://img1.tidb.net/_next/static/media/TiDB_Hackathon_2019.1a7fe0e9.jpg","height":400,"width":608,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAIDAQAAAAAAAAAAAAABAAIDEQVBITEyQv/EABQBAQAAAAAAAAAAAAAAAAAAAAX/xAAcEQACAQUBAAAAAAAAAAAAAAABAwIABBESIcH/2gAMAwEAAhEDEQA/ALWHzMTmwRHHwkNmPuncmzfV/I3pERGX9wxTtYHAx6aYghco7Edr/9k="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/PastReview/TiDB_Hackathon_2018.jpg
/* harmony default export */ var TiDB_Hackathon_2018 = ({"src":"https://img1.tidb.net/_next/static/media/TiDB_Hackathon_2018.ca9badc3.jpg","height":400,"width":608,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAeEAAABgIDAAAAAAAAAAAAAAAAAQIDBBEhMRIUFf/EABUBAQEAAAAAAAAAAAAAAAAAAAEF/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAEx/9oADAMBAAIRAxEAPwCfKmxW4Zw/OaN7XZNauVnm6utYAAFEXa//2Q=="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/PastReview/index.tsx
function PastReview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PastReview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PastReview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PastReview_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PastReview_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PastReview_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var data = [
    {
        name: "TiDB_Hackathon_2021",
        image: TiDB_Hackathon_2021,
        url: "https://pingkai.cn/tidbcommunity/events/hackathon2021"
    },
    {
        name: "TiDB_Hackathon_2020",
        image: TiDB_Hackathon_2020,
        url: "https://pingkai.cn/tidbcommunity/archived/events/hackathon2020"
    },
    {
        name: "TiDB_Hackathon_2019",
        image: TiDB_Hackathon_2019,
        url: "https://pingkai.cn/tidbcommunity/archived/events/hackathon2019"
    },
    {
        name: "TiDB_Hackathon_2018",
        image: TiDB_Hackathon_2018,
        url: "https://pingkai.cn/tidbcommunity/archived/events/hackathon2018"
    }, 
];
var PastReview_PastReview = function(props) {
    //function SectionTitle(props: IProps) {
    var children = props.children, rest = PastReview_objectWithoutProperties(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PastReview_index_styled_Container, PastReview_objectSpread({}, rest, {
        children: data.map(function(value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PastReview_index_styled_Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PastReview_index_styled_Item, {
                    href: value.url,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), PastReview_objectSpread({}, value.image, {
                        alt: value.name
                    }))
                })
            }, value.name);
        })
    }));
};
/* harmony default export */ var hackathon2022_PastReview = (PastReview_PastReview);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2022/index.page.tsx




























//import SideBar from './SideBar';
var description = "\u672C\u5C4A\u5927\u8D5B\u4E3B\u9898\u4E3A\u300CPossibility at Scale\u300D\uFF0C\u89C4\u6A21\u521B\u5386\u53F2\u4E4B\u6700\uFF0C\u5171\u6709 303 \u540D\u9009\u624B\u62A5\u540D \uFF0C86 \u652F\u961F\u4F0D\u53C2\u8D5B\uFF0C\u6709\u6765\u81EA\u5FAE\u8F6F\u3001\u8682\u8681\u96C6\u56E2\u3001\u5B57\u8282\u8DF3\u52A8\u3001\u7F51\u6613\u6709\u9053\u3001\u6D6A\u6F6E\u3001\u660E\u671D\u4E07\u8FBE\u3001B \u7AD9\u3001\u601D\u79D1\u3001\u592A\u6781\u56FE\u5F62\u7B49\u4F01\u4E1A\u7684\u9009\u624B\uFF0C\u4E5F\u6709\u6765\u81EA\u6E05\u534E\u5927\u5B66\u3001\u5317\u4EAC\u90AE\u7535\u5927\u5B66\u3001\u534E\u4E1C\u5E08\u8303\u5927\u5B66\u3001\u6D59\u6C5F\u7406\u5DE5\u5927\u5B66\u3001\u65B0\u52A0\u5761\u56FD\u7ACB\u5927\u5B66\u7B49\u9AD8\u6821\u7684\u5B66\u751F\u3002\u9009\u624B\u4EEC\u56F4\u7ED5\u7740 TiDB \u4EA7\u54C1\u7EC4\u548C\u5E94\u7528\u7EC4\u4E24\u5927\u8D5B\u9053\uFF0C\u5C55\u5F00\u4E86\u4E00\u573A\u6280\u672F\u7684\u6BD4\u62FC\u548C\u521B\u610F\u7684\u78B0\u649E\u3002";
var seo = {
    title: "TiDB Hackathon 2022",
    description: description,
    keywords: [
        "\u9ED1\u5BA2\u9A6C\u62C9\u677E",
        "TiDB",
        "Hackathon"
    ]
};
var Hackathon2022 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: seo.title,
                description: seo.description,
                keyword: seo.keywords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_Header, {
                        data: dataHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro, {
                        id: "intro",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_icon_cube_orange, {}),
                                children: "\u5927\u8D5B\u56DE\u987E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "\u672C\u5C4A\u5927\u8D5B\u4E3B\u9898\u4E3A\u300CPossibility at Scale\u300D\uFF0C",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "\u89C4\u6A21\u521B\u5386\u53F2\u4E4B\u6700\uFF0C\u5171\u6709 303 \u540D\u9009\u624B\u62A5\u540D \uFF0C86 \u652F\u961F\u4F0D\u53C2\u8D5B\uFF0C\u6709\u6765\u81EA\u5FAE\u8F6F\u3001\u8682\u8681\u96C6\u56E2\u3001\u5B57\u8282\u8DF3\u52A8\u3001\u7F51\u6613\u6709\u9053\u3001\u6D6A\u6F6E\u3001\u660E\u671D\u4E07\u8FBE\u3001B \u7AD9\u3001\u601D\u79D1\u3001\u592A\u6781\u56FE\u5F62\u7B49\u4F01\u4E1A\u7684\u9009\u624B"
                                            }),
                                            "\uFF0C\u4E5F\u6709\u6765\u81EA\u6E05\u534E\u5927\u5B66\u3001\u5317\u4EAC\u90AE\u7535\u5927\u5B66\u3001\u534E\u4E1C\u5E08\u8303\u5927\u5B66\u3001\u6D59\u6C5F\u7406\u5DE5\u5927\u5B66\u3001\u65B0\u52A0\u5761\u56FD\u7ACB\u5927\u5B66\u7B49\u9AD8\u6821\u7684\u5B66\u751F\u3002\u9009\u624B\u4EEC\u56F4\u7ED5\u7740 TiDB \u4EA7\u54C1\u7EC4\u548C\u5E94\u7528\u7EC4\u4E24\u5927\u8D5B\u9053\uFF0C\u5C55\u5F00\u4E86\u4E00\u573A\u6280\u672F\u7684\u6BD4\u62FC\u548C\u521B\u610F\u7684\u78B0\u649E\u3002"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Hackathon\uFF0C\u5373\u201C\u9ED1\u5BA2\u9A6C\u62C9\u677E\u201D\uFF0C\u662F\u7A0B\u5E8F\u5458\u975E\u5E38\u559C\u95FB\u4E50\u89C1\u7684\u8D5B\u4E8B\u6D3B\u52A8\u3002\u5B83\u6709\u7740\u81EA\u7531\u7684\u5F62\u5F0F\uFF1AHacker \u4EEC\u805A\u96C6\u5728\u4E00\u8D77\uFF0C\u7D27\u5BC6\u5408\u4F5C\uFF0C\u53D1\u6325\u521B\u610F\uFF0C\u6301\u7EED\u7F16\u7A0B\uFF0C\u5B9E\u73B0\u521B\u60F3\u3002\u7F16\u7A0B\u9A6C\u62C9\u677E\u7684\u7CBE\u9AD3\u5728\u4E8E\uFF1A",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "\u4E00\u7FA4\u5FD7\u540C\u9053\u5408\u7684\u4F19\u4F34\uFF0C\u5728\u7279\u5B9A\u7684\u65F6\u95F4\u5185\uFF0C\u76F8\u805A\u5728\u4E00\u8D77\uFF0C\u53BB\u505A\u4ED6\u4EEC\u60F3\u505A\u7684\u4E8B\u60C5"
                                            }),
                                            "\u2014\u2014\u6574\u4E2A\u7F16\u7A0B\u7684\u8FC7\u7A0B\u51E0\u4E4E\u6CA1\u6709\u4EFB\u4F55\u9650\u5236\u3002"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "\u5728\u4E24\u5929\u4E00\u591C\u7684 Hacking Time \u540E\uFF0C\u9009\u624B\u4EEC\u8FDB\u884C\u4E86\u7CBE\u5F69\u7684\u5C55\u793A\uFF0C\u5F00\u53D1\u8005\u4EEC\u5BF9 TiDB \u7684\u7406\u89E3\u548C\u4F7F\u7528\u8D8A\u6765\u8D8A\u7EAF\u719F\uFF0CHackathon \u7684\u8D28\u91CF\u4E5F\u5728\u4E0D\u65AD\u8FDB\u5316\u3002\u672C\u6B21",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "\u6709 16 \u652F\u961F\u4F0D\u74DC\u5206\u4E86\u603B\u8BA1 35 \u4E07\u5143\u7684\u5956\u91D1\uFF0C\u5176\u4E2D\u6709 10 \u652F\u961F\u4F0D\u5206\u83B7\u6700\u4F73\u521B\u610F\u5956\u3001\u516C\u76CA\u8D21\u732E\u5956\u3001\u6280\u672F\u8D8B\u52BF\u5956\u3001Cloud \u5E94\u7528\u751F\u6001\u5956\u3001\u6700\u4F73\u4EBA\u6C14\u5956\u3001\u6700\u4F73\u6821\u56ED\u5956\u3001\u7528\u6237\u4E4B\u9009\u5956\u3002"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            backgroundImage: "url(".concat(background_corner_skyblue.src, ")"),
                            backgroundRepeat: "no-repeat"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeRace, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        children: "\u4E3B\u9898\u8D5B\u9053"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeRaceBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_ThemeRace, {
                                            data: dataThemeRace
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WinnerTeam, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_winner_icon, {}),
                                        children: "\u83B7\u5956\u56E2\u961F"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WinnerTeamBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_WinnerTeam, {
                                            data: dataWinnerTeam
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinalistTeam, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_winner_icon, {}),
                                        children: "\u5165\u56F4\u9879\u76EE"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalistTeamBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_FinalistTeam, {
                                            data: dataFinalist
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompetitionProcess, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_icon_corner_skyblue, {}),
                                        children: "\u53C2\u8D5B\u6D41\u7A0B"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompetitionProcessBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_CompetitionProcess, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            backgroundImage: "url(".concat(background_corner_green.src, ")"),
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "right"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Prize, {
                                id: "prize",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_icon_cloud_deepblue, {}),
                                        children: "\u5927\u8D5B\u5956\u9879"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizeBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_Prize, {
                                            data: dataPrize
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ParticipationWelfare, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        children: "\u5176\u4ED6\u53C2\u8D5B\u798F\u5229"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipationWelfareBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_ParticipationWelfare, {
                                            data: dataParticipationWelfare
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            backgroundImage: "url(".concat(background_corner_blue.src, ")"),
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "left"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Judge, {
                                id: "judges",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_icon_corner_green, {}),
                                        children: "\u8BC4\u59D4\u5BFC\u5E08\u9635\u5BB9"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JudgeDescription, {
                                        children: "\u6309\u59D3\u540D\u5B57\u6BCD\u6392\u5E8F"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JudgeBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_Judge, {
                                            data: dataJudge
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FAQ, {
                                id: "faq",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_icon_cube_skyblue, {}),
                                        children: "FAQ"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_FAQ, {
                                            data: dataFAQ
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            backgroundImage: "url(".concat(background_corner_skyblue_reverse.src, ")"),
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "right"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Partner, {
                                id: "partner",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_icon_cube_orange, {}),
                                        children: "\u8D5E\u52A9\u5546\u4E0E\u5408\u4F5C\u4F19\u4F34"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_Partner, {
                                            data: dataPartner
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PastReview, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_SectionTitle, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_icon_cube_skyblue, {}),
                                        children: "\u5F80\u671F\u56DE\u987E"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PastReviewBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hackathon2022_PastReview, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var index_page = (Hackathon2022);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(16051); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);